"use strict";

import * as THREE from "three";
import { OrbitControls } from "./OrbitControls.js";
import { DragControls } from "three/examples/jsm/controls/DragControls.js";
import { MathUtils } from "three";
import CSG from "./three-csg.js";
import fontFile from "../assets/helvetiker_regular.typeface.json";

import { textureMaple } from "./textures.js";
import { textureSideMaple } from "./textures.js";
import { textureWalnut } from "./textures.js";
import { textureSideWalnut } from "./textures.js";
import { textureCedar } from "./textures.js";
import { textureSideCedar } from "./textures.js";
import { textureOak } from "./textures.js";
import { textureSideOak } from "./textures.js";

//import {knifeModel} from './models.js';

export default function didScript() {
  var camera, scene, renderer, canvas;
  var drawer_insert, controls, dControls, sControls;

  const baseThickness = 0.00635; // 1/4" plywood
  const boardThickness = 0.009144; // 0.36", divider board thickness and base track thickness

  var minDivWidth = 0.05;

  //set the initial size of the drawer insert
  var insertWidth = 0.508;
  var insertDepth = 0.4064;
  var insertHeight = 0.0636;
  var divHeight = insertHeight - baseThickness;

  //set an initial area so the HTML has something to display at startup
  var baseArea = 0;
  var sideArea = 0;

  var originalColour;

  var textureInUse = undefined;
  var textureSideInUse = undefined;
  var textureInUseName = undefined;

  const lineMaterial = new THREE.LineBasicMaterial({ color: 0x0000ff });

  const radNinety = MathUtils.degToRad(90);

  var impSwitchOn = true;
  var vDimOn = true;
  var hDimOn = true;
  var bottomReqSwitchOn = true;

  var pauseUserDataUpdate = false;

  var hoverOnBoard = false;
  var hoverObject;

  var raycaster = new THREE.Raycaster();
  var mouse = new THREE.Vector2();

  // array of meshes that can be dragged
  var moveableObjects = [];
  var lastDivDragged = "";

  var fullVertDivGroup = [];
  var fullHorizDivGroup = [];
  var spanVertDivGroup = [];
  var spanHorizDivGroup = [];
  var hMeasurementGroup = new THREE.Group();
  var vMeasurementGroup = new THREE.Group();
  var outsideVertMeasGroup = new THREE.Group();
  var outsideHorizMeasGroup = new THREE.Group();
  var outsideHeightMeasGroup = new THREE.Group();

  var divsWithCutaway = [];

  const knifeblockBladeHeight = 0.043;
  const knifeblockHandleHeight = 0.03;
  const bladeSlotWidth = 0.003;
  const bladeSlotCurveSize = 0.002;
  const bladeSlotHeight = 0.025;
  const knifeblockLargeHandleHeight = 0.043;
  const knifeblockSlotSpacing = 0.03175; //1 1/4" includes flat space between the curves
  const knifeblockHandleSpaceBetweenCurves = 0.00635; //1/4"
  const knifeblockHandleCurveDepth = 0.018;
  const knifeblockHandleDistFromBottom = 0.04445; // 1.75"
  const knifeblockHandle2DistFromBottom = 0.123825; // 4 7/8"
  const knifeblockSmallBladeDistFromBottom = 0.1778; // 7"
  const knifeblockLargeBladeDistFromBottom = 0.26035; // 10.25"
  const minKnifeblockAreaWidth = 0.1016; // 4"
  const minKnifeblockAreaDepth = 0.168; // 7" minus board thickness
  const maxKnifeblockAreaDepth = 0.295; // 12" minus board thickness
  const minLargeKnifeblockAreaWidth = 0.1016; // 4"
  const minLargeKnifeblockAreaDepth = 0.295; // 12" minus board thickness
  var bottomAreas = [];
  var validBottomAreas = [];

  // parallel arrays for the divs making up the two different sized knifeblocks
  var knifeblockBladeGroup = [];
  var knifeblockHandleGroup = [];
  var knifeblockLargeBladeGroup = [];
  var knifeblockLargeHandleGroup = [];
  var knifeblockLargeHandle2Group = [];
  var hoverKnifeblockArea;
  var hoverSpicerackArea;

  const minSpicerackAreaWidth = 0.1;
  const maxSpicerackAreaWidth = 0.4064;
  const spicerackAreaDepth = 0.12065; // 4 3/4" fixed area depth for a spice race
  const spicerackInsertDepth = 0.1254125; // 4 5/16" fixed depth of spicerack insert
  const spicerackCurveDepth = .0127; // 1/2 inch curve depth, 1" curve opening
  const spiceJarWidth = 0.045; // 1.77"
  var spicerackInsertGroup = [];
  // array parallel to spicerackInsertGroup to store movabable divs that have been disabled
  // so they can be renabled if the spicerack is deleted.
  var spicerackDisabledMoveableObjects = [];

  var feltBottomMesh = false;
  var antislipBottomMesh = false;

  const drawerboxThickness = 0.0158; // 5/8"
  const drawerboxHeight = 0.1016; // 4" drawbox fixed height
  const drawerboxSpace = 0.003; // the drawer is 3mm or 1/8" larger on each side than the insert
  var dbSwitchOn = true;
  var dbBackMesh,dbFrontMesh,dbRightMesh,dbLeftMesh,dbBaseMesh;

  var divsToSpace = [];
  var divsToSpaceIsVertical;
  var checkValidMove = [];

  var history = [];
  var histPosition = 0;
  var justLoaded = false;

  //make functions available from the document root
  window.positionNewFullVert = positionNewFullVert;
  window.positionNewFullHoriz = positionNewFullHoriz;
  window.positionNewSpanVert = positionNewSpanVert;
  window.positionNewSpanHoriz = positionNewSpanHoriz;
  window.cancelPositionNewFullVert = cancelPositionNewFullVert;
  window.cancelPositionNewFullHoriz = cancelPositionNewFullHoriz;
  window.cancelPositionNewSpanHoriz = cancelPositionNewSpanHoriz;
  window.cancelPositionNewSpanVert = cancelPositionNewSpanVert;
  window.cancelDeleteDividerSelect = cancelDeleteDividerSelect;
  window.cancelAddCutawaySelect = cancelAddCutawaySelect;
  window.cancelRemoveCutawaySelect = cancelRemoveCutawaySelect;

  window.addKnifeblockSelect = addKnifeblockSelect;
  window.addLargeKnifeblockSelect = addLargeKnifeblockSelect;
  window.removeKnifeblockSelect = removeKnifeblockSelect;
  window.cancelAddKnifeblockSelect = cancelAddKnifeblockSelect;
  window.cancelRemoveKnifeblockSelect = cancelRemoveKnifeblockSelect;

  window.addSpicerackSelect = addSpicerackSelect;
  window.removeSpicerackSelect = removeSpicerackSelect;
  window.cancelAddSpicerackSelect = cancelAddSpicerackSelect;
  window.cancelRemoveSpicerackSelect = cancelRemoveSpicerackSelect;

  window.impSwitch = impSwitch;
  window.spaceDividerSelect = spaceDividerSelect;
  window.deleteDividerSelect = deleteDividerSelect;
  window.cancelSpaceDividerSelect = cancelSpaceDividerSelect;
  window.finishSpaceDividerSelect = finishSpaceDividerSelect;
  window.deleteAll = deleteAll;
  window.printInsert = printInsert;
  window.loadInsert = loadInsert;
  window.saveInsert = saveInsert;
  window.saveSVGs = saveSVGs;
  window.vDimensionsSwitch = vDimensionsSwitch;
  window.hDimensionsSwitch = hDimensionsSwitch;
  window.drawerBoxSwitch = drawerBoxSwitch;
  window.addCutawaySelect = addCutawaySelect;
  window.removeCutawaySelect = removeCutawaySelect;

  window.changeWidth = changeWidth;
  window.changeDepth = changeDepth;
  window.changeHeight = changeHeight;
  window.calcAreas = calcAreas;
  window.calcSpicejars = calcSpicejars;
  window.checkBottomRequired = checkBottomRequired;
  window.setFeltBase = setFeltBase;
  window.setFeltColour = setFeltColour;
  window.setAntislipBase = setAntislipBase;
  window.setAntislipColour = setAntislipColour;

  
  // setup a link for saving and downloading an insert model
  const link = document.createElement("a");
  link.style.display = "none";
  document.body.appendChild(link);

  // set up env for a font to display measurements
  let font = undefined;
  const fontHeight = 0.001,
    fontSize = 0.01,
    fontCurveSegments = 10;

  // zoom the drawer insert in and out based on the zoom slider input
  var zoomSlider = document.getElementById("zoomRange");

  zoomSlider.oninput = function () {
    if (zoomSlider.value / 50 > 2) {
      camera.zoom = 2;
    } else if (zoomSlider.value / 50 < 0.5) {
      camera.zoom = 0.5;
    } else {
      camera.zoom = zoomSlider.value / 50;
    }

    camera.updateProjectionMatrix();
    controls.update();
    render();
  };

  // rotate the drawer insert left and right based on the rotate slider input
  var rotateSlider = document.getElementById("rotateRange");
  var prevRotateSliderValue = 50;

  rotateSlider.oninput = function () {
    controls.rotateLeft((rotateSlider.value - prevRotateSliderValue) * 0.05);

    prevRotateSliderValue = rotateSlider.value;
  };

  // pan the drawer insert left and right based on the pan slider input
  var panSlider = document.getElementById("panRange");
  var prevPanSliderValue = 50;

  panSlider.oninput = function () {
    if (panSlider.value > prevPanSliderValue) {
      controls.pan(10, 0);
    } else {
      if (panSlider.value < prevPanSliderValue) {
        controls.pan(-10, 0);
      }
    }

    prevPanSliderValue = panSlider.value;
  };

  // tilt the drawer insert up and down based on the tilt slider input
  var tiltSlider = document.getElementById("tiltRange");
  var prevTiltSliderValue = 50;

  tiltSlider.oninput = function () {
    controls.rotateUp((tiltSlider.value - prevTiltSliderValue) * -0.02);

    prevTiltSliderValue = tiltSlider.value;
  };

  // explode the drawer insert based on the slider input
  var explodeSlider = document.getElementById("explodeRange");
  var prevSliderValue = 0;

  explodeSlider.oninput = function () {
    if (explodeSlider.value == 0.5 && prevSliderValue == 0) {
      // disable drag controls and explode the model a number of steps
      dControls.enabled = false;
      dControls.deactivate();
      pauseUserDataUpdate = true;
    }

    let multiplier = -0.002;
    if (prevSliderValue < explodeSlider.value) {
      multiplier = 0.002;
    }

    // loop through the horizontal meshes and translate them all on z and y
    let hDivsToExplode = [];
    hDivsToExplode.push(drawer_insert.children[3]);
    hDivsToExplode.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToExplode, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToExplode, spanHorizDivGroup);

    hDivsToExplode.forEach((j) => {
      let currentZ = j.position.z;
      let currentY = j.position.y;

      if (j.name != "fbFrontMesh" && j.name != "fbBackMesh") {
        //turn off clamping, gets turned back on in redoInsert()
        j.userData.limit = {
          min: new THREE.Vector3(-1, -1, -1),
          max: new THREE.Vector3(1, 1, 1),
        };
        j.userData.update();
      }

      if (currentZ >= 0) {
        if (prevSliderValue > explodeSlider.value) {
          j.position.z = currentZ + prevSliderValue * multiplier;
          j.position.y = currentY + prevSliderValue * multiplier;
        } else {
          j.position.z = currentZ + explodeSlider.value * multiplier;
          j.position.y = currentY + explodeSlider.value * multiplier;
        }
      } else {
        if (prevSliderValue > explodeSlider.value) {
          j.position.z = currentZ - prevSliderValue * multiplier;
          j.position.y = currentY + prevSliderValue * multiplier;
        } else {
          j.position.z = currentZ - explodeSlider.value * multiplier;
          j.position.y = currentY + explodeSlider.value * multiplier;
        }
      }
    });

    // loop through the vertical meshes and translate them all on x and y
    let vDivsToExplode = [];
    vDivsToExplode.push(drawer_insert.children[1]);
    vDivsToExplode.push(drawer_insert.children[2]);
    Array.prototype.push.apply(vDivsToExplode, fullVertDivGroup);
    Array.prototype.push.apply(vDivsToExplode, spanVertDivGroup);

    vDivsToExplode.forEach((j) => {
      let currentX = j.position.x;
      let currentY = j.position.y;

      if (j.name != "leftBoardMesh" && j.name != "rightBoardMesh") {
        //turn off clamping, gets turned back on in redoInsert()
        j.userData.limit = {
          min: new THREE.Vector3(-1, -1, -1),
          max: new THREE.Vector3(1, 1, 1),
        };
        j.userData.update();
      }

      if (currentX >= 0) {
        if (prevSliderValue > explodeSlider.value) {
          j.position.x = currentX + prevSliderValue * multiplier;
          j.position.y = currentY + prevSliderValue * multiplier;
        } else {
          j.position.x = currentX + explodeSlider.value * multiplier;
          j.position.y = currentY + explodeSlider.value * multiplier;
        }
      } else {
        if (prevSliderValue > explodeSlider.value) {
          j.position.x = currentX - prevSliderValue * multiplier;
          j.position.y = currentY + prevSliderValue * multiplier;
        } else {
          j.position.x = currentX - explodeSlider.value * multiplier;
          j.position.y = currentY + explodeSlider.value * multiplier;
        }
      }
    });

    if (explodeSlider.value == 0 && prevSliderValue == 0.5) {
      dControls.enabled = true;
      dControls.activate();
      pauseUserDataUpdate = false;
      redoInsert();
    }

    prevSliderValue = explodeSlider.value;
    render();
  };

  // go to a top view
  var topViewButton = document.getElementById("topView");

  topViewButton.onclick = function () {
    zoomSlider.value = 50;
    rotateSlider.value = 50;
    panSlider.value = 50;
    tiltSlider.value = 50;
    explodeSlider.value = 0;
    controls.reset();

    const currentAngle = controls.getAzimuthalAngle();
    controls.rotateLeft(currentAngle);
    controls.rotateUp(90);
  };

  // reset the view and sliders back to the starting point
  var resetButton = document.getElementById("resetView");

  resetButton.onclick = function () {
  
    zoomSlider.value = 50;
    rotateSlider.value = 50;
    panSlider.value = 50;
    tiltSlider.value = 50;
    explodeSlider.value = 0;
  
    camera.position.z = 0.5;
    camera.position.y = 0.6;
    camera.position.x = 0.3;
    camera.updateProjectionMatrix();
  
    controls.reset();
  
    redoInsert();
  };


  function checkBottomRequired() {

    var bottomReqSwitch = document.getElementById("bottom-required");
    
    if (bottomReqSwitch.checked == true) {
      bottomReqSwitchOn = true;
      divHeight = insertHeight - baseThickness;
    } else {
      bottomReqSwitchOn = false;
      divHeight = insertHeight;
    }

    if ( feltBottomMesh != false ) {

      feltBottomMesh.geometry.dispose();
      feltBottomMesh.material.dispose();
      scene.remove(feltBottomMesh);
      drawer_insert.remove(feltBottomMesh);
      feltBottomMesh = false;

    }

    if ( antislipBottomMesh != false ) {

      antislipBottomMesh.geometry.dispose();
      antislipBottomMesh.material.dispose();
      scene.remove(antislipBottomMesh);
      drawer_insert.remove(antislipBottomMesh);
      antislipBottomMesh = false;

    }

    redoInsert();
  };

  function setFeltBase(originalFeltColour) {

    const geometry = new THREE.BoxGeometry(insertWidth, 0.00001, insertDepth);
        
    const material = new THREE.MeshLambertMaterial({
      color: 0xbc0c15,
      emissive: 0x000000,
    });

    feltBottomMesh = new THREE.Mesh(geometry, material);

    feltBottomMesh.name = "feltBottomMesh";

    feltBottomMesh.position.y = (baseThickness / 2) + 0.0001;
    scene.add(feltBottomMesh);
    drawer_insert.add(feltBottomMesh);
    render();
  };

  function setFeltColour(feltColour) {

    var meshColour = '0xbc0c15';

    if ( feltColour == "Red" ) meshColour = '0xbc0c15';
    if ( feltColour == "Black" ) meshColour = '0x181414';
    if ( feltColour == "Green" ) meshColour = '0x24443c';
    if ( feltColour == "Blue" ) meshColour = '0x0c1c4c';

    feltBottomMesh.material.color.setHex(meshColour);
    render();
  };

  function setAntislipBase(originalAntislipColour) {

    const geometry = new THREE.BoxGeometry(insertWidth, 0.00001, insertDepth);
      
    const material = new THREE.MeshPhongMaterial({
      color: 0x504d44,
      emissive: 0x000000,
    });

    antislipBottomMesh = new THREE.Mesh(geometry, material);

    antislipBottomMesh.name = "antislipBottomMesh";

    antislipBottomMesh.position.y = (baseThickness / 2) + 0.0001;
    scene.add(antislipBottomMesh);
    drawer_insert.add(antislipBottomMesh);
    render();
  };

  function setAntislipColour(antislipColour) {

    var meshColour = '0x504d44';

    if ( antislipColour == "Anthracite" ) meshColour = '0x504d44';
    if ( antislipColour == "Black" ) meshColour = '0x312f2a';
    if ( antislipColour == "Blue Jade" ) meshColour = '0x186371';
    if ( antislipColour == "Brown" ) meshColour = '0x9a7d6e';
    if ( antislipColour == "Gray" ) meshColour = '0x9ea09d';
    if ( antislipColour == "Prune" ) meshColour = '0x692b30';
    if ( antislipColour == "Green" ) meshColour = '0x878976';
    if ( antislipColour == "Taupe" ) meshColour = '0x99896f';


    antislipBottomMesh.material.color.setHex(meshColour);
    render();
  };

  // load a .json file when the Load Insert button is click and a file selected
  const inputElement = document.getElementById("uploadInput");
  inputElement.addEventListener("change", handleInputFiles, false);

  // listen for a click, set the location and call the addFullVert function
  var clickHandleFullVert = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObject(
      scene.getObjectByName("baseMesh"),
    );

    if (intersects.length > 0) {
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      var pointX = intersects[0].point.x;
      addFullVert(pointX);
    }
  };

  // listen for a click, set the location and call the addFullHoriz function
  var clickHandleFullHoriz = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObject(
      scene.getObjectByName("baseMesh"),
    );

    if (intersects.length > 0) {
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      var pointZ = intersects[0].point.z;
      addFullHoriz(pointZ);
    }
  };

  // listen for a click, set the location and call the addSpanVert function
  var clickHandleVert = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObject(
      scene.getObjectByName("baseMesh"),
    );

    if (intersects.length > 0) {
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      var pointX = intersects[0].point.x;
      var pointZ = intersects[0].point.z;
      addSpanVert(pointX, pointZ);
    }
  };

  // listen for a click, set the location and call the addSpanHoriz function
  var clickHandleHoriz = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObject(
      scene.getObjectByName("baseMesh"),
    );

    if (intersects.length > 0) {
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      var pointX = intersects[0].point.x;
      var pointZ = intersects[0].point.z;
      addSpanHoriz(pointX, pointZ);
    }
  };

  var clickHandleSpace = function (event) {
    // add the board being hovered on to the list of boards to be evenly spaced

    if (hoverOnBoard === true) {
      if (divsToSpace.length == 0) {
        divsToSpace.push(hoverObject);
        hoverObject.material.color.set(0x66a3ff);
        if (
          hoverObject.name == "fullVertBoardMesh" ||
          hoverObject.name == "spanVertBoardMesh"
        ) {
          divsToSpaceIsVertical = true;
        } else {
          divsToSpaceIsVertical = false;
        }
      } else if (
        divsToSpaceIsVertical == true &&
        (hoverObject.name == "fullVertBoardMesh" ||
          hoverObject.name == "spanVertBoardMesh")
      ) {
        divsToSpace.push(hoverObject);
        hoverObject.material.color.set(0x66a3ff);
      } else if (
        divsToSpaceIsVertical == false &&
        (hoverObject.name == "fullHorizBoardMesh" ||
          hoverObject.name == "spanHorizBoardMesh")
      ) {
        divsToSpace.push(hoverObject);
        hoverObject.material.color.set(0x66a3ff);
      }
      // console.log("adding divider to divsToSpace");
      // console.log(divsToSpace);
      // console.log(hoverObject);
    } else {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      raycaster.setFromCamera(mouse, camera);
      let intersects = raycaster.intersectObjects(moveableObjects);

      if (intersects.length > 0) {
        hoverObject = intersects[0].object;
        if (divsToSpace.length == 0) {
          divsToSpace.push(hoverObject);
          hoverObject.material.dispose();
          hoverObject.material = new THREE.MeshPhongMaterial({
            color: 0x66a3ff,
            emissive: 0x000000,
          });
          //hoverObject.material.color.set(0x66a3ff);
          if (
            hoverObject.name == "fullVertBoardMesh" ||
            hoverObject.name == "spanVertBoardMesh"
          ) {
            divsToSpaceIsVertical = true;
          } else {
            divsToSpaceIsVertical = false;
          }
        } else if (
          divsToSpaceIsVertical == true &&
          (hoverObject.name == "fullVertBoardMesh" ||
            hoverObject.name == "spanVertBoardMesh")
        ) {
          divsToSpace.push(hoverObject);
          hoverObject.material.dispose();
          hoverObject.material = new THREE.MeshPhongMaterial({
            color: 0x66a3ff,
            emissive: 0x000000,
          });
          //hoverObject.material.color.set(0x66a3ff);
        } else if (
          divsToSpaceIsVertical == false &&
          (hoverObject.name == "fullHorizBoardMesh" ||
            hoverObject.name == "spanHorizBoardMesh")
        ) {
          divsToSpace.push(hoverObject);
          hoverObject.material.dispose();
          hoverObject.material = new THREE.MeshPhongMaterial({
            color: 0x66a3ff,
            emissive: 0x000000,
          });
          //hoverObject.material.color.set(0x66a3ff);
        }
      }
    }
    render();
  };

  var clickHandleDelete = function (event) {
    if (hoverOnBoard === true) {
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      deleteDivider();
      return;
    } else {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      raycaster.setFromCamera(mouse, camera);
      let intersects = raycaster.intersectObjects(moveableObjects);

      if (intersects.length > 0) {
        hoverObject = intersects[0].object;
        const toolClick = window.document.getElementById("validToolClick");
        toolClick.click();
        deleteDivider();
      }
    }
  };

  var clickHandleAddCutaway = function (event) {
    if (hoverOnBoard === true) {
      //dControls.removeEventListener("dragstart", dragStartHandle, false);
      //dControls.removeEventListener("dragend", dragEndHandle, false);
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      addCutaway();
    } else {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      raycaster.setFromCamera(mouse, camera);
      let intersects = raycaster.intersectObjects(moveableObjects);

      if (intersects.length > 0) {
        hoverObject = intersects[0].object;
        const toolClick = window.document.getElementById("validToolClick");
        toolClick.click();
        addCutaway();
      }
    }
  };

  var clickHandleRemoveCutaway = function (event) {
    if (hoverOnBoard === true) {
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      removeCutaway();
    } else {
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      raycaster.setFromCamera(mouse, camera);
      let intersects = raycaster.intersectObjects(moveableObjects);

      if (intersects.length > 0) {
        hoverObject = intersects[0].object;
        const toolClick = window.document.getElementById("validToolClick");
        toolClick.click();
        removeCutaway();
      }
    }
  };

  var clickHandleAddKnifeblock = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(validBottomAreas);

    if (intersects.length > 0) {
      hoverKnifeblockArea = intersects[0].object;
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      addKnifeblock(hoverKnifeblockArea);
    }
  };

  var clickHandleRemoveKnifeblock = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(validBottomAreas);

    if (intersects.length > 0) {
      hoverKnifeblockArea = intersects[0].object;
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      removeKnifeblock(hoverKnifeblockArea);
    }
  };

  var clickHandleAddLargeKnifeblock = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(validBottomAreas);

    if (intersects.length > 0) {
      hoverKnifeblockArea = intersects[0].object;
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      addLargeKnifeblock(hoverKnifeblockArea);
    }
  };

  var clickHandleAddSpicerack = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(validBottomAreas);

    if (intersects.length > 0) {
      hoverSpicerackArea = intersects[0].object;
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      addSpicerack(hoverSpicerackArea);
    }
  };

  var clickHandleRemoveSpicerack = function (event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(validBottomAreas);

    if (intersects.length > 0) {
      hoverSpicerackArea = intersects[0].object;
      const toolClick = window.document.getElementById("validToolClick");
      toolClick.click();
      removeSpicerack(hoverSpicerackArea);
    }
  };

  var hoverOnKnifeblockHandle = function (event) {
    //console.log("hoveron " + event.object.name);

    event.object.material.dispose();
    event.object.material = new THREE.MeshPhongMaterial({
      color: 0x009933,
      emissive: 0x000000,
    });
    renderer.render(scene, camera);
  };

  var hoverOffKnifeblockHandle = function (event) {
    //console.log("hoveroff " + event.object.name);

    event.object.material.dispose();
    event.object.material = new THREE.MeshPhongMaterial({
      color: 0x98a698,
      emissive: 0x000000,
    });

    renderer.render(scene, camera);
  };

  var hoverOnHandle = function (event) {
    //console.log("hoveron " + event.object.name);

    hoverOnBoard = true;
    hoverObject = event.object;

    let leaveColour = false;

    let i = 0;
    for (i = 0; i < divsToSpace.length; i++) {
      if (divsToSpace[i] == hoverObject) {
        leaveColour = true;
      }
    }

    if (leaveColour == false) {
      //event.object.material.color.set(0xff3333);
      event.object.material.dispose();
      event.object.material = new THREE.MeshPhongMaterial({
        color: 0x98a698,
        emissive: 0x000000,
      });
      //event.object.material.map = null;
      //event.object.material.color.set(0x98a698);
    }

    document.addEventListener("keydown", onDocumentKeyDown, false);
    renderer.render(scene, camera);
  };

  var hoverOffHandle = function (event) {
    //console.log("hoveroff " + event.object.name);

    let leaveColour = false;

    let i = 0;
    for (i = 0; i < divsToSpace.length; i++) {
      if (divsToSpace[i] == hoverObject) {
        leaveColour = true;
      }
    }

    if (leaveColour == false) {
      event.object.material.dispose();
      event.object.material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
      //event.object.material.map = textureInUse;
      //event.object.material.color.set(originalColour);
    }

    hoverOnBoard = false;
    hoverObject = undefined;
    document.removeEventListener("keydown", onDocumentKeyDown, false);
    renderer.render(scene, camera);
  };

  var dragHandle = function (event) {
    //console.log("drag");
    if (pauseUserDataUpdate == false) {
      //console.log("updating moveableObjects");
      moveableObjects.forEach((o) => {
        o.userData.update();
      });
    }

    const allHorizSpan = spanHorizDivGroup.concat(knifeblockBladeGroup,knifeblockHandleGroup,
          knifeblockLargeBladeGroup,knifeblockLargeHandleGroup, knifeblockLargeHandle2Group);

    // if the spanning object being dragged would interfere with other dividers
    // of the same orientation then mark it as red
    if (spanVertDivGroup.includes(event.object)) {
      let j = 0;
      for (j = 0; j < spanVertDivGroup.length; j++) {
        if (event.object.id == spanVertDivGroup[j].id) {
          //console.log("  can't collide with itself, skipping id = " + i.id);
          continue;
        }

        const iLength =
          event.object.geometry.boundingBox.max.x -
          event.object.geometry.boundingBox.min.x;
        const jLength =
          spanVertDivGroup[j].geometry.boundingBox.max.x -
          spanVertDivGroup[j].geometry.boundingBox.min.x;

        const iBottomX =
          Math.round(
            (event.object.position.z + iLength / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        const iTopX =
          Math.round(
            (event.object.position.z - iLength / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        const jTopX =
          Math.round(
            (spanVertDivGroup[j].position.z - jLength / 2 + 3) * 1000000 +
              Number.EPSILON,
          ) / 1000000;
        const jBottomX =
          Math.round(
            (spanVertDivGroup[j].position.z + jLength / 2 - boardThickness) *
              1000000 +
              Number.EPSILON,
          ) / 1000000;

        if (iBottomX == jTopX || iTopX == jBottomX) {
          //console.log("  dividers could interfere...");
          if (
            event.object.position.x >=
              spanVertDivGroup[j].position.x - 0.01 - boardThickness / 2 &&
            event.object.position.x <=
              spanVertDivGroup[j].position.x + 0.01 + boardThickness / 2
          ) {
            //console.log("    dividers could interfere, setting red...");
            spanVertDivGroup[j].material.dispose();
            spanVertDivGroup[j].material = new THREE.MeshPhongMaterial({
              color: 0xff3333,
              emissive: 0x000000,
            });
          } else if (spanVertDivGroup[j].material.map == null) {
            spanVertDivGroup[j].material.dispose();
            spanVertDivGroup[j].material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
          }
        }
      }
    } else if (allHorizSpan.includes(event.object)) {
      let j = 0;
      for (j = 0; j < allHorizSpan.length; j++) {
        if (event.object.id == allHorizSpan[j].id) {
          //console.log("  can't collide with itself, skipping id = " + i.id);
          continue;
        }

        const iLength =
          event.object.geometry.boundingBox.max.x -
          event.object.geometry.boundingBox.min.x;
        const jLength =
          allHorizSpan[j].geometry.boundingBox.max.x -
          allHorizSpan[j].geometry.boundingBox.min.x;

        const iRightX =
          Math.round(
            (event.object.position.x + iLength / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        const iLeftX =
          Math.round(
            (event.object.position.x - iLength / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        const jLeftX =
          Math.round(
            (allHorizSpan[j].position.x - jLength / 2 + boardThickness) *
              1000000 +
              Number.EPSILON,
          ) / 1000000;
        const jRightX =
          Math.round(
            (allHorizSpan[j].position.x + jLength / 2 - boardThickness) *
              1000000 +
              Number.EPSILON,
          ) / 1000000;

        if (iRightX == jLeftX || iLeftX == jRightX) {
          //console.log("  dividers could interfere...");
          if (
            event.object.position.z >=
              allHorizSpan[j].position.z - 0.01 - boardThickness / 2 &&
            event.object.position.z <=
              allHorizSpan[j].position.z + 0.01 + boardThickness / 2
          ) {
            //console.log("    dividers could interfere, setting red...");
            allHorizSpan[j].material.dispose();
            allHorizSpan[j].material = new THREE.MeshPhongMaterial({
              color: 0xff3333,
              emissive: 0x000000,
            });
          } else if (allHorizSpan[j].material.map == null) {
            allHorizSpan[j].material.dispose();
            allHorizSpan[j].material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
          }
        }
      }
    }

    renderer.render(scene, camera);
  };

  var dragStartHandle = function (event) {
    //console.log("dragstart");
    //console.log(event);
    //event.object.material.map = null;
    //event.object.material.color.set(0x98a698);
    controls.enabled = false;
    renderer.render(scene, camera);
  };

  var dragEndHandle = function (event) {
    //console.log("dragend");
    //event.object.material.color.set(0xbd9975);
    //event.object.material.map = textureInUse;
    //event.object.material.color.set(originalColour);
    controls.enabled = true;
    // redraw base and dividers that touch the dragged object
    lastDivDragged = event.object.id;
    redoInsert();

    renderer.render(scene, camera);
  };

  init();

  function init() {
    canvas = document.getElementById("myCanvas");

    scene = new THREE.Scene();
    scene.background = new THREE.Color("rgb(190, 190, 190)");

    renderer = new THREE.WebGLRenderer({
      antialias: true,
      canvas: canvas,
      preserveDrawingBuffer: true,
    });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);

    camera = new THREE.PerspectiveCamera(45,canvas.clientWidth / canvas.clientHeight,0.01,50);
    camera.position.z = 0.5;
    camera.position.y = 0.6;
    camera.position.x = 0.3;

    scene.add(camera);

    window.addEventListener("resize", function () {
      camera.aspect = canvas.clientWidth / canvas.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
      renderer.render(scene, camera);
    });

    controls = new OrbitControls(camera, renderer.domElement);
    controls.maxDistance = 2;
    controls.minDistance = 0.5;
    controls.update();
    controls.addEventListener("change", render);

    dControls = new DragControls(moveableObjects, camera, renderer.domElement);
    addListeners();

    drawer_insert = new THREE.Object3D();
    scene.add(drawer_insert);

    const light = new THREE.SpotLight( 0xffffff,.8);
    light.position.set( 0, 1, 0 );
    
    const light2 = new THREE.DirectionalLight( 0xffffff,.8);
    light2.position.set( 10, 0.05, 0 );
    
    const light3 = new THREE.DirectionalLight( 0xffffff,.8);
    light3.position.set( -10, 0.05, 0);

    const light4 = new THREE.DirectionalLight( 0xffffff,.8);
    light4.position.set( 0, 0.05, 1);

    const light5 = new THREE.DirectionalLight( 0xffffff,.7);
    light5.position.set( 0, 0.05, -1);

    const light6 = new THREE.DirectionalLight( 0xffffff,.7);
    light6.position.set( 0, -1, 0);
   
    scene.add(light);
    scene.add(light2);
    scene.add(light3);
    scene.add(light4);
    scene.add(light5);
    scene.add(light6);


    // load a font for displaying measurements
    const loader = new THREE.FontLoader();
    font = loader.parse(fontFile);

    // populate the inputs with the initial values
    window.parent.document.getElementById("outside_width").value =
      insertWidth * 100;
    window.parent.document.getElementById("outside_depth").value =
      insertDepth * 100;
    window.parent.document.getElementById("outside_height").value =
      insertHeight * 100;

    // build base Mesh and add it to the main Object3D
    textureInUse = textureMaple;
    textureSideInUse = textureSideMaple;
    textureInUseName = "Maple";

    const initialBaseGeometry = makeBaseGeometry();
    const materialBase = new THREE.MeshPhongMaterial({ map: textureInUse });
    originalColour = materialBase.color;
    const baseMesh = new THREE.Mesh(initialBaseGeometry, materialBase);

    baseMesh.name = "baseMesh";
    drawer_insert.add(baseMesh);

    // build left and right side Mesh and add it to the main Object3D
    const initialLeftSideGeometery = makeSideGeometry();
    const initialRightSideGeometery = makeSideGeometry();
    const materialSide = new THREE.MeshPhongMaterial({ map: textureSideInUse });
    const leftBoardMesh = new THREE.Mesh(
      initialLeftSideGeometery,
      materialSide,
    );

    const rightBoardMesh = new THREE.Mesh(
      initialRightSideGeometery,
      materialSide,
    );

    // position the left and right sides
    leftBoardMesh.rotation.y += radNinety;
    rightBoardMesh.rotation.y += radNinety;
    leftBoardMesh.translateZ(0 - (insertWidth / 2 - boardThickness / 2));
    leftBoardMesh.translateY(divHeight / 2 + baseThickness / 2);
    rightBoardMesh.translateZ(insertWidth / 2 - boardThickness / 2);
    rightBoardMesh.translateY(divHeight / 2 + baseThickness / 2);

    leftBoardMesh.name = "leftBoardMesh";
    rightBoardMesh.name = "rightBoardMesh";
    drawer_insert.add(leftBoardMesh, rightBoardMesh);

    // build front and back Mesh and add it to the main Object3D
    const initialFrontGeometery = makeFbGeometry();
    const initialBackGeometery = makeFbGeometry();

    const fbFrontMesh = new THREE.Mesh(initialFrontGeometery, materialSide);

    const fbBackMesh = new THREE.Mesh(initialBackGeometery, materialSide);

    // position the front and back parts
    fbBackMesh.translateZ(0 - (insertDepth / 2 - boardThickness / 2));
    fbBackMesh.translateY(divHeight / 2 + baseThickness / 2);
    fbFrontMesh.translateZ(insertDepth / 2 - boardThickness / 2);
    fbFrontMesh.translateY(divHeight / 2 + baseThickness / 2);

    fbFrontMesh.name = "fbFrontMesh";
    fbBackMesh.name = "fbBackMesh";

    drawer_insert.add(fbFrontMesh, fbBackMesh);

    //assign the UV's to the geometry of each mesh
    drawer_insert.children.forEach((i) => {
      assignUVs(i);
    });

    //add in a transparent drawer box to house the insert
    const DbMaterial = new THREE.MeshPhongMaterial( { color: 0xd5d5d5, transparent: true, opacity: 0.4 } ); //{wireframe: true}

    dbRightMesh = new THREE.Mesh(makeDbSideGeometry(), DbMaterial);
    dbLeftMesh = new THREE.Mesh(makeDbSideGeometry(), DbMaterial);
    dbBackMesh = new THREE.Mesh(makeDbBackGeometry(), DbMaterial);
    dbFrontMesh = new THREE.Mesh(makeDbFrontGeometry(), DbMaterial);
    dbBaseMesh = new THREE.Mesh(makeDbBaseGeometry(), DbMaterial);

    dbRightMesh.rotation.y += radNinety;
    dbLeftMesh.rotation.y += radNinety;
    
    dbRightMesh.position.x = insertWidth / 2 + (drawerboxThickness / 2) + drawerboxSpace;
    dbRightMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2);
    
    dbLeftMesh.position.x = 0 - (insertWidth / 2 + (drawerboxThickness / 2) + drawerboxSpace);
    dbLeftMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2);
    
    dbBackMesh.position.z = 0 - (insertDepth / 2) - (drawerboxThickness / 2) - drawerboxSpace;
    dbBackMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2);
    dbFrontMesh.position.z = 0 + (insertDepth / 2) + (drawerboxThickness / 2) + drawerboxSpace;
    dbFrontMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2) - 0.00125;

    dbBaseMesh.position.z = 0 - (drawerboxThickness / 2);
    dbBaseMesh.position.y = 0 - (drawerboxThickness / 2) - (baseThickness / 2);

    scene.add(dbBackMesh,dbFrontMesh,dbRightMesh,dbLeftMesh, dbBaseMesh);
   

    // set up the Material buttons
    var materialsButton1 = document.getElementById("material1");
    var materialsButton2 = document.getElementById("material2");
    var materialsButton3 = document.getElementById("material3");
    var materialsButton4 = document.getElementById("material4");

    materialsButton1.onclick = function () {
      textureInUse = textureMaple;
      textureSideInUse = textureSideMaple;
      textureInUseName = "Maple";
      let k = 0;
      for (k = 0; k < drawer_insert.children.length; k++) {
        if (drawer_insert.children[k].type == "Mesh" && drawer_insert.children[k].name == "baseMesh") {
          drawer_insert.children[k].material.map = textureInUse;
        } else if (drawer_insert.children[k].type == "Mesh") {
          drawer_insert.children[k].material.map = textureSideInUse;
        }

        if (
          drawer_insert.children[k].name == "outsideVertMeasGroup" ||
          drawer_insert.children[k].name == "outsideHeightMeasGroup" ||
          drawer_insert.children[k].name == "outsideHorizMeasGroup"
        ) {
          drawer_insert.children[k].children[3].material.color.set(0xffffff);
        }
        if (
          drawer_insert.children[k].name == "vMeasurementGroup" ||
          drawer_insert.children[k].name == "hMeasurementGroup"
        ) {
          let l = 0;
          for (l = 0; l < drawer_insert.children[k].children.length; l++) {
            drawer_insert.children[k].children[
              l
            ].children[3].material.color.set(0xffffff);
          }
        }
      }
      render();
    };

     materialsButton2.onclick = function () {

       textureInUse = textureOak;
       textureSideInUse = textureSideOak;
       textureInUseName = "Oak";

       let k = 0;
       for (k = 0; k < drawer_insert.children.length; k++) {
         if (drawer_insert.children[k].type == "Mesh" && drawer_insert.children[k].name == "baseMesh") {
          drawer_insert.children[k].material.map = textureInUse;
         } else if (drawer_insert.children[k].type == "Mesh") {
          drawer_insert.children[k].material.map = textureSideInUse;
         }

         if ( drawer_insert.children[k].name == "outsideVertMeasGroup" ||
              drawer_insert.children[k].name == "outsideHeightMeasGroup" ||
              drawer_insert.children[k].name == "outsideHorizMeasGroup"
         ) {
           drawer_insert.children[k].children[3].material.color.set(0xffffff);
         }
         if ( drawer_insert.children[k].name == "vMeasurementGroup" ||
              drawer_insert.children[k].name == "hMeasurementGroup" ) {
           let l = 0;
           for (l = 0; l < drawer_insert.children[k].children.length; l++) {
             drawer_insert.children[k].children[l].children[3].material.color.set(0xffffff);
           };
         }

       };

       render();
     } 

    materialsButton3.onclick = function () {
      textureInUse = textureWalnut;
      textureSideInUse = textureSideWalnut;
      textureInUseName = "Walnut";
      let k = 0;
      for (k = 0; k < drawer_insert.children.length; k++) {
        if (drawer_insert.children[k].type == "Mesh" && drawer_insert.children[k].name == "baseMesh") {
          drawer_insert.children[k].material.map = textureInUse;
        } else if (drawer_insert.children[k].type == "Mesh") {
          drawer_insert.children[k].material.map = textureSideInUse;
        }

        if (
          drawer_insert.children[k].name == "outsideVertMeasGroup" ||
          drawer_insert.children[k].name == "outsideHeightMeasGroup" ||
          drawer_insert.children[k].name == "outsideHorizMeasGroup"
        ) {
          drawer_insert.children[k].children[3].material.color.set(0xffffff);
        }
        if (
          drawer_insert.children[k].name == "vMeasurementGroup" ||
          drawer_insert.children[k].name == "hMeasurementGroup"
        ) {
          let l = 0;
          for (l = 0; l < drawer_insert.children[k].children.length; l++) {
            drawer_insert.children[k].children[
              l
            ].children[3].material.color.set(0xffffff);
          }
        }
      }
      render();
    };

    materialsButton4.onclick = function () {
      textureInUse = textureCedar;
      textureSideInUse = textureSideCedar;
      textureInUseName = "Cedar";
      let k = 0;
      for (k = 0; k < drawer_insert.children.length; k++) {
        if (drawer_insert.children[k].type == "Mesh" && drawer_insert.children[k].name == "baseMesh") {
          drawer_insert.children[k].material.map = textureInUse;
        } else if (drawer_insert.children[k].type == "Mesh") {
          drawer_insert.children[k].material.map = textureSideInUse;
        }

        if (
          drawer_insert.children[k].name == "outsideVertMeasGroup" ||
          drawer_insert.children[k].name == "outsideHeightMeasGroup" ||
          drawer_insert.children[k].name == "outsideHorizMeasGroup"
        ) {
          drawer_insert.children[k].children[3].material.color.set(0xffffff);
        }
        if (
          drawer_insert.children[k].name == "vMeasurementGroup" ||
          drawer_insert.children[k].name == "hMeasurementGroup"
        ) {
          let l = 0;
          for (l = 0; l < drawer_insert.children[k].children.length; l++) {
            drawer_insert.children[k].children[
              l
            ].children[3].material.color.set(0xffffff);
          }
        }
      }
      render();
    };

    //console.log("adding initial measurements");
    if (vDimOn == true) {
      addVertMeasurementLines();
      addVertOutsideMeasurementLine();
      addHeightOutsideMeasurementLine();
    }

    if (hDimOn == true) {
      addHorizMeasurementLines();
      addHorizOutsideMeasurementLine();
    }

    renderer.render(scene, camera);

    history.push(saveInsert(true));
  }

  function handleInputFiles() {
    const fileList = this.files;
    let reader = new FileReader();

    reader.readAsText(fileList.item(0));

    reader.onload = function () {
      loadInsert(reader.result);
    };

    reader.onerror = function () {
      console.log(reader.error);
    };
  }

  function onDocumentKeyDown(event) {
    let increment = 0.001;
    if (impSwitchOn == true) {
      increment = 0.0015875;
    }

    if (
      hoverObject.name == "fullVertBoardMesh" ||
      hoverObject.name == "spanVertBoardMesh"
    ) {
      if (event.code == "ArrowLeft") {
        hoverObject.position.x -= increment;
      } else if (event.code == "ArrowRight") {
        hoverObject.position.x += increment;
      }
    } else if (
      hoverObject.name == "fullHorizBoardMesh" ||
      hoverObject.name == "spanHorizBoardMesh"
    ) {
      if (event.code == "ArrowUp") {
        hoverObject.position.z -= increment;
      } else if (event.code == "ArrowDown") {
        hoverObject.position.z += increment;
      }
    }

    lastDivDragged = hoverObject.id;
    redoInsert();
  }

  function undoRedo(event) {
    //console.log("keydown sensed...");

    if (
      ((event.ctrlKey && event.key === "z") ||
        (event.metaKey && event.key === "z" && !event.shiftKey)) &&
      histPosition > 0
    ) {
      histPosition--;
      //console.log("ctrl-z pressed, loading history pos = " + histPosition + " len = " + history.length);
      loadInsert(history[histPosition]);
    }

    if (
      ((event.ctrlKey && event.key === "y") ||
        (event.metaKey && event.shiftKey && event.key === "z")) &&
      histPosition + 1 < history.length
    ) {
      histPosition++;
      //console.log("ctrl-y pressed, loading history pos = " + histPosition + " len = " + history.length);
      loadInsert(history[histPosition]);
    }
  }

  function addListeners() {
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);
    document.addEventListener("keydown", undoRedo, false);
  }

  function removeListeners() {
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    dControls.removeEventListener("drag", dragHandle, false);
    dControls.removeEventListener("hoveron", hoverOnHandle, false);
    dControls.removeEventListener("hoveroff", hoverOffHandle, false);
    document.removeEventListener("keydown", undoRedo, false);
  }

  function printInsert() {
    const insertImage = renderer.domElement.toDataURL("image/jpeg");

    var newTab = window.open("about:blank", "image from canvas");
    newTab.document.write("<img src='" + insertImage + "' alt='from canvas'/>");

    setTimeout(function () {
      newTab.print();
    }, 100);
  }

  function loadInsert(insertObject) {
    removeListeners();
    dControls.dispose();
    scene.remove(drawer_insert);

    drawer_insert = new THREE.ObjectLoader().parse(JSON.parse(insertObject));
    //console.log("drawer_insert right after loading...");
    //console.log(drawer_insert);

    if (drawer_insert.userData.textureMaple) {
      textureInUse = textureMaple;
      textureSideInUse = textureSideMaple;
      textureInUseName = "Maple";
      const event = new Event("loadInsertClick");
      document.getElementById("material1").dispatchEvent(event);
   }
    else if ( drawer_insert.userData.textureOak ) {
      textureInUse = textureOak;
      textureSideInUse = textureSideOak;
      textureInUseName = "Oak";
      const event = new Event("loadInsertClick");
      document.getElementById("material2").dispatchEvent(event);
   }
    else if ( drawer_insert.userData.textureWalnut ) {
      textureInUse = textureWalnut;
      textureSideInUse = textureSideWalnut;
      textureInUseName = "Walnut";
      const event = new Event("loadInsertClick");
      document.getElementById("material3").dispatchEvent(event);
   }
   else if ( drawer_insert.userData.textureCedar ) {
     textureInUse = textureCedar;
     textureSideInUse = textureSideCedar;
     textureInUseName = "Cedar";
     const event = new Event("loadInsertClick");
     document.getElementById("material4").dispatchEvent(event);
  }

      (fullVertDivGroup = []),
      (fullHorizDivGroup = []),
      (spanVertDivGroup = []),
      (spanHorizDivGroup = []),
      (moveableObjects = []),
      (divsWithCutaway = []),
      (knifeblockBladeGroup = []),
      (knifeblockHandleGroup = []),
      (knifeblockLargeBladeGroup = []),
      (knifeblockLargeHandleGroup = []),
      (knifeblockLargeHandle2Group = []),
      (spicerackDisabledMoveableObjects = []),
      (spicerackInsertGroup = []);

    //restore the texture to the base
    drawer_insert.children[0].material.map = textureInUse;

    let j = 1;
    for (j = 1; j < drawer_insert.children.length; j++) {
      drawer_insert.children[j].material.map = textureSideInUse;
      let mesh = drawer_insert.children[j];
              
      if (mesh.name === "fullVertBoardMesh") {
        moveableObjects.push(mesh);
        fullVertDivGroup.push(mesh);
        // re-add the userdata update function as they are not cloned when the meshes are saved
        mesh.userData.update = function () {
          mesh.position.clamp(mesh.userData.limit.min, mesh.userData.limit.max);
        };
        mesh.userData.update();
      } else if (mesh.name === "fullHorizBoardMesh") {
        moveableObjects.push(mesh);
        fullHorizDivGroup.push(mesh);
        // re-add the userdata update function as they are not cloned when the meshes are saved
        mesh.userData.update = function () {
          mesh.position.clamp(mesh.userData.limit.min, mesh.userData.limit.max);
        };
      mesh.userData.update();
      } else if (mesh.name === "spanVertBoardMesh") {
        moveableObjects.push(mesh);
        spanVertDivGroup.push(mesh);
        // re-add the userdata update function as they are not cloned when the meshes are saved
        mesh.userData.update = function () {
          mesh.position.clamp(mesh.userData.limit.min, mesh.userData.limit.max);
        };
        mesh.userData.update();
      } else if (mesh.name === "spanHorizBoardMesh") {
        moveableObjects.push(mesh);
        spanHorizDivGroup.push(mesh);
        // re-add the userdata update function as they are not cloned when the meshes are saved
        mesh.userData.update = function () {
          mesh.position.clamp(mesh.userData.limit.min, mesh.userData.limit.max);
        };
        mesh.userData.update();

      } else if (mesh.name === "knifeblockBladeBoardMesh") {
          knifeblockBladeGroup.push(mesh);
      } else if (mesh.name === "knifeblockHandleBoardMesh") {
          knifeblockHandleGroup.push(mesh);
      } else if (mesh.name === "knifeblockLargeBladeBoardMesh") {
          knifeblockLargeBladeGroup.push(mesh);
      } else if (mesh.name === "knifeblockLargeHandleBoardMesh") {
          knifeblockLargeHandleGroup.push(mesh);
      } else if (mesh.name === "knifeblockLargeHandle2BoardMesh") {
          knifeblockLargeHandle2Group.push(mesh);
      } else if (mesh.name === "spicerackInsertBoardMesh") {
          spicerackInsertGroup.push(mesh);
          spicerackDisabledMoveableObjects.push([]);
      }

    
      // if this mesh is in the cutawayNameList add it to the divsWithCutaway array
      if (mesh.userData.hasCutaway === true) {
        divsWithCutaway.push(mesh);
      }

      if (mesh.name === "feltBottomMesh") feltBottomMesh = mesh;    

      drawer_insert.children[j].geometry.computeBoundingBox();
    }

    drawer_insert.children[0].geometry.computeBoundingBox();
    //set dimensions from the newly loaded model
    // check the height of the bounding box of the left board
    insertHeight =
      drawer_insert.children[1].geometry.boundingBox.max.y -
      drawer_insert.children[1].geometry.boundingBox.min.y +
      baseThickness;

    divHeight = insertHeight - baseThickness;
    // check the depth of the bounding box of the base
    insertDepth =
      drawer_insert.children[0].geometry.boundingBox.max.z -
      drawer_insert.children[0].geometry.boundingBox.min.z;
    // check the width of the bounding box of the base
    insertWidth =
      drawer_insert.children[0].geometry.boundingBox.max.x -
      drawer_insert.children[0].geometry.boundingBox.min.x;

    window.parent.document.getElementById("outside_height").value = (
      insertHeight * 100
    ).toFixed(2);
    window.parent.document.getElementById("outside_depth").value = (
      insertDepth * 100
    ).toFixed(2);
    window.parent.document.getElementById("outside_width").value = (
      insertWidth * 100
    ).toFixed(2);

    scene.add(drawer_insert);

    // remove the divs in front of and behind any spiceracks from the moveableObjects array
    let k = 0;
    for (k = 0; k < spicerackInsertGroup.length; k++) {
      spicerackDisableAdjacentDivs(spicerackInsertGroup[k].position.z);
    }

    dControls = new DragControls(moveableObjects, camera, renderer.domElement);
    addListeners();

    justLoaded = true;
    redoInsert();
  }

  function saveInsert(returning) {
    let insertToSave = drawer_insert.clone();

    let i = 0;
    for (i = 0; i < insertToSave.length; i++) {
      insertToSave[i].material.color.set(originalColour);
    }

    if (vDimOn == true) {
      let j = insertToSave.children.length - 1;
      for (j = insertToSave.children.length - 1; j >= 0; j--) {
        if (
          insertToSave.children[j].name == "vMeasurementGroup" ||
          insertToSave.children[j].name == "outsideVertMeasGroup" ||
          insertToSave.children[j].name == "outsideHeightMeasGroup"
        ) {
          insertToSave.children.splice(j, 1);
        }
      }
    }
    if (hDimOn == true) {
      let j = insertToSave.children.length - 1;
      for (j = insertToSave.children.length - 1; j >= 0; j--) {
        if (
          insertToSave.children[j].name == "hMeasurementGroup" ||
          insertToSave.children[j].name == "outsideHorizMeasGroup"
        ) {
          insertToSave.children.splice(j, 1);
        }
      }
    }

    let j = 0;
    for (j = 0; j < insertToSave.children.length; j++) {
      insertToSave.children[j].geometry.computeBoundingBox();
      insertToSave.children[j].material.map = null;
    }

    if (textureInUseName == "Maple") {
      insertToSave.userData.textureMaple = true;
      insertToSave.userData.textureOak = false;
      insertToSave.userData.textureWalnut = false;
      insertToSave.userData.textureCedar = false;
    }
    if (textureInUseName == "Oak") {
      insertToSave.userData.textureMaple = false;
      insertToSave.userData.textureOak = true;
      insertToSave.userData.textureWalnut = false;
      insertToSave.userData.textureCedar = false;
    }
    if (textureInUseName == "Walnut") {
      insertToSave.userData.textureMaple = false;
      insertToSave.userData.textureOak = false;
      insertToSave.userData.textureWalnut = true;
      insertToSave.userData.textureCedar = false;
    }
    if (textureInUseName == "Cedar") {
      insertToSave.userData.textureMaple = false;
      insertToSave.userData.textureOak = false;
      insertToSave.userData.textureWalnut = false;
      insertToSave.userData.textureCedar = true;
    }

    // set the instantiation parameters unique to the boxGeometry object created for the base
    // when loading the original parameters are used which seem to override the objects geometry.
    //console.log("base geo type = " + insertToSave.children[0].geometry.type);
    if (insertToSave.children[0].geometry.type == "BoxGeometry") {
      insertToSave.children[0].geometry.parameters.depth = insertDepth;
      insertToSave.children[0].geometry.parameters.width = insertWidth;
    }

    //console.log("insertToSave right before saving...");
    //console.log(insertToSave);

    const json = insertToSave.toJSON();

    const output = JSON.stringify(json);

    let insertFilename =
      window.parent.document.getElementById("insertName").value + ".json";

    if (returning) return output;
    else saveFile(new Blob([output], { type: "text/plain" }), insertFilename);
  }

  function saveFile(blob, filename) {
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }

  function checkVertHole(holePosX, holePosZ) {
    fullVertDivGroup.forEach((i) => {
      if (
        (i.position.x + 0.01) * -1 <= holePosX &&
        (i.position.x - 0.01) * -1 >= holePosX
      ) {
        holePosX = holePosX + 0.02;
      }
    });

    spanVertDivGroup.forEach((i) => {
      const iLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      const iTopZ =
        Math.round((i.position.z - iLength / 2) * 1000000 + Number.EPSILON) /
        1000000;
      const iBottomZ =
        Math.round((i.position.z + iLength / 2) * 1000000 + Number.EPSILON) /
        1000000;
      if (
        (i.position.x + 0.01) * -1 <= holePosX &&
        (i.position.x - 0.01) * -1 >= holePosX &&
        holePosZ >= iTopZ &&
        holePosZ <= iBottomZ
      ) {
        holePosX = holePosX + 0.02;
      }
    });

    return holePosX;
  }

  function checkHorizHole(holePosX, holePosZ) {
    fullHorizDivGroup.forEach((i) => {
      if (i.position.z + 0.01 >= holePosZ && i.position.z - 0.01 <= holePosZ) {
        holePosZ = holePosZ + 0.02;
      }
    });

    spanHorizDivGroup.forEach((i) => {
      const iLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      const iTopX =
        Math.round((i.position.x - iLength / 2) * 1000000 + Number.EPSILON) /
        1000000;
      const iBottomX =
        Math.round((i.position.x + iLength / 2) * 1000000 + Number.EPSILON) /
        1000000;
      if (
        i.position.z + 0.01 >= holePosZ &&
        i.position.z - 0.01 <= holePosZ &&
        holePosX * -1 >= iTopX &&
        holePosX * -1 <= iBottomX
      ) {
        holePosZ = holePosZ + 0.02;
      }
    });

    return holePosZ;
  }

  function saveSVGs() {
  
    // create an array of points from the dimensions and divider properties to draw the svg lines between
    let points = [];
    let yPos = baseThickness / 2;

    let xPos1 =
      Math.round(
        ((insertWidth / 2) * -1 + boardThickness) * 1000000 + Number.EPSILON,
      ) / 1000000;
    let xPos2 =
      Math.round(
        (insertWidth / 2 - boardThickness) * 1000000 + Number.EPSILON,
      ) / 1000000;
    let zPos1 =
      Math.round(
        ((insertDepth / 2) * -1 + boardThickness) * 1000000 + Number.EPSILON,
      ) / 1000000;
    let zPos2 =
      Math.round(
        (insertDepth / 2 - boardThickness) * 1000000 + Number.EPSILON,
      ) / 1000000;

    points.push({ x: xPos1, y: yPos, z: zPos1 });
    points.push({ x: xPos2, y: yPos, z: zPos1 });
    points.push({ x: xPos2, y: yPos, z: zPos2 });
    points.push({ x: xPos1, y: yPos, z: zPos2 });

    // create an array of points for holes to be drilled, flipped left to right to be drilled from bottom
    // back divider
    let holes = [];

    //console.log("checking back divider");
    let xHolePos =
      Math.round(((insertWidth / 2) * -1 + 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    let zHolePos =
      Math.round(
        ((insertDepth / 2) * -1 + boardThickness / 2) * 1000000 +
          Number.EPSILON,
      ) / 1000000;
    // check if potential hole in horizontal back piece is the same spot as the end of a full or partial vertical divider
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    xHolePos =
      Math.round((insertWidth / 2 - 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    let holeHorizSpacing = (insertWidth - 0.0381 * 2) / 3 / 2;

    xHolePos =
      Math.round(holeHorizSpacing * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    xHolePos =
      Math.round(holeHorizSpacing * -1 * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    // front divider
    //console.log("checking front divider");
    xHolePos =
      Math.round(((insertWidth / 2) * -1 + 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    zHolePos =
      Math.round(
        (insertDepth / 2 - boardThickness / 2) * 1000000 + Number.EPSILON,
      ) / 1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    xHolePos =
      Math.round((insertWidth / 2 - 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    xHolePos =
      Math.round(holeHorizSpacing * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    xHolePos =
      Math.round(holeHorizSpacing * -1 * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

    // left divider,flipped left to right to be drilled from bottom
    //console.log("checking left divider");
    xHolePos =
      Math.round(
        (insertWidth / 2 - boardThickness / 2) * 1000000 + Number.EPSILON,
      ) / 1000000;
    zHolePos =
      Math.round((insertDepth / 2 - 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    zHolePos =
      Math.round(((insertDepth / 2) * -1 + 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    let holeVertSpacing = (insertDepth - 0.0381 * 2) / 3 / 2;

    zHolePos = Math.round(holeVertSpacing * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    zHolePos =
      Math.round(holeVertSpacing * -1 * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    // right divider, flipped left to right to be drilled from bottom
    //console.log("checking right divider");
    xHolePos =
      Math.round(
        ((insertWidth / 2) * -1 + boardThickness / 2) * 1000000 +
          Number.EPSILON,
      ) / 1000000;
    zHolePos =
      Math.round((insertDepth / 2 - 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    zHolePos =
      Math.round(((insertDepth / 2) * -1 + 0.0381) * 1000000 + Number.EPSILON) /
      1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    zHolePos = Math.round(holeVertSpacing * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    zHolePos =
      Math.round(holeVertSpacing * -1 * 1000000 + Number.EPSILON) / 1000000;
    holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

    fullVertDivGroup.forEach((i) => {
      xPos1 =
        Math.round(
          (i.position.x - boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;
      xPos2 =
        Math.round(
          (i.position.x + boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;
      zPos1 =
        Math.round(
          (i.geometry.boundingBox.max.x - boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      zPos2 =
        Math.round(
          (i.geometry.boundingBox.min.x + boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;

      points.push({ x: xPos1, y: yPos, z: zPos1 });
      points.push({ x: xPos1, y: yPos, z: zPos2 });
      points.push({ x: xPos2, y: yPos, z: zPos1 });
      points.push({ x: xPos2, y: yPos, z: zPos2 });

      fullHorizDivGroup.forEach((j) => {
        // add 4 points where any full horizontals meet this full vertical
        xPos1 =
          Math.round(
            (i.position.x - boardThickness / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        xPos2 =
          Math.round(
            (i.position.x + boardThickness / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        zPos1 =
          Math.round(
            (j.position.z - boardThickness / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;
        zPos2 =
          Math.round(
            (j.position.z + boardThickness / 2) * 1000000 + Number.EPSILON,
          ) / 1000000;

        points.push({ x: xPos1, y: yPos, z: zPos1 });
        points.push({ x: xPos1, y: yPos, z: zPos2 });
        points.push({ x: xPos2, y: yPos, z: zPos1 });
        points.push({ x: xPos2, y: yPos, z: zPos2 });
      });

      //console.log("checking full vert divider " + i.name);
      //full divider should have 3 holes, 1 1 1/2 - 2 inches from the end and then 1 centered.
      //flipped left to right to be drilled from bottom
      xHolePos =
        Math.round(i.position.x * -1 * 1000000 + Number.EPSILON) / 1000000;
      zHolePos =
        Math.round(
          (i.geometry.boundingBox.max.x - 0.0381) * 1000000 + Number.EPSILON,
        ) / 1000000;
      holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

      zHolePos =
        Math.round(
          (i.geometry.boundingBox.min.x + 0.0381) * 1000000 + Number.EPSILON,
        ) / 1000000;
      holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, zHolePos) });

      // a hole in the middle of the full vertical divider
      holes.push({ x: xHolePos, z: checkHorizHole(xHolePos, 0) });
    });

    fullHorizDivGroup.forEach((i) => {
      // add 4 points where any full horizontals meet this full vertical
      xPos1 =
        Math.round(
          (i.geometry.boundingBox.max.x - boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      xPos2 =
        Math.round(
          (i.geometry.boundingBox.min.x + boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      zPos1 =
        Math.round(
          (i.position.z - boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;
      zPos2 =
        Math.round(
          (i.position.z + boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;

      points.push({ x: xPos1, y: yPos, z: zPos1 });
      points.push({ x: xPos1, y: yPos, z: zPos2 });
      points.push({ x: xPos2, y: yPos, z: zPos1 });
      points.push({ x: xPos2, y: yPos, z: zPos2 });

      //console.log("checking full horiz divider " + i.name);
      //full divider should have 3 holes, 1 1 1/2 - 2 inches from the end and then 1 centered.
      //flipped left to right to be drilled from bottom, makes no difference for full horizontals
      xHolePos =
        Math.round(
          (i.geometry.boundingBox.max.x - 0.0381) * -1 * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      zHolePos = Math.round(i.position.z * 1000000 + Number.EPSILON) / 1000000;
      holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

      xHolePos =
        Math.round(
          (i.geometry.boundingBox.min.x + 0.0381) * -1 * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      holes.push({ x: checkVertHole(xHolePos, zHolePos), z: zHolePos });

      // a hole in the middle of the full vertical divider
      holes.push({ x: checkVertHole(0, zHolePos), z: zHolePos });
    });

    spanVertDivGroup.forEach((i) => {
      const divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;

      xPos1 =
        Math.round(
          (i.position.x - boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;
      xPos2 =
        Math.round(
          (i.position.x + boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;
      zPos1 =
        Math.round(
          (i.position.z - divLength / 2 + boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      zPos2 =
        Math.round(
          (i.position.z + divLength / 2 - boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;

      points.push({ x: xPos1, y: yPos, z: zPos1 });
      points.push({ x: xPos1, y: yPos, z: zPos2 });
      points.push({ x: xPos2, y: yPos, z: zPos1 });
      points.push({ x: xPos2, y: yPos, z: zPos2 });

      // two holes evenly spaced if the partial divider is longer than 25cm
      // one hole centered if less than 25cm
      if (divLength > 0.25) {
        xHolePos =
          Math.round(i.position.x * -1 * 1000000 + Number.EPSILON) / 1000000;

        const holeSpanVertSpacing = divLength / 3 / 2;

        zHolePos =
          Math.round(
            (i.position.z - holeSpanVertSpacing) * 1000000 + Number.EPSILON,
          ) / 1000000;
        holes.push({ x: xHolePos, z: zHolePos });

        zHolePos =
          Math.round(
            (i.position.z + holeSpanVertSpacing) * 1000000 + Number.EPSILON,
          ) / 1000000;
        holes.push({ x: xHolePos, z: zHolePos });
      } else {
        xHolePos =
          Math.round(i.position.x * -1 * 1000000 + Number.EPSILON) / 1000000;
        zHolePos =
          Math.round(i.position.z * 1000000 + Number.EPSILON) / 1000000;
        holes.push({ x: xHolePos, z: zHolePos });
      }
    });

    const allHorizSpan = spanHorizDivGroup.concat(knifeblockBladeGroup, knifeblockHandleGroup, knifeblockLargeBladeGroup, knifeblockLargeHandleGroup, knifeblockLargeHandle2Group);

    allHorizSpan.forEach((i) => {
      const divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;

      xPos1 =
        Math.round(
          (i.position.x - divLength / 2 + boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      xPos2 =
        Math.round(
          (i.position.x + divLength / 2 - boardThickness) * 1000000 +
            Number.EPSILON,
        ) / 1000000;
      zPos1 =
        Math.round(
          (i.position.z - boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;
      zPos2 =
        Math.round(
          (i.position.z + boardThickness / 2) * 1000000 + Number.EPSILON,
        ) / 1000000;

      points.push({ x: xPos1, y: yPos, z: zPos1 });
      points.push({ x: xPos2, y: yPos, z: zPos1 });
      points.push({ x: xPos1, y: yPos, z: zPos2 });
      points.push({ x: xPos2, y: yPos, z: zPos2 });

      // two holes evenly spaced if the partial divider is longer than 25cm
      // one hole centered if less than 25cm
      if (divLength > 0.25) {
        zHolePos =
          Math.round(i.position.z * 1000000 + Number.EPSILON) / 1000000;

        const holeSpanHorizSpacing = divLength / 3 / 2;

        xHolePos =
          Math.round(
            (i.position.x - holeSpanHorizSpacing) * -1 * 1000000 +
              Number.EPSILON,
          ) / 1000000;
        holes.push({ x: xHolePos, z: zHolePos });

        xHolePos =
          Math.round(
            (i.position.x + holeSpanHorizSpacing) * -1 * 1000000 +
              Number.EPSILON,
          ) / 1000000;
        holes.push({ x: xHolePos, z: zHolePos });
      } else {
        xHolePos =
          Math.round(i.position.x * -1 * 1000000 + Number.EPSILON) / 1000000;
        zHolePos =
          Math.round(i.position.z * 1000000 + Number.EPSILON) / 1000000;
        holes.push({ x: xHolePos, z: zHolePos });
      }
    });

    let vsortedPoints = [...points];

    // sort the points on z and then x
    points.sort(function (a, b) {
      return a.z - b.z || a.x - b.x;
    });

    // sort the points on z and then x
    vsortedPoints.sort(function (a, b) {
      return a.x - b.x || a.z - b.z;
    });
    // 1mm ≅ 3.7795px or user units
    // 1 px = 0.26458333 mm

    //let unitMultiplier = 2834.71;
    let unitMultiplier = 3545; // manually fine tuned for vcurve pro
    //let unitMultLaser = 3779.52;
    // 1in = 96px or user units
    // 1in = 25.4mm
    // 25.4mm = 96px

    let xOffset = 276.38;
    let yOffset = 292.7;

    // use a template to create a svg file based on the baseMesh geometry

    let xmlString =
      '<?xml version="1.0" encoding="utf-8"?>\n' +
      "<!-- Generator: drawer insert designer v0.1  -->\n" +
      '<svg width="4000" height="4000" viewBox="0.00000000 0.00000000 4000 4000" id="svg2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape">\n' +
      '<style type="text/css">\n' +
      "	.st0{fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;}\n" +
      "</style>\n";

    const insertWidthSVG = insertWidth * unitMultiplier;
    const insertDepthSVG = insertDepth * unitMultiplier;

    xmlString =
      xmlString +
      '    <g inkscape:groupmode="layer" id="a74eb484-e48a-4f48-b3cb-f9311b9b35a6" inkscape:label="LINE_15_" style="stroke:#000000;">\n' +
      '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';

    xmlString =
      xmlString +
      xOffset +
      "," +
      yOffset +
      " L " +
      (xOffset + insertWidthSVG).toFixed(2) +
      "," +
      yOffset;
    xmlString =
      xmlString +
      " L " +
      (xOffset + insertWidthSVG).toFixed(2) +
      "," +
      (yOffset + insertDepthSVG).toFixed(2);
    xmlString =
      xmlString + " L " + xOffset + "," + (yOffset + insertDepthSVG).toFixed(2);
    xmlString = xmlString + " L " + xOffset + "," + yOffset + '"/>\n';
    xmlString = xmlString + "    </g>\n";

    // loop through the points creating a horizinontal line for each pair of points
    let baseLineNum = 12;
    let i = 0;
    for (i = 0; i < points.length; i = i + 2) {
      let newX1 = (
        (points[i].x * -1 + insertWidth / 2) * unitMultiplier +
        276.38
      ).toFixed(2);
      let newX2 = (
        (points[i + 1].x * -1 + insertWidth / 2) * unitMultiplier +
        276.38
      ).toFixed(2);
      let newY1 = (
        (points[i].z + insertDepth / 2) * unitMultiplier +
        292.7
      ).toFixed(2);
      let newY2 = (
        (points[i + 1].z + insertDepth / 2) * unitMultiplier +
        292.7
      ).toFixed(2);

      xmlString =
        xmlString +
        '<g id="LINE_' +
        baseLineNum +
        '_">\n' +
        '	<line class="st0" x1="' +
        newX1 +
        '" y1="' +
        newY1 +
        '" x2="' +
        newX2 +
        '" y2="' +
        newY2 +
        '"/>\n' +
        "</g>\n";
      baseLineNum++;
    }

    // loop through the points creating a vertical line for each pair of points
    let j = 0;
    for (j = 0; j < vsortedPoints.length; j = j + 2) {
      let newX1 = (
        (vsortedPoints[j].x * -1 + insertWidth / 2) * unitMultiplier +
        276.38
      ).toFixed(2);
      let newX2 = (
        (vsortedPoints[j + 1].x * -1 + insertWidth / 2) * unitMultiplier +
        276.38
      ).toFixed(2);
      let newY1 = (
        (vsortedPoints[j].z + insertDepth / 2) * unitMultiplier +
        292.7
      ).toFixed(2);
      let newY2 = (
        (vsortedPoints[j + 1].z + insertDepth / 2) * unitMultiplier +
        292.7
      ).toFixed(2);

      xmlString =
        xmlString +
        '<g id="LINE_' +
        baseLineNum +
        '_">\n' +
        '	<line class="st0" x1="' +
        newX1 +
        '" y1="' +
        newY1 +
        '" x2="' +
        newX2 +
        '" y2="' +
        newY2 +
        '"/>\n' +
        "</g>\n";
      baseLineNum++;
    }

    //console.log(holes);

    // loop through the holes and create a 1/8" or 3.175mm circle for each
    let k = 0;
    for (k = 0; k < holes.length; k++) {
      //<circle cx="25" cy="75" r="20"/>

      let newX1 = (
        (holes[k].x + insertWidth / 2) * unitMultiplier +
        xOffset
      ).toFixed(2);
      let newY1 = (
        (holes[k].z + insertDepth / 2) * unitMultiplier +
        yOffset
      ).toFixed(2);

      // console.log(holes[k].x);
      // console.log(holes[k].z);
      // console.log(newX1);
      // console.log(newY1);

      xmlString =
        xmlString +
        '<g id="LINE_' +
        baseLineNum +
        '_">\n' +
        '	<circle class="st0" cx="' +
        newX1 +
        '" cy="' +
        newY1 +
        '" r="5"/>\n' +
        "</g>\n";
      baseLineNum++;
    }

    let xmlBaseString = xmlString + "</svg>";

    var svgBaseFile = xmlBaseString;

    let baseSVGFilename = "my.drawer.insert.base.svg";

    // ***************************
    // DONE creating the Base xml. now create the Sides xml
    //***************************

    // build an array of all of the Dividers to loop through
    let divsToSave = [];
    divsToSave.push(drawer_insert.children[1]);
    divsToSave.push(drawer_insert.children[2]);
    divsToSave.push(drawer_insert.children[3]);
    divsToSave.push(drawer_insert.children[4]);
    Array.prototype.push.apply(divsToSave, fullHorizDivGroup);
    Array.prototype.push.apply(divsToSave, spanHorizDivGroup);
    Array.prototype.push.apply(divsToSave, fullVertDivGroup);
    Array.prototype.push.apply(divsToSave, spanVertDivGroup);
    Array.prototype.push.apply(divsToSave, knifeblockBladeGroup);
    Array.prototype.push.apply(divsToSave, knifeblockHandleGroup);
    Array.prototype.push.apply(divsToSave, knifeblockLargeBladeGroup);
    Array.prototype.push.apply(divsToSave, knifeblockLargeHandleGroup);
    Array.prototype.push.apply(divsToSave, knifeblockLargeHandle2Group);

    xOffset = 20;
    yOffset = 40;

    // 1mm ≅ 3.7795px or user units
    // 1 px = 0.26458333 mm

    let unitMultLaser = 3779.52;

    let xmlDivString =
      '<?xml version="1.0" encoding="utf-8"?>\n' +
      "<!-- Generator: drawer insert designer v0.1  -->\n" +
      '<svg width="5000" height="9000" viewBox="0.00000000 0.00000000 5000 6000" id="svg2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape">\n';

    //Use a Best Fit bin packing algorithm to layout the sides on the 2' x 4' pieces with as little waste as possible. The sides must go legthwise with the grain of the wood.

    //the general steps are:
    //- sort the sides in descending order
    //- create an initial bin
    //- loop through the sides placing them in the box with the maximum load in which it fits.
    //- if the side doesn't fit in any box then add a new one and place the side in that.
    //- the spicerack insert is a fixed height, if there are spiceracks create a new box for them

    // create an initial 2' x 4' rectangle 2' = 609.6mm, 4' = 1219.2mm
    let binNum = 0;
    let binRow = [];
    binRow[binNum] = 0;
    const binWidth = 1.2192;
    const binWidthSVG = binWidth * unitMultLaser;
    const binHeight = 0.6096;
    const binHeightSVG = binHeight * unitMultLaser;
    const binGap = 0.05;
    const binGapSVG = 0.05 * unitMultLaser;

    xmlDivString =
      xmlDivString +
      '    <g inkscape:groupmode="layer" id="a74eb484-e48a-4f48-b3cb-f9311b9b35a6" inkscape:label="LINE_15_" style="stroke:#000000;">\n' +
      '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';

    xmlDivString =
      xmlDivString +
      xOffset +
      "," +
      yOffset +
      " L " +
      (xOffset + binWidthSVG).toFixed(2) +
      "," +
      yOffset;
    xmlDivString =
      xmlDivString +
      " L " +
      (xOffset + binWidthSVG).toFixed(2) +
      "," +
      (yOffset + binHeightSVG).toFixed(2);
    xmlDivString =
      xmlDivString +
      " L " +
      xOffset +
      "," +
      (yOffset + binHeightSVG).toFixed(2);
    xmlDivString = xmlDivString + " L " + xOffset + "," + yOffset + '"/>\n';
    xmlDivString = xmlDivString + "    </g>\n";

    // sort the dividers on length in descending order
    divsToSave.sort(function (a, b) {
      return (
        b.geometry.boundingBox.max.x -
        b.geometry.boundingBox.min.x -
        (a.geometry.boundingBox.max.x - a.geometry.boundingBox.min.x)
      );
    });


    // write the total length of the dividers to the space below the first box
    let totalLength = 0;

    i = 0;
    for (i = 0; i < divsToSave.length; i++) {
      totalLength =
        totalLength +
        (divsToSave[i].geometry.boundingBox.max.x -
          divsToSave[i].geometry.boundingBox.min.x);
    }

    // convert from cm to inches
    totalLength = totalLength * 39.3701;

    xmlDivString =
      xmlDivString +
      '    <text x="' +
      xOffset +
      '" y="' +
      (yOffset + binHeightSVG + 50).toFixed(2) +
      '" font-size="2em">Linear material needed: ' +
      totalLength.toFixed(0) +
      '"</text>\n';

    

    // create an parallel array with the offsets of each divider using the model units
    let divsToSaveOffsets = [];
    let divAdded = false;

    // loop through the dividers and build the parallel array
    let m = 0;
    for (m = 0; m < divsToSave.length; m++) {
      //console.log("starting main loop, last binNum = " + binNum + " binRow = " + binRow[binNum]);
      divAdded = false;
      const divLength =
        divsToSave[m].geometry.boundingBox.max.x -
        divsToSave[m].geometry.boundingBox.min.x;

      // if this is the first divider then start the bottom left of the first bin
      if (divsToSaveOffsets.length == 0) {
        //console.log("adding first divider");
        divsToSaveOffsets[m] = {
          lx: 0.01,
          ly: binHeight - divHeight - 0.01,
          rx: 0.01 + divLength,
          ry: binHeight - divHeight - 0.01,
        };
        //console.log(divsToSaveOffsets[m]);
        continue;
      } else {
        // loop through the each row of each bin and find the furthest right x value
        let b = 0;
        for (b = 0; b < binRow.length; b++) {
          //console.log("checking bin: " + b + " binRow[" + b + "]: " + binRow[b]);
          let n = 0;
          for (n = 0; n <= binRow[b]; n++) {
            // loop through the saved offsets see if this divider can be added to the row
            //console.log("\tchecking row: " + n + " of bin: " + b);
            let furthestRight = 0;
            let p = 0;
            for (p = 0; p < divsToSaveOffsets.length; p++) {
              if (
                divsToSaveOffsets[p].ry ==
                (b + 1) * binHeight +
                  b * binGap -
                  (n + 1) * divHeight -
                  (n + 1) * 0.01
              ) {
                if (divsToSaveOffsets[p].rx > furthestRight) {
                  furthestRight = divsToSaveOffsets[p].rx;
                  // console.log("setting furthestRight= " + furthestRight);
                }
              }
            }
            // check if there is room in this row for this divider
            if (binWidth - furthestRight > divLength + 0.02) {
              // console.log("furthestRight= " + furthestRight);
              let newLy =
                (b + 1) * binHeight +
                b * binGap -
                (n + 1) * divHeight -
                (n + 1) * 0.01;

              divsToSaveOffsets[m] = {
                lx: furthestRight + 0.01,
                ly: newLy,
                rx: furthestRight + 0.01 + divLength,
                ry: newLy,
              };

              //console.log("added div to this row, breaking from offset loop");
              // console.log(divsToSaveOffsets[m]);
              divAdded = true;
              break;
            }
            //break out of row loop back to the loop through the bins
            if (divAdded == true) {
              // console.log("added div to existing row, breaking from row loop");
              break;
            }
          } // end of loop through rows
          //break out of bin loop back to the loop through the dividers
          if (divAdded == true) {
            //console.log("added div to existing row, breaking from bin loop");
            break;
          }
        } // end of loop through bins
      }

      //continue on to the next divider in the loop
      if (divAdded == true) {
        //console.log("added div, continue on to the next divider.");
        continue;
      }

      // couldn't find a spot in the existing bins and rows, add a new row and add this divider to it.

      // check if there is room in this bin for a new row otherwise add a new bin
      // newY is the y value for the new row if it is in the same bin
      let newY =
        (binNum + 1) * binHeight +
        binNum * binGap -
        (binRow[binNum] + 2) * divHeight -
        (binRow[binNum] + 2) * 0.01;

      // the that newY fits in the current bin, if not then add a new bin
      if (newY < binNum * binHeight + binNum * binGap + 0.01) {
        // add a new bin with this as the first divider

        binNum++;
        binRow[binNum] = 0;
        
        const newBinYoffsetSVG =
          binNum * binHeightSVG + yOffset + binNum * binGapSVG;
        const newBinYoffset =
          binNum * binHeight + binNum * binGap + binHeight - divHeight - 0.01;

        xmlDivString =
          xmlDivString +
          '    <g inkscape:groupmode="layer" id="a74eb484-e48a-4f48-b3cb-f9311b9b35a6" inkscape:label="LINE_15_" style="stroke:#000000;">\n' +
          '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';

        xmlDivString = xmlDivString + xOffset + "," + newBinYoffsetSVG + " L " + (xOffset + binWidthSVG).toFixed(2) + "," + newBinYoffsetSVG;
        xmlDivString = xmlDivString + " L " + (xOffset + binWidthSVG).toFixed(2) + "," + (newBinYoffsetSVG + binHeightSVG).toFixed(2);
        xmlDivString = xmlDivString + " L " + xOffset + "," + (newBinYoffsetSVG + binHeightSVG).toFixed(2);
        xmlDivString = xmlDivString + " L " + xOffset + "," + newBinYoffsetSVG + '"/>\n';
        xmlDivString = xmlDivString + "    </g>\n";

        divsToSaveOffsets[m] = {
          lx: 0.01,
          ly: newBinYoffset,
          rx: 0.01 + divLength,
          ry: newBinYoffset,
        };

      } else {
        // add the divider to a new row in this bin
        divsToSaveOffsets[m] = {
          lx: 0.01,
          ly: newY,
          rx: 0.01 + divLength,
          ry: newY,
        };
        binRow[binNum]++;
        // console.log("added div to new row = " + binRow[binNum]);
        // console.log(divsToSaveOffsets[m]);
      }
    }

    // Do any spiceracks last in a new bin as they are a fixed height.
    if ( spicerackInsertGroup.length != 0 ) {

      const spicerackOffsetStart = divsToSave.length;

      Array.prototype.push.apply(divsToSave, spicerackInsertGroup);

      binNum++;
      binRow[binNum] = 0;
      // console.log("adding a new bin # = " + binNum);
      const newBinYoffsetSVG =
        binNum * binHeightSVG + yOffset + binNum * binGapSVG;
      const newBinYoffset =
        binNum * binHeight + binNum * binGap + binHeight - spicerackInsertDepth - 0.01;

      xmlDivString =
        xmlDivString +
        '    <g inkscape:groupmode="layer" id="a74eb484-e48a-4f48-b3cb-f9311b9b35a6" inkscape:label="LINE_15_" style="stroke:#000000;">\n' +
        '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';

      xmlDivString = xmlDivString + xOffset + "," + newBinYoffsetSVG + " L " + (xOffset + binWidthSVG).toFixed(2) + "," + newBinYoffsetSVG;
      xmlDivString = xmlDivString + " L " + (xOffset + binWidthSVG).toFixed(2) + "," + (newBinYoffsetSVG + binHeightSVG).toFixed(2);
      xmlDivString = xmlDivString + " L " + xOffset + "," + (newBinYoffsetSVG + binHeightSVG).toFixed(2);
      xmlDivString = xmlDivString + " L " + xOffset + "," + newBinYoffsetSVG + '"/>\n';
      xmlDivString = xmlDivString + "    </g>\n";

      // write the total length of the dividers to the space below the first box
      let totalLength = 0;

      i = 0;
      for (i = 0; i < spicerackInsertGroup.length; i++) {
        totalLength =
          totalLength +
          (spicerackInsertGroup[i].geometry.boundingBox.max.x -
            spicerackInsertGroup[i].geometry.boundingBox.min.x);
      }

      // convert from cm to inches
      totalLength = totalLength * 39.3701;

      xmlDivString =
        xmlDivString +
        '    <text x="' +
        xOffset +
        '" y="' +
        (newBinYoffsetSVG + binHeightSVG + 50).toFixed(2) +
        '" font-size="2em">Linear material needed for spiceracks: ' +
        totalLength.toFixed(0) +
        '"</text>\n';

    

    
      // add to the parallel array with the offsets of each spicerack insert using the model units
      m = 0;
      for (m = 0; m < spicerackInsertGroup.length; m++) {
        //console.log("doing spicerack m = " + m);

        divAdded = false;

        const spicerackLength =
        spicerackInsertGroup[m].geometry.boundingBox.max.x -
        spicerackInsertGroup[m].geometry.boundingBox.min.x;
     
        // if this is the first divider then start the bottom left of the first bin
        if (m == 0) {
          //console.log("adding first divider");
          divsToSaveOffsets[spicerackOffsetStart] = {
            lx: 0.01,
            ly: binNum * binHeight + binNum * binGap + binHeight - spicerackInsertDepth - 0.01,
            rx: 0.01 + spicerackLength,
            ry: binNum * binHeight + binNum * binGap + binHeight - spicerackInsertDepth - 0.01,
          };
          //console.log(divsToSaveOffsets[m]);
          continue;
        } else {
          // loop through the each row of each bin and find the furthest right x value
          let b = binNum;
          for (b = binNum; b < binRow.length; b++) {
            //console.log("checking bin: " + b + " binRow[" + b + "]: " + binRow[b]);
            let n = 0;
            for (n = 0; n <= binRow[b]; n++) {
              // loop through the saved offsets see if this divider can be added to the row
              //console.log("\tchecking row: " + n + " of bin: " + b);
              let furthestRight = 0;
              let p = spicerackOffsetStart;
              for (p = spicerackOffsetStart; p < divsToSaveOffsets.length; p++) {
                //console.log("\tchecking offset: " + p);
                //debugger;
                if (
                  divsToSaveOffsets[p].ry ==
                  (b + 1) * binHeight +
                    b * binGap -
                    (n + 1) * spicerackInsertDepth -
                    (n + 1) * 0.01
                ) {
                  if (divsToSaveOffsets[p].rx > furthestRight) {
                    furthestRight = divsToSaveOffsets[p].rx;
                    //console.log("setting furthestRight= " + furthestRight);
                  }
                }
              }
              // check if there is room in this row for this divider
              if (binWidth - furthestRight > spicerackLength + 0.02) {
                // console.log("furthestRight= " + furthestRight);
                let newLy =
                  (b + 1) * binHeight +
                  b * binGap -
                  (n + 1) * spicerackInsertDepth -
                  (n + 1) * 0.01;

                divsToSaveOffsets[spicerackOffsetStart + m] = {
                  lx: furthestRight + 0.01,
                  ly: newLy,
                  rx: furthestRight + 0.01 + spicerackLength,
                  ry: newLy,
                };

                //console.log("added div to this row, breaking from offset loop");
                //console.log(divsToSaveOffsets[m]);
                divAdded = true;
                break;
              }
              //break out of row loop back to the loop through the bins
              if (divAdded == true) {
                // console.log("added div to existing row, breaking from row loop");
                break;
              }
            } // end of loop through rows
            //break out of bin loop back to the loop through the dividers
            if (divAdded == true) {
              //console.log("added div to existing row, breaking from bin loop");
              break;
            }
          } // end of loop through bins
        }
        
        //continue on to the next divider in the loop
        if (divAdded == true) {
          //console.log("added div, continue on to the next divider.");
          continue;
        }

        // couldn't find a spot in the existing bins and rows, add a new row and add this divider to it.

        // check if there is room in this bin for a new row otherwise add a new bin
        // newY is the y value for the new row if it is in the same bin
        let newY =
          (binNum + 1) * binHeight +
          binNum * binGap -
          (binRow[binNum] + 2) * spicerackInsertDepth -
          (binRow[binNum] + 2) * 0.01;

        // the that newY fits in the current bin, if not then add a new bin
        if (newY < binNum * binHeight + binNum * binGap + 0.01) {
          // add a new bin with this as the first divider

          binNum++;
          binRow[binNum] = 0;
          
          const newBinYoffsetSVG =
            binNum * binHeightSVG + yOffset + binNum * binGapSVG;
          const newBinYoffset =
            binNum * binHeight + binNum * binGap + binHeight - spicerackInsertDepth - 0.01;

          xmlDivString =
            xmlDivString +
            '    <g inkscape:groupmode="layer" id="a74eb484-e48a-4f48-b3cb-f9311b9b35a6" inkscape:label="LINE_15_" style="stroke:#000000;">\n' +
            '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';

          xmlDivString = xmlDivString + xOffset + "," + newBinYoffsetSVG + " L " + (xOffset + binWidthSVG).toFixed(2) + "," + newBinYoffsetSVG;
          xmlDivString = xmlDivString + " L " + (xOffset + binWidthSVG).toFixed(2) + "," + (newBinYoffsetSVG + binHeightSVG).toFixed(2);
          xmlDivString = xmlDivString + " L " + xOffset + "," + (newBinYoffsetSVG + binHeightSVG).toFixed(2);
          xmlDivString = xmlDivString + " L " + xOffset + "," + newBinYoffsetSVG + '"/>\n';
          xmlDivString = xmlDivString + "    </g>\n";

          divsToSaveOffsets[spicerackOffsetStart + m] = {
            lx: 0.01,
            ly: newBinYoffset,
            rx: 0.01 + spicerackLength,
            ry: newBinYoffset,
          };
          //console.log("added div to new bin = " + binRow[binNum]);
          //console.log(divsToSaveOffsets[m]);

        } else {
          // add the divider to a new row in this bin
          divsToSaveOffsets[spicerackOffsetStart + m] = {
            lx: 0.01,
            ly: newY,
            rx: 0.01 + spicerackLength,
            ry: newY,
          };
          binRow[binNum]++;
          //console.log("added div to new row = " + binRow[binNum]);
          //console.log(divsToSaveOffsets[m]);
        }
      } // end spicerack section
    } // end of loop through the dividers and building the Offset parallel array



    // **************
    // loop through the dividers and create the svg lines
    // **************
    m = 0;
    for (m = 0; m < divsToSave.length; m++) {
      //console.log("writing svg for " + divsToSave[m].name);

      let divPosAttr = divsToSave[m].geometry.getAttribute("position");
      let divNormAttr = divsToSave[m].geometry.getAttribute("normal");

      let divPoints = [];
      //let divNorms = [];
      const divLength =
        divsToSave[m].geometry.boundingBox.max.x -
        divsToSave[m].geometry.boundingBox.min.x;

      const divHeight = divsToSave[m].geometry.boundingBox.max.y - divsToSave[m].geometry.boundingBox.min.y;

      let k = 0;
      for (k = 0; k < divPosAttr.count; k++) {
        // let xDivPos = Math.round( +divPosAttr.getX(k) * 1000000 + Number.EPSILON ) / 1000000;
        // let yDivPos = Math.round( +divPosAttr.getY(k) * 1000000 + Number.EPSILON ) / 1000000;
        // let zDivPos = Math.round( +divPosAttr.getZ(k) * 1000000 + Number.EPSILON ) / 1000000;

        let xDivPos = +divPosAttr.getX(k).toFixed(6);
        let yDivPos = +divPosAttr.getY(k).toFixed(6);
        let zDivPos = +divPosAttr.getZ(k).toFixed(6);

        // if the points are in the front layer add them to an array without duplicates
        let duplicateFound = false;

        if (zDivPos == boardThickness / 2) {
          let l = 0;
          for (l = 0; l < divPoints.length; l++) {
            if (
              divPoints[l].x == xDivPos &&
              divPoints[l].y == yDivPos &&
              divPoints[l].z == zDivPos
            ) {
              duplicateFound = true;
              continue;
            }
          }

          if (duplicateFound == false && divNormAttr.getZ(k) == 0) {
            //console.log(". push to divPoints x = " + xDivPos + " y = " + yDivPos + " z = " + zDivPos)
            divPoints.push({ x: xDivPos, y: yDivPos, z: zDivPos });
          }
        }
        duplicateFound = false;
      }

      let vsortedDivPoints = [...divPoints];

      // sort the points on y and then x
      divPoints.sort(function (a, b) {
        return a.y - b.y || a.x - b.x;
      });

      // check if this divider has a cutaway and if so remove all of the
      // curve points and the line with the cutaway.
      let hasCutaway = false;
      var cutAwayDiameter, cutAwayXStart;

      i = 0;
      for (i = 0; i < divsWithCutaway.length; i++) {
        if (divsToSave[m] == divsWithCutaway[i]) {
          hasCutaway = true;
          //console.log("the divider " + divsToSave[m].name + " has a cutaway");

          divsToSave[m].geometry.computeBoundingBox();
          let divLength =
            divsToSave[m].geometry.boundingBox.max.x -
            divsToSave[m].geometry.boundingBox.min.x;
          //divLength = Math.round( divLength * 1000000 + Number.EPSILON ) / 1000000;
          cutAwayDiameter =
            (divsToSave[m].geometry.boundingBox.max.x -
              divsToSave[m].geometry.boundingBox.min.x) /
            2;
          cutAwayDiameter =
            Math.round(cutAwayDiameter * 1000000 + Number.EPSILON) / 1000000;
          cutAwayXStart =
            divsToSave[m].geometry.boundingBox.min.x +
            (divsToSave[m].geometry.boundingBox.max.x -
              divsToSave[m].geometry.boundingBox.min.x) /
              4;
          cutAwayXStart =
            Math.round(cutAwayXStart * 1000000 + Number.EPSILON) / 1000000;

          // remove the 7th point (index 6) where x = 0 from divPoints
          if (divPoints[6].x == 0) {
            divPoints.splice(6, 1);
          }

          let regDivPoints = [];

          let notchHeight =
            Math.round(
              (divHeight / 2 - boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;

          i = 0;
          for (i = 0; i < divPoints.length; i++) {
            //console.log("checking divPoints[i].y = " + divPoints[i].y + " for: " + notchHeight);

            if (
              divPoints[i].y <= 0 ||
              (divPoints[i].y >= notchHeight - 0.000001 &&
                divPoints[i].y <= notchHeight)
            ) {
              //console.log("  adding divPoints[i].y = " + divPoints[i].y);
              regDivPoints.push(divPoints[i]);
            }
          }

          // add points to draw lines before and after the openings left for the cutouts
          const py =
            Math.round((divHeight / 2) * 1000000 + Number.EPSILON) / 1000000;
          const p1x =
            Math.round(
              (-(divLength / 2) + boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p2x =
            Math.round(-cutAwayXStart * 1000000 + Number.EPSILON) / 1000000;
          const p3x =
            Math.round(
              (divLength / 2 - boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p4x =
            Math.round(cutAwayXStart * 1000000 + Number.EPSILON) / 1000000;

          //console.log("  divLength = " + divLength);
          //console.log("  ((divLength / 2) - boardThickness) = " + ((divLength / 2) - boardThickness));
          //console.log("  rounded = " + p3x);

          regDivPoints.push({ x: p1x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p2x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p3x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p4x, y: py, z: boardThickness / 2 });

          divPoints = [...regDivPoints];
        }
      }


      // check if this divider is a knifeblock blade divider and if so remove all of the
      // the slots.
      let isKnifeblockBlade = false;
      var numBladeSlots, outsideBladeOffset;

      let bladeDivs = knifeblockBladeGroup.concat(knifeblockLargeBladeGroup);

      let n = 0;
      for (n = 0; n < bladeDivs.length; n++) {
        if (divsToSave[m] == bladeDivs[n]) {
          isKnifeblockBlade = true;
          //console.log("the divider " + divsToSave[m].name + " is a knifeblock blade, removing curve points");

          divsToSave[m].geometry.computeBoundingBox();
          let divLength =
            divsToSave[m].geometry.boundingBox.max.x -
            divsToSave[m].geometry.boundingBox.min.x;
          divLength =
            Math.round(divLength * 1000000 + Number.EPSILON) / 1000000;
          numBladeSlots =
            Math.round((divLength - boardThickness * 2) / knifeblockSlotSpacing ) - 1;

          outsideBladeOffset = (divLength - (boardThickness * 2) -
              (knifeblockSlotSpacing * numBladeSlots)) / 2;

          // remove the 7th point (index 6) where x = 0 from divPoints
          if (divPoints[6].x == 0) {
            divPoints.splice(6, 1);
          }

          let regDivPoints = [];

          i = 0;
          for (i = 0; i < divPoints.length; i++) {
            // console.log("checking divPoints[i].y = " + divPoints[i].y + " .x: " + divPoints[i].x);
            // console.log(". left side = " + ((divLength / 2 ) * -1 + boardThickness) + " rs = " + ((divLength / 2 ) - boardThickness) );


            if ( divPoints[i].x <= -(divLength / 2) + boardThickness + 0.0001 ||
                 divPoints[i].x >= (divLength / 2) - boardThickness - 0.0001 ) {
              // console.log("  adding divPoints[i].y = " + divPoints[i].y + " .x: " + divPoints[i].x);
              regDivPoints.push(divPoints[i]);
            }
          }

          // add points to draw lines before and after the openings left for the cutouts
          const py =
            Math.round(
              (knifeblockBladeHeight / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p1x =
            Math.round(
              (-((divLength - boardThickness * 2) / 2) + outsideBladeOffset) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p2x =
            Math.round(
              (((divLength - boardThickness * 2) / 2) - outsideBladeOffset) * 1000000 + Number.EPSILON,
            ) / 1000000;
       

          regDivPoints.push({ x: p1x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p2x, y: py, z: boardThickness / 2 });


          divPoints = [...regDivPoints];

          // i = 0;
          // for (i = 0; i < divPoints.length; i++) {
          //   const geometry = new THREE.SphereGeometry(0.001, 32, 16);
          //   const material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
          //   const sphere = new THREE.Mesh(geometry, material);
          //   scene.add(sphere);
          //   sphere.position.x = divPoints[i].x;
          //   sphere.position.y = divPoints[i].y;
          //   sphere.position.z = divPoints[i].z;
          //   render();
          // }
        }
      }


      // check if this divider is a knifeblock handle and if so remove all of the
      // curve points and the line with the handle curves.
      let isKnifeblockHandle = false;
      let isKnifeblockLargeHandle = false;
      var numHandleSlots, outsideHandleOffset;

      n = 0;
      for (n = 0; n < knifeblockHandleGroup.length; n++) {
        if (divsToSave[m] == knifeblockHandleGroup[n]) {
          isKnifeblockHandle = true;
          //console.log("the divider " + divsToSave[m].name + " is a knifeblock handle, removing curve points");

          divsToSave[m].geometry.computeBoundingBox();
          let divLength =
            divsToSave[m].geometry.boundingBox.max.x -
            divsToSave[m].geometry.boundingBox.min.x;
          divLength =
            Math.round(divLength * 1000000 + Number.EPSILON) / 1000000;
          numHandleSlots =
            Math.round(
              (divLength - boardThickness * 2) / knifeblockSlotSpacing,
            ) - 1;

          outsideHandleOffset =
            (divLength -
              boardThickness * 2 -
              knifeblockSlotSpacing * numHandleSlots) /
            2;

          // remove the 7th point (index 6) where x = 0 from divPoints
          if (divPoints[6].x == 0) {
            divPoints.splice(6, 1);
          }

          let regDivPoints = [];

          let notchHeight =
            Math.round(
              (knifeblockHandleHeight / 2 - boardThickness) * 1000000 +
                Number.EPSILON,
            ) / 1000000;

          i = 0;
          for (i = 0; i < divPoints.length; i++) {
            //console.log("checking divPoints[i].y = " + divPoints[i].y + " for: " + notchHeight);

            if (
              divPoints[i].y <= 0 ||
              (divPoints[i].y >= notchHeight - 0.000001 &&
                divPoints[i].y <= notchHeight)
            ) {
              //console.log("  adding divPoints[i].y = " + divPoints[i].y);
              regDivPoints.push(divPoints[i]);
            }
          }

          // add points to draw lines before and after the openings left for the cutouts
          const py =
            Math.round(
              (knifeblockHandleHeight / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p1x =
            Math.round(
              (-(divLength / 2) + boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p2x =
            Math.round(
              (-((divLength - boardThickness * 2) / 2) + outsideHandleOffset) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;
          const p3x =
            Math.round(
              (divLength / 2 - boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p4x =
            Math.round(
              ((divLength - boardThickness * 2) / 2 - outsideHandleOffset) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;

          regDivPoints.push({ x: p1x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p2x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p3x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p4x, y: py, z: boardThickness / 2 });

          divPoints = [...regDivPoints];

          // i = 0;
          // for (i = 0; i < divPoints.length; i++) {
          //   const geometry = new THREE.SphereGeometry(0.001, 32, 16);
          //   const material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
          //   const sphere = new THREE.Mesh(geometry, material);
          //   scene.add(sphere);
          //   sphere.position.x = divPoints[i].x;
          //   sphere.position.y = divPoints[i].y;
          //   sphere.position.z = divPoints[i].z;
          //   render();
          // }
        }
      }

      n = 0;
      for (n = 0; n < knifeblockLargeHandleGroup.length; n++) {
        if (divsToSave[m] == knifeblockLargeHandleGroup[n]) {
          isKnifeblockHandle = true;
          isKnifeblockLargeHandle = true;
          //console.log("the divider " + divsToSave[m].name + " is a knifeblock handle, removing curve points");

          divsToSave[m].geometry.computeBoundingBox();
          let divLength =
            divsToSave[m].geometry.boundingBox.max.x -
            divsToSave[m].geometry.boundingBox.min.x;
          divLength =
            Math.round(divLength * 1000000 + Number.EPSILON) / 1000000;
          numHandleSlots =
            Math.round(
              (divLength - boardThickness * 2) / knifeblockSlotSpacing,
            ) - 1;

          outsideHandleOffset =
            (divLength -
              boardThickness * 2 -
              knifeblockSlotSpacing * numHandleSlots) /
            2;

          // remove the 7th point (index 6) where x = 0 from divPoints
          if (divPoints[6].x == 0) {
            divPoints.splice(6, 1);
          }

          let regDivPoints = [];

          let notchHeight =
            Math.round(
              (knifeblockLargeHandleHeight / 2 - boardThickness) * 1000000 +
                Number.EPSILON,
            ) / 1000000;

          i = 0;
          for (i = 0; i < divPoints.length; i++) {
            //console.log("checking divPoints[i].y = " + divPoints[i].y + " for: " + notchHeight);

            if (
              divPoints[i].y <= 0 ||
              (divPoints[i].y >= notchHeight - 0.000001 &&
                divPoints[i].y <= notchHeight)
            ) {
              //console.log("  adding divPoints[i].y = " + divPoints[i].y);
              regDivPoints.push(divPoints[i]);
            }
          }

          // add points to draw lines before and after the openings left for the cutouts
          const py =
            Math.round(
              (knifeblockLargeHandleHeight / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p1x =
            Math.round(
              (-(divLength / 2) + boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p2x =
            Math.round(
              (-((divLength - boardThickness * 2) / 2) + outsideHandleOffset) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;
          const p3x =
            Math.round(
              (divLength / 2 - boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p4x =
            Math.round(
              ((divLength - boardThickness * 2) / 2 - outsideHandleOffset) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;

          regDivPoints.push({ x: p1x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p2x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p3x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p4x, y: py, z: boardThickness / 2 });

          divPoints = [...regDivPoints];
        }
      }

      n = 0;
      for (n = 0; n < knifeblockLargeHandle2Group.length; n++) {
        if (divsToSave[m] == knifeblockLargeHandle2Group[n]) {
          isKnifeblockHandle = true;

          //console.log("the divider " + divsToSave[m].name + " is a knifeblock handle, removing curve points");

          divsToSave[m].geometry.computeBoundingBox();
          let divLength =
            divsToSave[m].geometry.boundingBox.max.x -
            divsToSave[m].geometry.boundingBox.min.x;
         
            Math.round(divLength * 1000000 + Number.EPSILON) / 1000000;
          numHandleSlots =
            Math.round(
              (divLength - boardThickness * 2) / knifeblockSlotSpacing,
            ) - 1;

          outsideHandleOffset =
            (divLength -
              boardThickness * 2 -
              knifeblockSlotSpacing * numHandleSlots) /
            2;

          // remove the 7th point (index 6) where x = 0 from divPoints
          if (divPoints[6].x == 0) {
            divPoints.splice(6, 1);
          }

          let regDivPoints = [];

          let notchHeight =
            Math.round(
              (knifeblockHandleHeight / 2 - boardThickness) * 1000000 +
                Number.EPSILON,
            ) / 1000000;

          i = 0;
          for (i = 0; i < divPoints.length; i++) {
            //console.log("checking divPoints[i].y = " + divPoints[i].y + " for: " + notchHeight);

            if (
              divPoints[i].y <= 0 ||
              (divPoints[i].y >= notchHeight - 0.000001 &&
                divPoints[i].y <= notchHeight)
            ) {
              //console.log("  adding divPoints[i].y = " + divPoints[i].y);
              regDivPoints.push(divPoints[i]);
            }
          }

          // add points to draw lines before and after the openings left for the cutouts
          const py =
            Math.round(
              (knifeblockHandleHeight / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p1x =
            Math.round(
              (-(divLength / 2) + boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p2x =
            Math.round(
              (-((divLength - boardThickness * 2) / 2) + outsideHandleOffset) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;
          const p3x =
            Math.round(
              (divLength / 2 - boardThickness) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const p4x =
            Math.round(
              ((divLength - boardThickness * 2) / 2 - outsideHandleOffset) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;

          regDivPoints.push({ x: p1x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p2x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p3x, y: py, z: boardThickness / 2 });
          regDivPoints.push({ x: p4x, y: py, z: boardThickness / 2 });

          divPoints = [...regDivPoints];

          // i = 0;
          // for (i = 0; i < divPoints.length; i++) {
          //   const geometry = new THREE.SphereGeometry( .001, 32, 16 );
          //   const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
          //   const sphere = new THREE.Mesh( geometry, material );
          //   scene.add( sphere );
          //   sphere.position.x = divPoints[i].x;
          //   sphere.position.y = divPoints[i].y;
          //   sphere.position.z = divPoints[i].z;
          //   render();
          //
          // }
        }
      }

      // check if this divider is a spicerack insert and if so remove all of the curve points and start from scratch
      
      n = 0;
      for (n = 0; n < spicerackInsertGroup.length; n++) {
        if (divsToSave[m] == spicerackInsertGroup[n]) {
          
          divPoints = [];
          let zDivPos = +(boardThickness / 2).toFixed(6);
          
          //manually create the divPoints with gaps for the curves
          
          divPoints.push({ x: -(divLength / 2).toFixed(6), y: -(divHeight / 2).toFixed(6), z: zDivPos });
          divPoints.push({ x: +(divLength / 2).toFixed(6), y: -(divHeight / 2).toFixed(6), z: zDivPos });
          divPoints.push({ x: +(divLength / 2).toFixed(6), y: -spicerackCurveDepth.toFixed(6), z: zDivPos });
          divPoints.push({ x: -(divLength / 2).toFixed(6), y: +(divHeight / 2).toFixed(6), z: zDivPos });
          divPoints.push({ x: -(divLength / 2).toFixed(6), y: +spicerackCurveDepth.toFixed(6), z: zDivPos });

          //console.log(divPoints);

        }
      }

      

      // Loop through the divpoints and extend the dividers slightly left and right for a little sanding removal
      // skip for the spicerack as there are no notches
      if (divsToSave[m].name != "spicerackInsertBoardMesh") {
        const notchExtraLength = 0.000762; // 0.03", divider board notch extra length for sanding the ends

        //console.log(divPoints);

        var highestX = 0.000001;
        var lowestX = -0.000001;

        //console.log("highestX = " + highestX )
        //console.log("lowestX  = " + lowestX )

        // find the highest and lowest values of x
        i = 0;
        for (i = 0; i < divPoints.length; i++) {
          if (divPoints[i].x > highestX) {
            highestX = divPoints[i].x;
          }
          if (divPoints[i].x < lowestX) {
            lowestX = divPoints[i].x;
          }
        }

        // change the values of the divPoints that are furtherest right and left

        i = 0;
        for (i = 0; i < divPoints.length; i++) {
         
          if (divPoints[i].x == highestX) {
            divPoints[i].x = divPoints[i].x + notchExtraLength;
          }
          if (divPoints[i].x == lowestX) {
            divPoints[i].x = divPoints[i].x - notchExtraLength;
          }
        }
      }

      // invert the y divpoints so the are the right side up unless it is a spicerack insert which is symetrical
      if (divsToSave[m].name != "spicerackInsertBoardMesh" ) { 
        i = 0;
        for (i = 0; i < divPoints.length; i++) {
          divPoints[i].y = divPoints[i].y * -1;
        }
      }

      // if there is a cutaway then re-sort the points on y and then x
      if (hasCutaway == true) {
        divPoints.sort(function (a, b) {
          return a.y - b.y || a.x - b.x;
        });
      }

      // Loop through the divpoints and write the svg path
      // start at the top left of each divider and alternate horizontal and vertical lines to the next point
      // top left is -x and -y.
      // Add half the divider height or width as needed when converting from the 3d model where the xy axis is in the middle
      // to the svg model where the xy axis is top left.

      xmlDivString =
        xmlDivString +
        '    <g inkscape:groupmode="layer" id="a74eb484-e48a-4f48-b3cb-f9311b9b35a6" inkscape:label="LINE_15_" style="stroke:#000000;">\n' +
        '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';

      let remainingDivPoints = [...divPoints];

      let prevX1, prevY1, newX1, newY1;
      let isHorizLine = true;

      let newX1base = (divPoints[0].x + divLength / 2) * unitMultLaser;
      let newX1offset = divsToSaveOffsets[m].lx * unitMultLaser;
      let newY1base = (divPoints[0].y + divHeight / 2) * unitMultLaser;
      let newY1offset = divsToSaveOffsets[m].ly * unitMultLaser;

      let newStartX1 = (newX1base + newX1offset + xOffset).toFixed(2);
      let newStartY1 = (newY1base + newY1offset + yOffset).toFixed(2);

      let firstPass = true;
      i = 0;
      for (i = 0; i < divPoints.length; i++) {
        // console.log("-----------");
        // console.log("i = " + i + " prevX1 = " + prevX1 + " prevY1 = " + prevY1);

        // first pass through set the top left starting point, leave the point in
        // the tracking array to return to it
        if (firstPass == true) {
          xmlDivString = xmlDivString + newStartX1 + "," + newStartY1 + " ";
          prevX1 = divPoints[0].x;
          prevY1 = divPoints[0].y;
          firstPass = false;
          i--;
          continue;
        }

        let closestX = 100000;
        let closestY = 100000;

        // loop through the divpoints and find the next point
        let k = 0;
        for (k = 0; k < remainingDivPoints.length; k++) {
          //console.log("Checking if Horizontal line for remainingDivPoints[k].y: " + remainingDivPoints[k].y + " = prevY1 " + prevY1);
          if (isHorizLine == true && (remainingDivPoints[k].y <= (prevY1 + 0.00001) && remainingDivPoints[k].y >= (prevY1 - 0.00001))) {
            //console.log(" *Checking if remainingDivPoints X: " + remainingDivPoints[k].x + " is closest to: " + prevX1);
            // check if this point is the previous one and skip if so
            if (remainingDivPoints[k].x == prevX1) {
              continue;
            }
            // check if this point is the starting one, skip as this should only happen when drawing a vertical line
            if (k == 0) {
              continue;
            }

            if (
              Math.abs(remainingDivPoints[k].x - prevX1) <
              Math.abs(closestX - prevX1)
            ) {
              let saveClosestX = closestX;
              closestX = remainingDivPoints[k].x;
              //console.log("  closestX = " +  closestX + " where prevX1 = " + prevX1);
            }
          } else {
            //console.log("Checking if Vertical line for remainingDivPoints[k].x: " + remainingDivPoints[k].x + " = prevX1 " + prevX1);
            if (isHorizLine == false && (remainingDivPoints[k].x <= (prevX1 + 0.00001) && remainingDivPoints[k].x >= (prevX1 - 0.00001))) {
              // console.log(
              //   " *Checking if remainingDivPoints Y: " +
              //     remainingDivPoints[k].y +
              //     " is closest to: " +
              //     prevY1,
              // );
              // check if this point is the previous one and skip if so
              if (remainingDivPoints[k].y == prevY1) {
                continue;
              }
              if (
                Math.abs(remainingDivPoints[k].y - prevY1) <
                Math.abs(closestY - prevY1)
              ) {
                closestY = remainingDivPoints[k].y;
                //console.log("  closestY = " +  closestY + " where prevY1 = " + prevY1);
              }
            }
          }
        }

        if (isHorizLine == true) {
          newX1base = (closestX + divLength / 2) * unitMultLaser;
          newX1offset = divsToSaveOffsets[m].lx * unitMultLaser;
          newY1base = (prevY1 + divHeight / 2) * unitMultLaser;
          newY1offset = divsToSaveOffsets[m].ly * unitMultLaser;

          newX1 = (newX1base + newX1offset + xOffset).toFixed(2);
          newY1 = (newY1base + newY1offset + yOffset).toFixed(2);

          prevX1 = closestX;
          // console.log(". drawing horizontal line to closestX/prevX1 = " + closestX);
          // console.log("    prevX1 = " + prevX1);

          isHorizLine = false;
        } else {
          newX1base = (prevX1 + divLength / 2) * unitMultLaser;
          newX1offset = divsToSaveOffsets[m].lx * unitMultLaser;
          newY1base = (closestY + divHeight / 2) * unitMultLaser;
          newY1offset = divsToSaveOffsets[m].ly * unitMultLaser;

          newX1 = (newX1base + newX1offset + xOffset).toFixed(2);
          newY1 = (newY1base + newY1offset + yOffset).toFixed(2);

          // console.log(". drawing vertical line to closestY = " + closestY);
          // console.log("    prevY1 = " + prevY1);
          prevY1 = closestY;

          isHorizLine = true;   
          
        }

        // remove the point that was drawn to from the tracking array
        k = 0;
        for (k = 0; k < remainingDivPoints.length; k++) {
          
          //console.log("  Checking if remainingDivPoints[k].x = " + remainingDivPoints[k].x + " prevX1 = " + prevX1 + " &&");
          //console.log("              remainingDivPoints[k].y = " + remainingDivPoints[k].y + " prevY1 = " + prevY1);
          if (
            (remainingDivPoints[k].x <= (prevX1 + 0.00001) && remainingDivPoints[k].x >= (prevX1 - 0.00001)) &&
            (remainingDivPoints[k].y <= (prevY1 + 0.00001) && remainingDivPoints[k].y >= (prevY1 - 0.00001))
          ) {
            //console.log("  Removing x = " + prevX1 + " y = " + prevY1);
            remainingDivPoints.splice(k, 1);
            break;
          }
        }

        xmlDivString = xmlDivString + "L ";
        xmlDivString = xmlDivString + newX1 + "," + newY1 + " ";

        // add in the cutaway for this divider if it has one.
        if (hasCutaway == true && prevX1 == cutAwayXStart) {
          //console.log("Adding cutaway with cutAwayDiameter = " + cutAwayDiameter + " cutAwayXStart = " + cutAwayXStart);

          // add 1/2 of the divLength to change the 0 position from the middle of the div to the left side
          // to match the svg coordinate system
          let startX = ((cutAwayXStart + divLength / 2) * unitMultLaser + newX1offset + xOffset);
          //let startY = (divHeight * unitMultLaser + newY1offset + yOffset);

          xmlDivString = xmlDivString +
            "C " + (startX + (cutAwayDiameter * unitMultLaser) / 3).toFixed(2) +
            "," + (newY1base + ((divHeight / 2) * unitMultLaser) + newY1offset + yOffset).toFixed(2) +

            "," + (startX + ((cutAwayDiameter * unitMultLaser) / 3) * 2).toFixed(2) +
            "," + (newY1base + ((divHeight / 2) * unitMultLaser) + newY1offset + yOffset).toFixed(2) +

            "," + ((cutAwayXStart + divLength / 2) * unitMultLaser + cutAwayDiameter * unitMultLaser + newX1offset + xOffset).toFixed(2) +
            "," + newY1 +
            " ";
          isHorizLine = true;

          // the end of the curve is the negative of the start of the curve, 0 in the middle
          prevX1 = prevX1 * -1;

          // remove the point that was drawn to from the tracking array
          let l = 0;
          for (l = 0; l < remainingDivPoints.length; l++) {
            if (
              remainingDivPoints[l].x == prevX1 &&
              remainingDivPoints[l].y == prevY1
            ) {
              //console.log("after cutaway Removing x = " + prevX1 + " y = " + prevY1);
              remainingDivPoints.splice(l, 1);
            }
          }
          i++;
        }

        if (isKnifeblockHandle == true) {
          const handleCurveXStart =
            (divLength - boardThickness * 2) / 2 - outsideHandleOffset;
          // console.log(
          //   "Knifeblock start prevX1 = " +
          //     prevX1.toFixed(6) +
          //     " handleCurveXStart = " +
          //     handleCurveXStart.toFixed(6),
          // );

          // add in the handle curves for this divider if it has one.
          if (prevX1.toFixed(6) == handleCurveXStart.toFixed(6)) {
            // console.log(
            //   "  Adding knifeblock handle with knifeblockSlotSpacing = " +
            //     knifeblockSlotSpacing +
            //     " handleCurveXStart = " +
            //     handleCurveXStart,
            // );

            let k = 0;
            for (k = 0; k < numHandleSlots; k++) {
              //console.log(" adding Handle Slots # " + k + " @ offSet = " + outsideHandleOffset);

              // add a line that is 1/2 of the knifeblockHandleSpaceBetweenCurves before the curve
              // this is another line added on to the end of the existing offset or other flat space between the
              // handle curves resulting in inefficient svg's, maybe should be done differently.

              // add 1/2 of the divLength to change the 0 position from the middle of the div to the left side
              // to match the svg coordinate system
              const firstCurveX =
                (handleCurveXStart +
                  divLength / 2 -
                  knifeblockSlotSpacing * k -
                  knifeblockHandleSpaceBetweenCurves / 2) *
                  unitMultLaser +
                newX1offset +
                xOffset; 
              const secondCurveX =
                (handleCurveXStart +
                  divLength / 2 -
                  knifeblockSlotSpacing * (k + 1) +
                  knifeblockHandleSpaceBetweenCurves / 2) *
                  unitMultLaser +
                newX1offset +
                xOffset;

              //console.log("  firstCurveX = " + firstCurveX);
              //console.log("  secondCurveX = " + secondCurveX);

              xmlDivString = xmlDivString + "L ";
              xmlDivString =
                xmlDivString + firstCurveX.toFixed(2) + "," + newY1 + " ";

              var handleHeight;
              if (isKnifeblockLargeHandle == true) {
                handleHeight = knifeblockLargeHandleHeight;
              } else {
                handleHeight = knifeblockHandleHeight;
              }

              xmlDivString =
                xmlDivString +
                "C " +
                firstCurveX.toFixed(2) +
                "," +
                (+newY1 + knifeblockHandleCurveDepth * unitMultLaser).toFixed(
                  2,
                ) +
                "," +
                secondCurveX.toFixed(2) +
                "," +
                //((((handleHeight / 2 ) - knifeblockHandleCurveDepth) * unitMultLaser) + newY1offset + yOffset).toFixed(2) + ',' +
                (+newY1 + knifeblockHandleCurveDepth * unitMultLaser).toFixed(
                  2,
                ) +
                "," +
                secondCurveX.toFixed(2) +
                "," +
                newY1 +
                " ";
              isHorizLine = true;

              xmlDivString = xmlDivString + "L ";
              xmlDivString =
                xmlDivString +
                (
                  secondCurveX -
                  (knifeblockHandleSpaceBetweenCurves / 2) * unitMultLaser
                ).toFixed(2) +
                "," +
                newY1 +
                " ";
            }

            // the end of the curve is the negative of the start of the curve, 0 in the middle
            prevX1 = prevX1 * -1;

            // remove the point that was drawn to from the tracking array
            let l = 0;
            for (l = 0; l < remainingDivPoints.length; l++) {
              if (
                remainingDivPoints[l].x == prevX1 &&
                remainingDivPoints[l].y == prevY1
              ) {
                //console.log("after cutaway Removing x = " + prevX1 + " y = " + prevY1);
                remainingDivPoints.splice(l, 1);
              }
            }
            i++;
          }
        }


        if (isKnifeblockBlade == true) {

          //const knifeblockSlotSpacing = 0.03175; //1 1/4" includes flat space between the curves
          const bladeSlotXStart = (divLength - boardThickness * 2) / 2 - outsideBladeOffset;
          const knifeblockBladeSpaceBetweenSlots = (knifeblockSlotSpacing - bladeSlotWidth - (2 * bladeSlotCurveSize)) / 2;

          // add in the blade slots for this divider if it has one.
          if (prevX1.toFixed(6) == bladeSlotXStart.toFixed(6)) {
            // console.log(
            //   "  Adding knifeblock blade with knifeblockBladeSpaceBetweenSlots = " +
            //     knifeblockBladeSpaceBetweenSlots +
            //     " bladeSlotXStart = " +
            //     bladeSlotXStart);

            let k = 0;
            for (k = 0; k < numBladeSlots; k++) {
              //console.log(" adding Blade Slots # " + k + " @ offSet = " + outsideBladeOffset);

              // add a line that is knifeblockBladeSpaceBetweenSlots long before the curve for the slot,
              // this is another line added on to the end of the existing offset or other flat space between the
              // handle curves resulting in inefficient svg's, maybe should be done differently.

              // add 1/2 of the divLength to change the 0 position from the middle of the div to the left side
              // to match the svg coordinate system

              const firstSlotCurveX = (bladeSlotXStart + divLength / 2 -
                  knifeblockSlotSpacing * k - knifeblockBladeSpaceBetweenSlots) *
                  unitMultLaser + newX1offset + xOffset; 
              const secondSlotCurveX = firstSlotCurveX - (bladeSlotCurveSize * 2 * unitMultLaser) - 
                (bladeSlotWidth * unitMultLaser) - (knifeblockBladeSpaceBetweenSlots * unitMultLaser);
     
              //console.log("  firstSlotCurveX = " + firstSlotCurveX);
              //console.log("  secondSlotCurveX = " + secondSlotCurveX);

              xmlDivString = xmlDivString + "L ";
              xmlDivString = xmlDivString + firstSlotCurveX.toFixed(2) + "," + newY1 + " ";


              xmlDivString = xmlDivString + "Q " +
                (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + "," +
                (+newY1).toFixed(2) + "," +
                (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + "," +
                (+newY1 + (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + " ";

              xmlDivString = xmlDivString + "L ";
              xmlDivString = xmlDivString + (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + "," + 
              (+newY1 + (bladeSlotCurveSize * unitMultLaser) + (bladeSlotHeight * unitMultLaser)).toFixed(2) + " ";

              xmlDivString = xmlDivString + "C " +
                (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + "," +
                (+newY1 + (bladeSlotCurveSize * unitMultLaser) + (bladeSlotHeight * unitMultLaser) + (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + "," +
                (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser) - (bladeSlotWidth * unitMultLaser)).toFixed(2) + "," +
                (+newY1 + (bladeSlotCurveSize * unitMultLaser) + (bladeSlotHeight * unitMultLaser) + (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + "," +
                (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser) - (bladeSlotWidth * unitMultLaser)).toFixed(2) + "," +
                (+newY1 + (bladeSlotCurveSize * unitMultLaser) + (bladeSlotHeight * unitMultLaser)).toFixed(2)+ " ";

              xmlDivString = xmlDivString + "L ";
              xmlDivString = xmlDivString + (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser) - (bladeSlotWidth * unitMultLaser)).toFixed(2) + "," + 
              (+newY1 + (bladeSlotCurveSize * unitMultLaser)).toFixed(2) + " ";

              xmlDivString = xmlDivString + "Q " +
                (firstSlotCurveX - (bladeSlotCurveSize * unitMultLaser) - (bladeSlotWidth * unitMultLaser)).toFixed(2) + "," +
                (+newY1).toFixed(2) + "," +
                (firstSlotCurveX - (bladeSlotCurveSize * 2 * unitMultLaser) - (bladeSlotWidth * unitMultLaser)).toFixed(2) + "," +
                (+newY1).toFixed(2) + " ";



              isHorizLine = true;

              xmlDivString = xmlDivString + "L ";
              xmlDivString = xmlDivString + (secondSlotCurveX).toFixed(2) + "," +
                (+newY1).toFixed(2) + " ";

            }

             // the end of the curve is the negative of the start of the curve, 0 in the middle
            prevX1 = prevX1 * -1;

            // remove the point that was drawn to from the tracking array
            let l = 0;
            for (l = 0; l < remainingDivPoints.length; l++) {
              if (
                remainingDivPoints[l].x == prevX1 &&
                remainingDivPoints[l].y == prevY1
              ) {
                //console.log("after cutaway Removing x = " + prevX1 + " y = " + prevY1);
                remainingDivPoints.splice(l, 1);
              }
            }
            i++;
          }
        }


        if (divsToSave[m].name == "spicerackInsertBoardMesh" ) { 
          
          if (prevX1 > 0 && prevY1 == (spicerackCurveDepth * -1)) {
  
            const divHeight = divsToSave[m].geometry.boundingBox.max.y - divsToSave[m].geometry.boundingBox.min.y;

            const firstCurveY = ((((spicerackCurveDepth * -1) + divHeight / 2) * unitMultLaser) + newY1offset + yOffset).toFixed(2);
            const secondCurveY = (((spicerackCurveDepth + divHeight / 2) * unitMultLaser) + newY1offset + yOffset).toFixed(2);
            const xControl = ((((prevX1 - spicerackCurveDepth) + divLength / 2) * unitMultLaser) + newX1offset + xOffset).toFixed(2);
            
            // draw curve
            xmlDivString = xmlDivString + "C " + xControl + "," + firstCurveY + "," +
              xControl + "," + secondCurveY +
              "," + newX1 + "," + secondCurveY + " ";
                

            //draw next vertical line    
            xmlDivString = xmlDivString + "L ";
            xmlDivString = xmlDivString + newX1 + "," + (((divHeight) * unitMultLaser + newY1offset + yOffset).toFixed(2)) + " ";

            prevY1 =  Math.round((divHeight / 2) * 1000000 + Number.EPSILON ) / 1000000;
        
          } else if (( prevX1 < 0 && prevY1 == spicerackCurveDepth )) {

            // draw curve
            const divHeight = divsToSave[m].geometry.boundingBox.max.y - divsToSave[m].geometry.boundingBox.min.y;

            const firstCurveY = (((spicerackCurveDepth + divHeight / 2) * unitMultLaser) + newY1offset + yOffset).toFixed(2);
            const secondCurveY = ((((spicerackCurveDepth * -1) + divHeight / 2) * unitMultLaser) + newY1offset + yOffset).toFixed(2);
            const xControl = ((((prevX1 + spicerackCurveDepth) + divLength / 2) * unitMultLaser) + newX1offset + xOffset).toFixed(2);

            xmlDivString = xmlDivString + "C " + xControl + "," + firstCurveY + "," +
              xControl + "," + secondCurveY +
              "," + newX1 + "," + secondCurveY + " ";

            //draw next vertical line, the Y value is 0 because the top left corner is negative 1/2 of the divHeight
            // and then 1/2 of divHeight is added to convert from 3d to svg coordinates   
            xmlDivString = xmlDivString + "L ";
            xmlDivString = xmlDivString + newX1 + "," + ((newY1offset + yOffset).toFixed(2)) + " ";

            prevY1 = Math.round(((divHeight / 2) * -1) * 1000000 + Number.EPSILON ) / 1000000;
            // the top left corner Y is negative 1/2 of the divHeight and then add 1/2 of divHeight to
            // convert from 3d to svg coordinates = 0 so it is not shown below
            newY1 = (newY1offset + yOffset).toFixed(2);

            // remove the point that was drawn to from the tracking array
            let l = 0;
            for (l = 0; l < remainingDivPoints.length; l++) {
              //console.log("  prevX1 = " + prevX1 + " y = " + ((divHeight / 2) * -1).toFixed(6) );
              if (remainingDivPoints[l].x == prevX1 && remainingDivPoints[l].y == ((divHeight / 2) * -1).toFixed(6)) {
                //console.log(".   after spicerack Removing x = " + prevX1 + " y = " + ((divHeight / 2) * -1).toFixed(6));
                remainingDivPoints.splice(l, 1);
              }
            }
          }        
        } 

        // if this is the last pass for the main outline then finish the path and
        // move to a new point to start drawing again if needed.
        // Leave the point in the tracking array to return to it
        //console.log("  newStartX1 = " + newStartX1 + " newX1 = " + newX1 );
        //console.log("  newStartY1 = " + newStartY1 + " newY1 = " + newY1 );
        if (newStartX1 == newX1 && newStartY1 == newY1) {
          //console.log("main outline done, starting new inner outlines if needed...");

          if (remainingDivPoints.length != 0) {
            // sort the remaining points on y and then x
            remainingDivPoints.sort(function (a, b) {
              return a.y - b.y || a.x - b.x;
            });
            //console.log(remainingDivPoints);
            newX1base =
              (remainingDivPoints[0].x + divLength / 2) * unitMultLaser;
            newY1base =
              (remainingDivPoints[0].y + divHeight / 2) * unitMultLaser;

            newStartX1 = (newX1base + newX1offset + xOffset).toFixed(2);
            newStartY1 = (newY1base + newY1offset + yOffset).toFixed(2);

            xmlDivString =
              xmlDivString + "M " + newStartX1 + "," + newStartY1 + " ";
            prevX1 = remainingDivPoints[0].x;
            prevY1 = remainingDivPoints[0].y;

            isHorizLine = true;
            continue;
          }

          // don't loop through again if this is the spicerack insert
          if (divsToSave[m].name == "spicerackInsertBoardMesh" ) {
            break;
          }
        }
      }

      xmlDivString = xmlDivString + '"/>\n';
      xmlDivString = xmlDivString + "    </g>\n";
    } // end of loop through dividers writing the svg lines

    xmlDivString = xmlDivString + "</svg>\n";

    //let divSVG = parser.parseFromString(xmlDivString, "application/xml");

    //let svgDivFile = XMLS.serializeToString(divSVG);
    let svgDivFile = xmlDivString;

    let divSVGFilename = "my.drawer.insert.sides.svg";

    // Done with Sides for the laser cutter, create the packing box for the cnc machine

    // let xmlPboxString =
    // '<?xml version="1.0" encoding="utf-8"?>\n' +
    // '<!-- Generator: drawer insert designer v0.1  -->\n' +
    // '<svg version="1.1" id="_x30_" xmlns="http://www.w3.org/2000/svg" ' +
    // 'xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1500 3000" ' +
    // 'style="enable-background:new 0 0 1851.47 1957.77;" xml:space="preserve">\n' +
    // '<style type="text/css">\n' +
    // "	.st0{fill:none;stroke:#000000;stroke-width:0.7087;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n" +
    // "</style>\n";
    //
    // let pboxTopDepthSVG = (insertDepth * unitMultiplier) + (pboxThickness * 2 );
    // let pboxTopWidthSVG = (insertWidth * unitMultiplier) + (pboxThickness * 2 );
    //
    // let pboxDepthSVG = (insertDepth * unitMultiplier) + (pboxThickness / 2 );
    // let pboxWidthSVG = (insertWidth * unitMultiplier) + (pboxThickness / 2 );
    // let pboxHeightSVG = (insertHeight * unitMultiplier) + (pboxThickness / 2 );
    //
    // // draw top box panel
    // xmlPboxString = xmlPboxString +
    // '    <g id="LINE_8_">\n' +
    // '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';
    //
    // xmlPboxString = xmlPboxString + xOffset + ',' + yOffset + ' L ' + (xOffset + pboxTopWidthSVG).toFixed(2) + ',' + yOffset;
    // xmlPboxString = xmlPboxString + ' L ' + (xOffset + pboxTopWidthSVG).toFixed(2) + ',' + (yOffset + pboxTopDepthSVG).toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + xOffset + ',' + (yOffset + pboxTopDepthSVG).toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + xOffset + ',' + yOffset + '"/>\n';
    // xmlPboxString = xmlPboxString + "    </g>\n";
    //
    // // draw middle box panel
    // yOffset = yOffset + pboxTopDepthSVG;
    //
    // xmlPboxString = xmlPboxString +
    // '    <g id="LINE_9_">\n' +
    // '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';
    //
    // xmlPboxString = xmlPboxString + xOffset + ',' + yOffset.toFixed(2) + ' L ' + (xOffset + pboxWidthSVG).toFixed(2) + ',' + yOffset.toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + (xOffset + pboxWidthSVG).toFixed(2) + ',' + (yOffset + pboxHeightSVG).toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + xOffset + ',' + (yOffset + pboxHeightSVG).toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + xOffset + ',' + yOffset.toFixed(2) + '"/>\n';
    // xmlPboxString = xmlPboxString + "    </g>\n";
    //
    // // draw bottom box panel
    // yOffset = yOffset + pboxHeightSVG;
    //
    // xmlPboxString = xmlPboxString +
    // '    <g id="LINE_10_">\n' +
    // '        <path style="fill:none;stroke-width:1.00000;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stroke:#000000;" d="M ';
    //
    // xmlPboxString = xmlPboxString + xOffset + ',' + yOffset.toFixed(2) + ' L ' + (xOffset + pboxWidthSVG).toFixed(2) + ',' + yOffset.toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + (xOffset + pboxWidthSVG).toFixed(2) + ',' + (yOffset + pboxDepthSVG).toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + xOffset + ',' + (yOffset + pboxDepthSVG).toFixed(2);
    // xmlPboxString = xmlPboxString + ' L ' + xOffset + ',' + yOffset.toFixed(2) + '"/>\n';
    // xmlPboxString = xmlPboxString + "    </g>\n";
    //
    // xmlPboxString = xmlPboxString + "</svg>\n";
    //
    // let svgPackingBoxFile = xmlPboxString;
    //
    // let packingBoxSVGFilename = "my.drawer.insert.packingbox.svg";

    const insertPic = renderer.domElement.toDataURL("image/jpeg");
    let picFilename = "drawer.insert.finished.jpg";

    let finishedInsert = saveInsert(true);
    let finishedInsertFilename = "drawer.insert.finished.json";

    //if (bottomReqSwitchOn == true) {
    //  saveFile(
    //    new Blob([svgBaseFile], { type: "text/plain" }),
    //    baseSVGFilename,
    //  );
    //}
    //saveFile(new Blob([svgDivFile], { type: "text/plain" }), divSVGFilename);
    //saveFile(new Blob([insertPic], { type: "text/jpeg" }), picFilename);
    //saveFile(new Blob([finishedInsert], { type: "text/plain" }), finishedInsertFilename);

    //saveFile(new Blob([svgPackingBoxFile], { type: "text/plain" }), packingBoxSVGFilename);

    return {
      base: Buffer.from(svgBaseFile).toString("base64"),
      dividers: Buffer.from(svgDivFile).toString("base64"),
      pic: Buffer.from(insertPic).toString("base64"),
      insert: Buffer.from(finishedInsert).toString("base64"),
    };
    //packingbox: Buffer.from(svgPackingBoxFile).toString("base64"),
  };

  function positionNewFullVert() {
    controls.enabled = false;
    dControls.enabled = false;
    dControls.deactivate();

    // listen for a click, set the location and call the addSpanVert function
    renderer.domElement.addEventListener("click", clickHandleFullVert, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "cell";
  }

  function cancelPositionNewFullVert() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleFullVert,
      false,
    );
    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addFullVert(locationX) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleFullVert,
      false,
    );

    // generate new board and add it to the main drawer_insert object
    // Create new BufferGeometries
    const newBoardGeometry = makeFullVertDivGeometry();
    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
    const fullVertBoardMesh = new THREE.Mesh(newBoardGeometry, material);

    fullVertBoardMesh.rotation.y += radNinety;
    fullVertBoardMesh.position.setY(divHeight / 2 + baseThickness / 2);
    fullVertBoardMesh.position.setX(locationX);
    fullVertBoardMesh.position.setZ(0);

    fullVertBoardMesh.name = "fullVertBoardMesh";
    // add clamp min and mix to limit movement to a range on the x axis only
    fullVertBoardMesh.userData.limit = {
      min: new THREE.Vector3(
        0 - (insertWidth / 2 - minDivWidth),
        fullVertBoardMesh.position.y,
        fullVertBoardMesh.position.z,
      ),
      max: new THREE.Vector3(
        insertWidth / 2 - minDivWidth,
        fullVertBoardMesh.position.y,
        fullVertBoardMesh.position.z,
      ),
    };
    fullVertBoardMesh.userData.update = function () {
      fullVertBoardMesh.position.clamp(
        fullVertBoardMesh.userData.limit.min,
        fullVertBoardMesh.userData.limit.max,
      );
    };
    fullVertBoardMesh.userData.update();

    moveableObjects.push(fullVertBoardMesh);

    drawer_insert.add(fullVertBoardMesh);

    fullVertDivGroup.push(fullVertBoardMesh);

    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();
    //console.log("calling redoInsert from addFulllVert");
    redoInsert();
  }

  function positionNewFullHoriz() {
    controls.enabled = false;
    dControls.enabled = false;
    dControls.deactivate();

    // listen for a click, set the location and call the addSpanVert function
    renderer.domElement.addEventListener("click", clickHandleFullHoriz, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "cell";
  }

  function cancelPositionNewFullHoriz() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleFullHoriz,
      false,
    );
    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addFullHoriz(locationZ) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleFullHoriz,
      false,
    );
    // generate new board and add it to the main drawer_insert object
    // Create new BufferGeometries
    const newBoardGeometry = makeFullHorizDivGeometry();
    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
    const fullHorizBoardMesh = new THREE.Mesh(newBoardGeometry, material);
    fullHorizBoardMesh.position.setY(divHeight / 2 + baseThickness / 2);
    fullHorizBoardMesh.position.setX(0);
    fullHorizBoardMesh.position.setZ(locationZ);

    fullHorizBoardMesh.name = "fullHorizBoardMesh";
    // add clamp min and mix to limit movement to a range on the x axis only
    fullHorizBoardMesh.userData.limit = {
      min: new THREE.Vector3(
        fullHorizBoardMesh.position.x,
        fullHorizBoardMesh.position.y,
        0 - (insertDepth / 2 - minDivWidth),
      ),
      max: new THREE.Vector3(
        fullHorizBoardMesh.position.x,
        fullHorizBoardMesh.position.y,
        insertDepth / 2 - minDivWidth,
      ),
    };
    fullHorizBoardMesh.userData.update = function () {
      fullHorizBoardMesh.position.clamp(
        fullHorizBoardMesh.userData.limit.min,
        fullHorizBoardMesh.userData.limit.max,
      );
    };
    fullHorizBoardMesh.userData.update();

    moveableObjects.push(fullHorizBoardMesh);

    drawer_insert.add(fullHorizBoardMesh);
    fullHorizDivGroup.push(fullHorizBoardMesh);

    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();

    redoInsert();
  }

  function positionNewSpanVert() {
    controls.enabled = false;
    dControls.enabled = false;
    dControls.deactivate();

    // listen for a click, set the location and call the addSpanVert function
    renderer.domElement.addEventListener("click", clickHandleVert, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "cell";
  }

  function cancelPositionNewSpanVert() {
    renderer.domElement.removeEventListener("click", clickHandleVert, false);
    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addSpanVert(locationX, locationZ) {
    renderer.domElement.removeEventListener("click", clickHandleVert, false);

    // figure out the length of the new divider
    // determine which horizontal dividers, front or back board are closest
    // chech in the positive and then the negative direction.
    // the back is the default closest negative divider and the front is the closest positive divider
    let closestPosDiv = drawer_insert.children[3].position.z;
    let closestNegDiv = drawer_insert.children[4].position.z;
    fullHorizDivGroup.forEach((i) => {
      if (locationZ >= closestPosDiv) {
        console.log(
          "Error: click location greater than front location @ z = " +
            closestPosDiv,
        );
      }
      if (i.position.z > locationZ && i.position.z < closestPosDiv) {
        closestPosDiv = i.position.z;
      }
      if (locationZ <= closestNegDiv) {
        console.log("Error: click location less than back location");
      }
      if (i.position.z < locationZ && i.position.z > closestNegDiv) {
        closestNegDiv = i.position.z;
      }
    });

    let j = 0;
    for (j = 0; j < spanHorizDivGroup.length; j++) {
      // if this spanning horizontal divider hits this spanning vertical divider at the end then ignore it
      var bBox = new THREE.Box3().setFromObject(spanHorizDivGroup[j]);

      let endXofVertDivLeft = +(locationX - boardThickness / 2).toFixed(6);
      let endXofVertDivRight = +(locationX + boardThickness / 2).toFixed(6);
      let endXofHorizDivLeft = +bBox.min.x.toFixed(6);
      let endXofHorizDivRight = +bBox.max.x.toFixed(6);

      if (
        endXofVertDivLeft <= endXofHorizDivLeft ||
        endXofVertDivRight >= endXofHorizDivRight
      ) {
        continue;
      }

      if (locationZ >= closestPosDiv) {
        console.log(
          "Error: click location greater than front location @ z = " +
            closestPosDiv,
        );
      }
      if (
        spanHorizDivGroup[j].position.z > locationZ &&
        spanHorizDivGroup[j].position.z < closestPosDiv
      ) {
        closestPosDiv = spanHorizDivGroup[j].position.z;
      }
      if (locationZ <= closestNegDiv) {
        console.log("Error: click location less than back location");
      }
      if (
        spanHorizDivGroup[j].position.z < locationZ &&
        spanHorizDivGroup[j].position.z > closestNegDiv
      ) {
        closestNegDiv = spanHorizDivGroup[j].position.z;
      }
    }

    const newSpanVertDivLength = closestPosDiv - closestNegDiv + boardThickness;
    const newSpanVertDivLocateZ =
      closestNegDiv + (closestPosDiv - closestNegDiv) / 2;

    // generate new board and add it to the main drawer_insert object
    // Create new BufferGeometries
    const newBoardGeometry = makeSpanDivGeometry(newSpanVertDivLength);

    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
    const spanVertBoardMesh = new THREE.Mesh(newBoardGeometry, material);
    spanVertBoardMesh.rotation.y += radNinety;
    spanVertBoardMesh.translateY(divHeight / 2 + baseThickness / 2);
    spanVertBoardMesh.position.x = locationX;
    spanVertBoardMesh.position.z = newSpanVertDivLocateZ;

    spanVertBoardMesh.name = "spanVertBoardMesh";
    // add clamp min and mix to limit movement to a range on the x axis only
    spanVertBoardMesh.userData.limit = {
      min: new THREE.Vector3(
        0 - (insertWidth / 2 - minDivWidth),
        spanVertBoardMesh.position.y,
        spanVertBoardMesh.position.z,
      ),
      max: new THREE.Vector3(
        insertWidth / 2 - minDivWidth,
        spanVertBoardMesh.position.y,
        spanVertBoardMesh.position.z,
      ),
    };
    spanVertBoardMesh.userData.update = function () {
      spanVertBoardMesh.position.clamp(
        spanVertBoardMesh.userData.limit.min,
        spanVertBoardMesh.userData.limit.max,
      );
    };
    spanVertBoardMesh.userData.update();

    moveableObjects.push(spanVertBoardMesh);

    spanVertDivGroup.push(spanVertBoardMesh);
    drawer_insert.add(spanVertBoardMesh);

    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();

    // add notches to the vertical divs that meet this spanning horzontal div
    spanVertBoardMesh.geometry.computeBoundingBox();
    addNotchHoriz(spanVertBoardMesh);
    //makeVertSpanDivGeoNotch(spanVertBoardMesh);
    spanVertBoardMesh.geometry.computeBoundingBox();

    spanHorizDivGroup.forEach((i) => {
      makeHorizSpanDivGeoNotch(i);
    });

    checkValidMove.push(spanVertBoardMesh.id);

    redoInsert();
  }

  function positionNewSpanHoriz() {
    controls.enabled = false;
    dControls.enabled = false;
    dControls.deactivate();

    // listen for a click, set the location and call the addSpanVert function
    renderer.domElement.addEventListener("click", clickHandleHoriz, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "cell";
  }

  function cancelPositionNewSpanHoriz() {
    renderer.domElement.removeEventListener("click", clickHandleHoriz, false);
    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addSpanHoriz(locationX, locationZ) {
    // add a horizontal divider that spans the section selected by user

    renderer.domElement.removeEventListener("click", clickHandleHoriz, false);

    // figure out the length of the new divider
    // determine which horizontal dividers, front or back board are closest
    // chech in the positive and then the negative direction.
    // the back is the default closest negative divider and the front is the closest positive divider
    let closestPosDiv = drawer_insert.children[2].position.x;
    let closestNegDiv = drawer_insert.children[1].position.x;
    fullVertDivGroup.forEach((i) => {
      if (locationX >= closestPosDiv) {
        console.log(
          "Error: click location greater than right side location @ z = " +
            closestPosDiv,
        );
      }
      if (i.position.x > locationX && i.position.x < closestPosDiv) {
        closestPosDiv = i.position.x;
      }
      if (locationX <= closestNegDiv) {
        console.log("Error: click location less than right side location");
      }
      if (i.position.x < locationX && i.position.x > closestNegDiv) {
        closestNegDiv = i.position.x;
      }
    });

    let j = 0;
    for (j = 0; j < spanVertDivGroup.length; j++) {
      var bBox = new THREE.Box3().setFromObject(spanVertDivGroup[j]);

      // if this spanning vertical divider hits this spanning horizintal divider at the end then ignore it
      let endZofHorizDivBack = +(locationZ - boardThickness / 2).toFixed(6);
      let endZofHorizDivFront = +(locationZ + boardThickness / 2).toFixed(6);
      let endZofVertDivBack = +bBox.min.z.toFixed(6);
      let endZofVertDivFront = +bBox.max.z.toFixed(6);

      if (
        endZofHorizDivFront <= endZofVertDivBack ||
        endZofHorizDivBack >= endZofVertDivFront ||
        endZofHorizDivBack <= endZofVertDivBack
      ) {
        continue;
      }
      if (locationX >= closestPosDiv) {
        console.log(
          "Error: click location greater than left side location @ x = " +
            closestPosDiv,
        );
      }
      if (
        spanVertDivGroup[j].position.x > locationX &&
        spanVertDivGroup[j].position.x < closestPosDiv
      ) {
        closestPosDiv = spanVertDivGroup[j].position.x;
      }
      if (locationX <= closestNegDiv) {
        console.log("Error: click location less than right side location");
      }
      if (
        spanVertDivGroup[j].position.x < locationX &&
        spanVertDivGroup[j].position.x > closestNegDiv
      ) {
        closestNegDiv = spanVertDivGroup[j].position.x;
      }
    }

    const newSpanHorizDivLength =
      closestPosDiv - closestNegDiv + boardThickness;
    const newSpanHorizDivLocateX =
      closestNegDiv + (closestPosDiv - closestNegDiv) / 2;

    // generate new board and add it to the main drawer_insert object
    // Create new BufferGeometries
    const newBoardGeometry = makeSpanDivGeometry(newSpanHorizDivLength);

    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
    const spanHorizBoardMesh = new THREE.Mesh(newBoardGeometry, material);
    spanHorizBoardMesh.translateY(divHeight / 2 + baseThickness / 2);
    spanHorizBoardMesh.position.x = newSpanHorizDivLocateX;
    spanHorizBoardMesh.position.z = locationZ;

    spanHorizBoardMesh.name = "spanHorizBoardMesh";

    // add clamp min and mix to limit movement to a range on the x axis only
    spanHorizBoardMesh.userData.limit = {
      min: new THREE.Vector3(
        spanHorizBoardMesh.position.x,
        spanHorizBoardMesh.position.y,
        0 - (insertDepth / 2 - minDivWidth),
      ),
      max: new THREE.Vector3(
        spanHorizBoardMesh.position.x,
        spanHorizBoardMesh.position.y,
        insertDepth / 2 - minDivWidth,
      ),
    };
    spanHorizBoardMesh.userData.update = function () {
      spanHorizBoardMesh.position.clamp(
        spanHorizBoardMesh.userData.limit.min,
        spanHorizBoardMesh.userData.limit.max,
      );
    };
    spanHorizBoardMesh.userData.update();

    moveableObjects.push(spanHorizBoardMesh);

    drawer_insert.add(spanHorizBoardMesh);
    spanHorizDivGroup.push(spanHorizBoardMesh);

    controls.enabled = true;
    dControls.enabled = true;
    dControls.activate();

    // add notches to the vertical divs that meet this spanning horzontal div
    spanHorizBoardMesh.geometry.computeBoundingBox();
    addNotchVert(spanHorizBoardMesh);
    spanHorizBoardMesh.geometry.computeBoundingBox();
    makeHorizSpanDivGeoNotch(spanHorizBoardMesh);

    // spanVertDivGroup.forEach((i) => {
    //   makeVertSpanDivGeoNotch(i);
    // });

    checkValidMove.push(spanHorizBoardMesh.id);

    redoInsert();
  }

  function deleteAll() {
    // delete all of the dividers leaving the empty box of the same dimensions

    removeListeners();
    dControls.dispose();

    fullVertDivGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    fullHorizDivGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    spanVertDivGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    spanHorizDivGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    knifeblockBladeGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    knifeblockHandleGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    knifeblockLargeBladeGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    knifeblockLargeHandleGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    knifeblockLargeHandle2Group.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });

    spicerackInsertGroup.forEach((i) => {
      i.geometry.dispose();
      i.material.dispose();
      scene.remove(i);
      drawer_insert.remove(i);
      i = undefined;
    });


    moveableObjects = [];
    fullVertDivGroup = [];
    fullHorizDivGroup = [];
    spanVertDivGroup = [];
    spanHorizDivGroup = [];
    divsWithCutaway = [];

    knifeblockBladeGroup = [];
    knifeblockHandleGroup = [];
    knifeblockLargeBladeGroup = [];
    knifeblockLargeHandleGroup = [];
    knifeblockLargeHandle2Group = [];

    spicerackInsertGroup = [];
    spicerackDisabledMoveableObjects = [];

    hoverOnBoard = false;
    hoverObject = undefined;

    dControls = new DragControls(moveableObjects, camera, renderer.domElement);
    addListeners();

    redoInsert();
  }

  function spaceDividerSelect() {
    // disable other controls and add the event listener for selecting boards
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);

    // listen for a click and call the spaceDivider function
    renderer.domElement.addEventListener("click", clickHandleSpace, false);

    window.parent.document.getElementById("myCanvas").style.cursor =
      "crosshair";
  }

  function cancelSpaceDividerSelect() {
    renderer.domElement.removeEventListener("click", clickHandleSpace, false);
    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.enabled = true;
    dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";

    let i = 0;
    for (i = 0; i < divsToSpace.length; i++) {
      //console.log("setting original color for div:");
      //console.log(i);
      divsToSpace[i].material.dispose();
      divsToSpace[i].material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
      divsToSpace[i].material.color.set(originalColour);
    }

    divsToSpace = [];

    render();
  }

  function finishSpaceDividerSelect() {
    renderer.domElement.removeEventListener("click", clickHandleSpace, false);

    spaceDivider();

    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    //dControls.enabled = true;
    //dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";

    let i = 0;
    for (i = 0; i < divsToSpace.length; i++) {
      divsToSpace[i].material.dispose();
      divsToSpace[i].material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
      divsToSpace[i].material.color.set(originalColour);
    }

    divsToSpace = [];

    render();
  }

  function spaceDivider() {
    // loop through the dividers to be spaced
    //  - find the closest dividers on each side
    //  - determine the distance between the outsides
    //  - determine the equal spacing based on the number of dividers
    //  - move the dividers.

    if (divsToSpaceIsVertical == true) {
      // sort the divs on their x position
      divsToSpace.sort(function (a, b) {
        return a.position.x - b.position.x;
      });

      let closestPosDiv = drawer_insert.children[2].position.x;
      let closestNegDiv = drawer_insert.children[1].position.x;

      fullVertDivGroup.forEach((j) => {
        if (
          j.position.x > divsToSpace[divsToSpace.length - 1].position.x &&
          j.position.x < closestPosDiv
        ) {
          closestPosDiv = j.position.x;
        }
        if (
          j.position.x < divsToSpace[0].position.x &&
          j.position.x > closestNegDiv
        ) {
          closestNegDiv = j.position.x;
        }
      });

      let j = 0;
      for (j = 0; j < spanVertDivGroup.length; j++) {
        // check if this span vert is relevant to the divs being spaced
        divsToSpace[0].geometry.computeBoundingBox();
        spanVertDivGroup[j].geometry.computeBoundingBox();
        const divToSpaceLength =
          divsToSpace[0].geometry.boundingBox.max.x -
          divsToSpace[0].geometry.boundingBox.min.x;
        const thisSpanVertLength =
          spanVertDivGroup[j].geometry.boundingBox.max.x -
          spanVertDivGroup[j].geometry.boundingBox.min.x;

        const spanVertTopPos =
          spanVertDivGroup[j].position.z -
          thisSpanVertLength / 2 +
          boardThickness;
        const spanVertBottomPos =
          spanVertDivGroup[j].position.z +
          thisSpanVertLength / 2 -
          boardThickness;
        const divsToSpaceTopPos =
          divsToSpace[0].position.z - divToSpaceLength / 2 + boardThickness;
        const divsToSpaceBottomPos =
          divsToSpace[0].position.z + divToSpaceLength / 2 - boardThickness;

        // console.log("checking  spanVertTopPos = " + spanVertTopPos.toFixed(6) +
        //   " spanVertBottomPos = " + spanVertBottomPos.toFixed(6) );
        //   console.log("<> divsToSpaceTopPos = " + divsToSpaceTopPos.toFixed(6) +
        //     " divsToSpaceBottomPos = " + divsToSpaceBottomPos.toFixed(6) );
        //+ " > divsToSpaceBottomPos = " + divsToSpaceBottomPos.toFixed(6));

        if (divsToSpaceBottomPos < spanVertTopPos) {
          //console.log("ignorning this spanvert");
          continue;
        }

        if (divsToSpaceTopPos > spanVertBottomPos) {
          //console.log("ignorning this spanvert");
          continue;
        }

        if (
          spanVertDivGroup[j].position.x >
            divsToSpace[divsToSpace.length - 1].position.x &&
          spanVertDivGroup[j].position.x < closestPosDiv
        ) {
          closestPosDiv = spanVertDivGroup[j].position.x;
        }
        if (
          spanVertDivGroup[j].position.x < divsToSpace[0].position.x &&
          spanVertDivGroup[j].position.x > closestNegDiv
        ) {
          closestNegDiv = spanVertDivGroup[j].position.x;
        }
      }

      let openingSize = closestPosDiv - closestNegDiv;
      let spacingInterval = openingSize / (divsToSpace.length + 1);

      j = 0;
      for (j = 0; j < divsToSpace.length; j++) {
        divsToSpace[j].position.x = closestNegDiv + spacingInterval * (j + 1);
        checkValidMove.push(divsToSpace[j].id);
      }
    } else {
      // space Horizontal divs

      // sort the divs on their z position
      divsToSpace.sort(function (a, b) {
        return a.position.z - b.position.z;
      });

      let closestPosDiv = drawer_insert.children[3].position.z;
      let closestNegDiv = drawer_insert.children[4].position.z;

      // console.log("checking full horizontal divs... ");
      // console.log("closestPosDiv = " + closestPosDiv);
      // console.log("closestNegDiv = " + closestNegDiv);

      fullHorizDivGroup.forEach((j) => {
        if (
          j.position.z > divsToSpace[divsToSpace.length - 1].position.z &&
          j.position.z < closestPosDiv
        ) {
          closestPosDiv = j.position.z;
        }
        if (
          j.position.z < divsToSpace[0].position.z &&
          j.position.z > closestNegDiv
        ) {
          closestNegDiv = j.position.z;
        }
      });

      let j = 0;
      for (j = 0; j < spanHorizDivGroup.length; j++) {
        // check if this span vert is relevant to the divs being spaced
        divsToSpace[0].geometry.computeBoundingBox();
        spanHorizDivGroup[j].geometry.computeBoundingBox();
        const divToSpaceLength =
          divsToSpace[0].geometry.boundingBox.max.x -
          divsToSpace[0].geometry.boundingBox.min.x;
        const thisSpanHorizLength =
          spanHorizDivGroup[j].geometry.boundingBox.max.x -
          spanHorizDivGroup[j].geometry.boundingBox.min.x;

        const spanHorizLeftPos =
          spanHorizDivGroup[j].position.x -
          thisSpanHorizLength / 2 +
          boardThickness;
        const spanHorizRightPos =
          spanHorizDivGroup[j].position.x +
          thisSpanHorizLength / 2 -
          boardThickness;
        const divsToSpaceLeftPos =
          divsToSpace[0].position.x - divToSpaceLength / 2 + boardThickness;
        const divsToSpaceRightPos =
          divsToSpace[0].position.x + divToSpaceLength / 2 - boardThickness;

        // console.log("checking  spanVertTopPos = " + spanVertTopPos.toFixed(6) +
        //   " spanVertBottomPos = " + spanVertBottomPos.toFixed(6) );
        //   console.log("<> divsToSpaceTopPos = " + divsToSpaceTopPos.toFixed(6) +
        //     " divsToSpaceBottomPos = " + divsToSpaceBottomPos.toFixed(6) );
        //+ " > divsToSpaceBottomPos = " + divsToSpaceBottomPos.toFixed(6));

        if (divsToSpaceRightPos < spanHorizLeftPos) {
          //console.log("ignorning this spanvert");
          continue;
        }

        if (divsToSpaceLeftPos > spanHorizRightPos) {
          //console.log("ignorning this spanvert");
          continue;
        }

        if (
          spanHorizDivGroup[j].position.z >
            divsToSpace[divsToSpace.length - 1].position.z &&
          spanHorizDivGroup[j].position.z < closestPosDiv
        ) {
          closestPosDiv = spanHorizDivGroup[j].position.z;
        }
        if (
          spanHorizDivGroup[j].position.z < divsToSpace[0].position.z &&
          spanHorizDivGroup[j].position.z > closestNegDiv
        ) {
          closestNegDiv = spanHorizDivGroup[j].position.z;
        }
      }

      let openingSize = closestPosDiv - closestNegDiv;
      let spacingInterval = openingSize / (divsToSpace.length + 1);

      j = 0;
      for (j = 0; j < divsToSpace.length; j++) {
        divsToSpace[j].position.z = closestNegDiv + spacingInterval * (j + 1);
        checkValidMove.push(divsToSpace[j].id);
      }
    }

    redoInsert();
  }

  function deleteDividerSelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);

    // listen for a click and call the deleteDivider function
    renderer.domElement.addEventListener("click", clickHandleDelete, false);

    window.parent.document.getElementById("myCanvas").style.cursor =
      "crosshair";
  }

  function cancelDeleteDividerSelect() {
    renderer.domElement.removeEventListener("click", clickHandleDelete, false);
    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.enabled = true;
    dControls.activate();
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function deleteDivider() {
    renderer.domElement.removeEventListener("click", clickHandleDelete, false);

    hoverObject.geometry.dispose();
    hoverObject.material.dispose();
    scene.remove(hoverObject);
    drawer_insert.remove(hoverObject);
    //remove hoverObject from moveableObjects
    let i = 0;
    for (i = 0; i < moveableObjects.length; i++) {
      if (hoverObject === moveableObjects[i]) {
        moveableObjects.splice(i, 1);
        break;
      }
    }
    //remove hoverObject from the appropriate DivGroup array
    let j = 0;
    switch (hoverObject.name) {
      case "fullVertBoardMesh":
        for (j = 0; j < fullVertDivGroup.length; j++) {
          if (hoverObject === fullVertDivGroup[j]) {
            fullVertDivGroup.splice(j, 1);
            break;
          }
        }
        break;
      case "fullHorizBoardMesh":
        for (j = 0; j < fullHorizDivGroup.length; j++) {
          if (hoverObject === fullHorizDivGroup[j]) {
            fullHorizDivGroup.splice(j, 1);
            break;
          }
        }
        break;
      case "spanVertBoardMesh":
        for (j = 0; j < spanVertDivGroup.length; j++) {
          if (hoverObject === spanVertDivGroup[j]) {
            spanVertDivGroup.splice(j, 1);
            break;
          }
        }
        break;
      case "spanHorizBoardMesh":
        for (j = 0; j < spanHorizDivGroup.length; j++) {
          if (hoverObject === spanHorizDivGroup[j]) {
            spanHorizDivGroup.splice(j, 1);
            break;
          }
        }
        break;
    }

    hoverObject = undefined;

    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);

    redoInsert();
  }

  function addCutawaySelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    //dControls.removeEventListener("drag", dragHandle, false);

    renderer.domElement.addEventListener("click", clickHandleAddCutaway, false);

    window.parent.document.getElementById("myCanvas").style.cursor =
      "crosshair";
  }

  function cancelAddCutawaySelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddCutaway,
      false,
    );
    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    //dControls.addEventListener("drag", dragHandle, false);
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addCutaway() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddCutaway,
      false,
    );

    let divLength =
      hoverObject.geometry.boundingBox.max.x -
      hoverObject.geometry.boundingBox.min.x;

    if (
      hoverObject.userData.hasCutaway != true &&
      divLength > 0.1 &&
      (hoverObject.name == "spanVertBoardMesh" ||
        hoverObject.name == "spanHorizBoardMesh")
    ) {
      divsWithCutaway.push(hoverObject);
      hoverObject.userData.hasCutaway = true;
    }

    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);

    redoInsert();
  }

  function removeCutawaySelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);

    renderer.domElement.addEventListener(
      "click",
      clickHandleRemoveCutaway,
      false,
    );

    window.parent.document.getElementById("myCanvas").style.cursor =
      "crosshair";
  }

  function cancelRemoveCutawaySelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleRemoveCutaway,
      false,
    );
    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function removeCutaway() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleRemoveCutaway,
      false,
    );

    //remove hoverObject from divsWithCutaway
    let i = 0;
    for (i = 0; i < divsWithCutaway.length; i++) {
      if (hoverObject === divsWithCutaway[i]) {
        divsWithCutaway.splice(i, 1);
        drawer_insert.userData = divsWithCutaway;
        break;
      }
    }

    hoverObject.userData.hasCutaway = false;

    controls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);

    redoInsert();
  }

  function addKnifeblockSelect() {

    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    dControls.removeEventListener("drag", dragHandle, false);
    dControls.removeEventListener("hoveron", hoverOnHandle, false);
    dControls.removeEventListener("hoveroff", hoverOffHandle, false);
    dControls.enabled = false;

    // create array of objects for the bottom of each area
    bottomAreas = [];
    var knifeblockSelectAreaCounter = 0;

    let hDivsToCheck = [];
    hDivsToCheck.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);
    hDivsToCheck.push(drawer_insert.children[3]);

    hDivsToCheck.sort(function (a, b) {
      return a.position.z - b.position.z;
    });

    let i = 0;
    for (i = 0; i < hDivsToCheck.length - 1; i++) {
      //console.log("checking hDiv = " + hDivsToCheck[i].name);

      var thisHorizbBox = new THREE.Box3().setFromObject(hDivsToCheck[i]);
      let vDivsToCheck = [];
      let vDivXsToDo = [];
      let thisvDivbBox;
      let hSpanZ = 0;
      let vDivMinZ = 0;
      let vDivMaxZ = 0;
      vDivsToCheck.push(drawer_insert.children[1]);
      vDivsToCheck.push(drawer_insert.children[2]);
      Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);
      Array.prototype.push.apply(vDivsToCheck, spanVertDivGroup);
      // console.log("hDiv vDivsToCheck = ");
      // console.log(vDivsToCheck);

      vDivsToCheck.forEach((j) => {
        thisvDivbBox = new THREE.Box3().setFromObject(j);
        //console.log("  checking vDiv = " + j.name + " @ pos x = " + j.position.x.toFixed(6));
        hSpanZ = hDivsToCheck[i].position.z;
        vDivMinZ = thisvDivbBox.min.z;
        vDivMaxZ = thisvDivbBox.max.z;
        if (
          thisHorizbBox.intersectsBox(thisvDivbBox) &&
          (+((hSpanZ - boardThickness / 2).toFixed(6) == vDivMinZ.toFixed(6)) ||
            (hSpanZ > vDivMinZ + boardThickness + 0.005 &&
              hSpanZ < vDivMaxZ - boardThickness - 0.005) ||
            j.name == "leftBoardMesh" ||
            j.name == "rightBoardMesh" ||
            j.name == "fullVertBoardMesh")
        ) {
          // then add to the list of verticial dividers to create areas for
          vDivXsToDo.push(j);
        }
      });

      // descending sort the vDivZsToDo array and loop through it creating measurement lines
      vDivXsToDo.sort(function (a, b) {
        return a.position.x - b.position.x;
      });
      // console.log("vDivXsToDo = ");
      // console.log(vDivXsToDo);

      let k = 0;
      for (k = 0; k < vDivXsToDo.length - 1; k++) {
        //console.log("  doing vDivXsToDo x = " + vDivXsToDo[k].position.x);

        let areaWidth =
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) -
          boardThickness * 2;
        let areaDepth = 0;
        let areaZOffset = 0;
        let areaOccupied = false;

        // figure out the depth of the area bounded by the hDiv and vDiv being done. Go through all the hDivs below
        // the current one being checked until one that intesects both this vDiv and the next one is found.

        let l = 0;
        for (l = i + 1; l < hDivsToCheck.length; l++) {
          //console.log("    finding hDiv to use, hDivsToCheck x = " + hDivsToCheck[l].position.z);
          var thisNextHdivBox = new THREE.Box3().setFromObject(hDivsToCheck[l]);
          var thisNextVdivBox = new THREE.Box3().setFromObject(
            vDivXsToDo[k + 1],
          );
          thisvDivbBox = new THREE.Box3().setFromObject(vDivXsToDo[k]);
          if (
            thisvDivbBox.intersectsBox(thisNextHdivBox) &&
            thisNextVdivBox.intersectsBox(thisNextHdivBox)
          ) {
            areaDepth = Math.abs(
              hDivsToCheck[i].position.z -
                hDivsToCheck[l].position.z +
                boardThickness * 2,
            );
            areaZOffset = Math.abs(
              hDivsToCheck[i].position.z - hDivsToCheck[l].position.z,
            );
            //console.log("      set areaDepth as hDiv at x = " + hDivsToCheck[l].position.z + " intersects.");
            break;
          }
        }

        if (areaDepth == 0) {
          console.log("Error: should always have found the areaDepth");
        }

        // check if the area is already occupied by a knifeblock
        let m = 0;
        for (m = 0; m < knifeblockBladeGroup.length; m++) {
          const kbWidth =
            knifeblockBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6)) {
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a Large knifeblock
        m = 0;
        for (m = 0; m < knifeblockLargeBladeGroup.length; m++) {
          const kbWidth =
            knifeblockLargeBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockLargeBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockLargeBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6)) {
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a Spicerack
        m = 0;
        for (m = 0; m < spicerackInsertGroup.length; m++) {
          const kbWidth =
            spicerackInsertGroup[m].geometry.boundingBox.max.x -
            spicerackInsertGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            spicerackInsertGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6)) {
            areaOccupied = true;
          }
        }

        var areaColour;

        const geometry = new THREE.BoxGeometry(areaWidth, 0.00001, areaDepth);
        if (
          areaWidth > minKnifeblockAreaWidth &&
          areaDepth >= minKnifeblockAreaDepth &&
          areaDepth <= maxKnifeblockAreaDepth &&
          areaOccupied == false
        ) {
          areaColour = 0x98a698;
        } else {
          areaColour = 0xff5050;
        }
        const material = new THREE.MeshPhongMaterial({
          color: areaColour,
          emissive: 0x000000,
        });
        var area = new THREE.Mesh(geometry, material);

        area.position.x =
          vDivXsToDo[k].position.x +
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) / 2;
        area.position.y = insertHeight / 4;
        area.position.z = hSpanZ + (areaDepth / 2) + boardThickness;

        area.name = "knifeblockSelectArea." + knifeblockSelectAreaCounter;

        if (
          areaWidth > minKnifeblockAreaWidth &&
          areaDepth >= minKnifeblockAreaDepth &&
          areaDepth <= maxKnifeblockAreaDepth &&
          areaOccupied == false
        ) {
          validBottomAreas.push(area);
        }
        bottomAreas.push(area);
        knifeblockSelectAreaCounter++;
        drawer_insert.add(area);
      }
    }

    render();

    sControls = new DragControls(validBottomAreas, camera, renderer.domElement);
    sControls.addEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.addEventListener("hoveroff", hoverOffKnifeblockHandle, false);

    renderer.domElement.addEventListener(
      "click",
      clickHandleAddKnifeblock,
      false,
    );
  }

  function cancelAddKnifeblockSelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddKnifeblock,
      false,
    );
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddLargeKnifeblock,
      false,
    );


    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }
    render();
    bottomAreas = [];
    validBottomAreas = [];

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addKnifeblock(selectedArea) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddKnifeblock,
      false,
    );

    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }

    render();
    bottomAreas = [];
    validBottomAreas = [];

    selectedArea.geometry.computeBoundingBox();
    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });

    const origKnifeblockWidth =
      selectedArea.geometry.boundingBox.max.x -
      selectedArea.geometry.boundingBox.min.x +
      boardThickness * 3;

    const origKnifeblockDepth =
      selectedArea.geometry.boundingBox.max.z -
      selectedArea.geometry.boundingBox.min.z +
      boardThickness * 3;
   
    // generate two new boards for the knike block and add them to the main drawer_insert object
    const newBladeDivGeometry =
      makeKnifeblockBladeGeometry(origKnifeblockWidth);
    const newHandleDivGeometry = makeKnifeblockHandleGeometry(
      origKnifeblockWidth,
      knifeblockHandleHeight,
    );

    const knifeblockBladeBoardMesh = new THREE.Mesh(
      newBladeDivGeometry,
      material,
    );
    const knifeblockHandleBoardMesh = new THREE.Mesh(
      newHandleDivGeometry,
      material,
    );

    knifeblockBladeBoardMesh.translateY(
      knifeblockBladeHeight / 2 + baseThickness / 2,
    );
    knifeblockHandleBoardMesh.translateY(
      knifeblockHandleHeight / 2 + baseThickness / 2,
    );

    knifeblockBladeBoardMesh.position.x = selectedArea.position.x;
    knifeblockHandleBoardMesh.position.x = selectedArea.position.x;

    //console.log("selectedArea.geometry.boundingBox.max.z = " + selectedArea.geometry.boundingBox.max.z);

    knifeblockBladeBoardMesh.position.z = selectedArea.position.z + (origKnifeblockDepth / 2) -
      knifeblockSmallBladeDistFromBottom;
    knifeblockHandleBoardMesh.position.z = selectedArea.position.z + (origKnifeblockDepth / 2) -
      knifeblockHandleDistFromBottom;

    //console.log("blade  at z = " + knifeblockBladeBoardMesh.position.z);
    //console.log("handle at z = " + knifeblockHandleBoardMesh.position.z);

    knifeblockBladeBoardMesh.name = "knifeblockBladeBoardMesh";
    knifeblockHandleBoardMesh.name = "knifeblockHandleBoardMesh";

    drawer_insert.add(knifeblockBladeBoardMesh);
    drawer_insert.add(knifeblockHandleBoardMesh);

    knifeblockBladeGroup.push(knifeblockBladeBoardMesh);
    knifeblockHandleGroup.push(knifeblockHandleBoardMesh);

    // const gltfloader = new GLTFLoader();
    //   gltfloader.load( '../assets/scene.gltf', function ( gltf ) {
    //
    //     scene.add( gltf.scene );
    //
    //   }, undefined, function ( error ) {
    //
    //     console.error( error );
    //
    //   } );

    // i = 0;
    // for (i = 0; i < knifeModel.children[0].children[0].children.length; i++) {
    //   //knifeModel.children[0].children[0].children[i].geometry.computeVertexNormals();
    //   knifeModel.children[0].children[0].children[i].material.metalness = 0;
    // }
    //
    //
    // console.log(knifeModel);
    // scene.add(knifeModel);

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
    redoInsert();
  }

  function cancelRemoveKnifeblockSelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleRemoveKnifeblock,
      false,
    );
    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }
    render();
    bottomAreas = [];
    validBottomAreas = [];

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function removeKnifeblock(selectedArea) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleRemoveKnifeblock,
      false,
    );
    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }

    render();
    bottomAreas = [];
    validBottomAreas = [];
    selectedArea.geometry.computeBoundingBox();

    // find the small knifeblock that matches the selectedArea
    let j = 0;
    for (j = 0; j < knifeblockBladeGroup.length; j++) {
      knifeblockBladeGroup[j].geometry.computeBoundingBox();

      if (
        selectedArea.position.x.toFixed(4) ==
        knifeblockBladeGroup[j].position.x.toFixed(4)
      ) {
        knifeblockBladeGroup[j].geometry.dispose();
        knifeblockHandleGroup[j].geometry.dispose();
        knifeblockBladeGroup[j].material.dispose();
        knifeblockHandleGroup[j].material.dispose();
        scene.remove(knifeblockBladeGroup[j]);
        scene.remove(knifeblockHandleGroup[j]);
        drawer_insert.remove(knifeblockBladeGroup[j]);
        drawer_insert.remove(knifeblockHandleGroup[j]);

        knifeblockBladeGroup.splice(j, 1);
        knifeblockHandleGroup.splice(j, 1);
      }
    }

    // find the Large knifeblock that matches the selectedArea
    j = 0;
    for (j = 0; j < knifeblockLargeBladeGroup.length; j++) {
      knifeblockLargeBladeGroup[j].geometry.computeBoundingBox();

      if (
        selectedArea.position.x.toFixed(4) ==
        knifeblockLargeBladeGroup[j].position.x.toFixed(4)
      ) {
        knifeblockLargeBladeGroup[j].geometry.dispose();
        knifeblockLargeHandleGroup[j].geometry.dispose();
        knifeblockLargeHandle2Group[j].geometry.dispose();
        knifeblockLargeBladeGroup[j].material.dispose();
        knifeblockLargeHandleGroup[j].material.dispose();
        knifeblockLargeHandle2Group[j].material.dispose();
        scene.remove(knifeblockLargeBladeGroup[j]);
        scene.remove(knifeblockLargeHandleGroup[j]);
        scene.remove(knifeblockLargeHandle2Group[j]);
        drawer_insert.remove(knifeblockLargeBladeGroup[j]);
        drawer_insert.remove(knifeblockLargeHandleGroup[j]);
        drawer_insert.remove(knifeblockLargeHandle2Group[j]);

        knifeblockLargeBladeGroup.splice(j, 1);
        knifeblockLargeHandleGroup.splice(j, 1);
        knifeblockLargeHandle2Group.splice(j, 1);
      }
    }

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";

    redoInsert();
  }

  function addLargeKnifeblockSelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    dControls.removeEventListener("drag", dragHandle, false);
    dControls.removeEventListener("hoveron", hoverOnHandle, false);
    dControls.removeEventListener("hoveroff", hoverOffHandle, false);
    dControls.enabled = false;

    // create array of objects for the bottom of each area
    bottomAreas = [];
    var knifeblockSelectAreaCounter = 0;

    let hDivsToCheck = [];
    hDivsToCheck.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);
    hDivsToCheck.push(drawer_insert.children[3]);

    hDivsToCheck.sort(function (a, b) {
      return a.position.z - b.position.z;
    });

    let i = 0;
    for (i = 0; i < hDivsToCheck.length - 1; i++) {
      //console.log("checking hDiv = " + hDivsToCheck[i].name);

      var thisHorizbBox = new THREE.Box3().setFromObject(hDivsToCheck[i]);
      let vDivsToCheck = [];
      let vDivXsToDo = [];
      let thisvDivbBox;
      let hSpanZ = 0;
      let vDivMinZ = 0;
      let vDivMaxZ = 0;
      vDivsToCheck.push(drawer_insert.children[1]);
      vDivsToCheck.push(drawer_insert.children[2]);
      Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);
      Array.prototype.push.apply(vDivsToCheck, spanVertDivGroup);
      // console.log("hDiv vDivsToCheck = ");
      // console.log(vDivsToCheck);

      vDivsToCheck.forEach((j) => {
        thisvDivbBox = new THREE.Box3().setFromObject(j);
        //console.log("  checking vDiv = " + j.name + " @ pos x = " + j.position.x.toFixed(6));
        hSpanZ = hDivsToCheck[i].position.z;
        vDivMinZ = thisvDivbBox.min.z;
        vDivMaxZ = thisvDivbBox.max.z;
        if (
          thisHorizbBox.intersectsBox(thisvDivbBox) &&
          (+((hSpanZ - boardThickness / 2).toFixed(6) == vDivMinZ.toFixed(6)) ||
            (hSpanZ > vDivMinZ + boardThickness + 0.005 &&
              hSpanZ < vDivMaxZ - boardThickness - 0.005) ||
            j.name == "leftBoardMesh" ||
            j.name == "rightBoardMesh" ||
            j.name == "fullVertBoardMesh")
        ) {
          // then add to the list of verticial dividers to create areas for
          vDivXsToDo.push(j);
        }
      });

      // descending sort the vDivZsToDo array and loop through it creating measurement lines
      vDivXsToDo.sort(function (a, b) {
        return a.position.x - b.position.x;
      });
      // console.log("vDivXsToDo = ");
      // console.log(vDivXsToDo);

      let k = 0;
      for (k = 0; k < vDivXsToDo.length - 1; k++) {
        //console.log("  doing vDivXsToDo x = " + vDivXsToDo[k].position.x);

        let areaWidth =
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) -
          boardThickness * 2;
        let areaDepth = 0;
        let areaZOffset = 0;
        let areaOccupied = false;

        // figure out the depth of the area bounded by the hDiv and vDiv being done. Go through all the hDivs below
        // the current one being checked until one that intesects both this vDiv and the next one is found.

        let l = 0;
        for (l = i + 1; l < hDivsToCheck.length; l++) {
          //console.log("    finding hDiv to use, hDivsToCheck x = " + hDivsToCheck[l].position.z);
          var thisNextHdivBox = new THREE.Box3().setFromObject(hDivsToCheck[l]);
          var thisNextVdivBox = new THREE.Box3().setFromObject(
            vDivXsToDo[k + 1],
          );
          thisvDivbBox = new THREE.Box3().setFromObject(vDivXsToDo[k]);
          if (
            thisvDivbBox.intersectsBox(thisNextHdivBox) &&
            thisNextVdivBox.intersectsBox(thisNextHdivBox)
          ) {
            areaDepth = Math.abs(
              hDivsToCheck[i].position.z -
                hDivsToCheck[l].position.z +
                boardThickness * 2,
            );
            areaZOffset = Math.abs(
              hDivsToCheck[i].position.z - hDivsToCheck[l].position.z,
            );
            //console.log("      set areaDepth as hDiv at x = " + hDivsToCheck[l].position.z + " intersects.");
            break;
          }
        }

        if (areaDepth == 0) {
          console.log("Error: should always have found the areaDepth");
        }

        // check if the area is already occupied by a knifeblock
        let m = 0;
        for (m = 0; m < knifeblockBladeGroup.length; m++) {
          const kbWidth =
            knifeblockBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6)) {
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a Large knifeblock
        m = 0;
        for (m = 0; m < knifeblockLargeBladeGroup.length; m++) {
          const kbWidth =
            knifeblockLargeBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockLargeBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockLargeBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6)) {
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a Spicerack
        m = 0;
        for (m = 0; m < spicerackInsertGroup.length; m++) {
          const kbWidth =
            spicerackInsertGroup[m].geometry.boundingBox.max.x -
            spicerackInsertGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            spicerackInsertGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6)) {
            areaOccupied = true;
          }
        }

        var areaColour;

        const geometry = new THREE.BoxGeometry(areaWidth, 0.00001, areaDepth);

        if (
          areaWidth > minLargeKnifeblockAreaWidth &&
          areaDepth >= minLargeKnifeblockAreaDepth &&
          areaOccupied == false
        ) {
          areaColour = 0x98a698;
        } else {
          areaColour = 0xff5050;
        }

        const material = new THREE.MeshPhongMaterial({
          color: areaColour,
          emissive: 0x000000,
        });
        var area = new THREE.Mesh(geometry, material);

        area.position.x =
          vDivXsToDo[k].position.x +
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) / 2;
        area.position.y = insertHeight / 4;
        area.position.z = hSpanZ + (areaDepth / 2) + boardThickness;

        area.name = "knifeblockSelectArea." + knifeblockSelectAreaCounter;

        if (
          areaWidth > minLargeKnifeblockAreaWidth &&
          areaDepth >= minLargeKnifeblockAreaDepth &&
          areaOccupied == false
        ) {
          validBottomAreas.push(area);
        }
        bottomAreas.push(area);
        knifeblockSelectAreaCounter++;
        drawer_insert.add(area);
      }
    }

    render();

    sControls = new DragControls(validBottomAreas, camera, renderer.domElement);
    sControls.addEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.addEventListener("hoveroff", hoverOffKnifeblockHandle, false);

    renderer.domElement.addEventListener(
      "click",
      clickHandleAddLargeKnifeblock,
      false,
    );
  }

  function cancelAddLargeKnifeblockSelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddLargeKnifeblock,
      false,
    );
    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }
    render();
    bottomAreas = [];
    validBottomAreas = [];

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addLargeKnifeblock(selectedArea) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddLargeKnifeblock,
      false,
    );

    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }

    render();
    bottomAreas = [];
    validBottomAreas = [];

    selectedArea.geometry.computeBoundingBox();
    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });
    //console.log(hoverKnifeblockArea);

    const origKnifeblockWidth =
      selectedArea.geometry.boundingBox.max.x -
      selectedArea.geometry.boundingBox.min.x +
      boardThickness * 3;

    const origKnifeblockDepth =
    selectedArea.geometry.boundingBox.max.z -
    selectedArea.geometry.boundingBox.min.z +
    boardThickness * 3;
    
    // generate two new boards for the knike block and add them to the main drawer_insert object
    const newBladeDivGeometry =
      makeKnifeblockBladeGeometry(origKnifeblockWidth);
    const newHandleDivGeometry = makeKnifeblockHandleGeometry(
      origKnifeblockWidth,
      knifeblockLargeHandleHeight,
    );
    const newHandle2DivGeometry = makeKnifeblockHandleGeometry(
      origKnifeblockWidth,
      knifeblockHandleHeight,
    );

    const knifeblockBladeBoardMesh = new THREE.Mesh(
      newBladeDivGeometry,
      material,
    );
    const knifeblockHandleBoardMesh = new THREE.Mesh(
      newHandleDivGeometry,
      material,
    );
    const knifeblockHandle2BoardMesh = new THREE.Mesh(
      newHandle2DivGeometry,
      material,
    );

    knifeblockBladeBoardMesh.translateY(
      knifeblockBladeHeight / 2 + baseThickness / 2,
    );
    knifeblockHandleBoardMesh.translateY(
      knifeblockLargeHandleHeight / 2 + baseThickness / 2,
    );
    knifeblockHandle2BoardMesh.translateY(
      knifeblockHandleHeight / 2 + baseThickness / 2,
    );

    knifeblockBladeBoardMesh.position.x = selectedArea.position.x;
    knifeblockHandleBoardMesh.position.x = selectedArea.position.x;
    knifeblockHandle2BoardMesh.position.x = selectedArea.position.x;

    knifeblockBladeBoardMesh.position.z = selectedArea.position.z + (origKnifeblockDepth / 2) -
      knifeblockLargeBladeDistFromBottom;
    knifeblockHandleBoardMesh.position.z = selectedArea.position.z + (origKnifeblockDepth / 2) -
      knifeblockHandleDistFromBottom;
    knifeblockHandle2BoardMesh.position.z = selectedArea.position.z + (origKnifeblockDepth / 2) -
      knifeblockHandle2DistFromBottom;

    knifeblockBladeBoardMesh.name = "knifeblockLargeBladeBoardMesh";
    knifeblockHandleBoardMesh.name = "knifeblockLargeHandleBoardMesh";
    knifeblockHandle2BoardMesh.name = "knifeblockLargeHandle2BoardMesh";

    drawer_insert.add(knifeblockBladeBoardMesh);
    drawer_insert.add(knifeblockHandleBoardMesh);
    drawer_insert.add(knifeblockHandle2BoardMesh);

    knifeblockLargeBladeGroup.push(knifeblockBladeBoardMesh);
    knifeblockLargeHandleGroup.push(knifeblockHandleBoardMesh);
    knifeblockLargeHandle2Group.push(knifeblockHandle2BoardMesh);

    // const gltfloader = new GLTFLoader();
    //   gltfloader.load( '../assets/scene.gltf', function ( gltf ) {
    //
    //     scene.add( gltf.scene );
    //
    //   }, undefined, function ( error ) {
    //
    //     console.error( error );
    //
    //   } );

    // i = 0;
    // for (i = 0; i < knifeModel.children[0].children[0].children.length; i++) {
    //   //knifeModel.children[0].children[0].children[i].geometry.computeVertexNormals();
    //   knifeModel.children[0].children[0].children[i].material.metalness = 0;
    // }
    //
    //
    // console.log(knifeModel);
    // scene.add(knifeModel);

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
    //console.log("calling redoInsert from addLargeKnifeBlock");
    redoInsert();
  }

  function removeKnifeblockSelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    dControls.removeEventListener("drag", dragHandle, false);
    dControls.removeEventListener("hoveron", hoverOnHandle, false);
    dControls.removeEventListener("hoveroff", hoverOffHandle, false);
    dControls.enabled = false;

    // create array of objects for the bottom of each area containing a knifeblock
    bottomAreas = [];
    var knifeblockSelectAreaCounter = 0;

    let hDivsToCheck = [];
    hDivsToCheck.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);
    hDivsToCheck.push(drawer_insert.children[3]);

    hDivsToCheck.sort(function (a, b) {
      return a.position.z - b.position.z;
    });

    let i = 0;
    for (i = 0; i < hDivsToCheck.length - 1; i++) {
    //console.log("checking hDiv = " + hDivsToCheck[i].name + " @ pos x = " + hDivsToCheck[i].position.x.toFixed(6));

      var thisHorizbBox = new THREE.Box3().setFromObject(hDivsToCheck[i]);
      let vDivsToCheck = [];
      let vDivXsToDo = [];
      let thisvDivbBox;
      let hSpanZ = 0;
      let vDivMinZ = 0;
      let vDivMaxZ = 0;
      vDivsToCheck.push(drawer_insert.children[1]);
      vDivsToCheck.push(drawer_insert.children[2]);
      Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);
      Array.prototype.push.apply(vDivsToCheck, spanVertDivGroup);

      vDivsToCheck.forEach((j) => {
        thisvDivbBox = new THREE.Box3().setFromObject(j);
        //console.log("  checking vDiv = " + j.name + " @ pos x = " + j.position.x.toFixed(6));
        hSpanZ = hDivsToCheck[i].position.z;
        vDivMinZ = thisvDivbBox.min.z;
        vDivMaxZ = thisvDivbBox.max.z;
        if (
          thisHorizbBox.intersectsBox(thisvDivbBox) &&
          (+((hSpanZ - boardThickness / 2).toFixed(6) == vDivMinZ.toFixed(6)) ||
            (hSpanZ > vDivMinZ + boardThickness + 0.005 &&
              hSpanZ < vDivMaxZ - boardThickness - 0.005) ||
            j.name == "leftBoardMesh" ||
            j.name == "rightBoardMesh" ||
            j.name == "fullVertBoardMesh")
        ) {
          // then add to the list of verticial dividers to create areas for
          vDivXsToDo.push(j);
        }
      });

      // descending sort the vDivZsToDo array and loop through it creating measurement lines
      vDivXsToDo.sort(function (a, b) {
        return a.position.x - b.position.x;
      });

      let k = 0;
      for (k = 0; k < vDivXsToDo.length - 1; k++) {
        let areaWidth =
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) -
          boardThickness * 2;
        let areaDepth = 0;
        let areaZOffset = 0;
        let areaOccupied = false;

        // figure out the depth of the area bounded by the hDiv and vDiv being done. Go through all the hDivs below
        // the current one being checked until one that intesects both this vDiv and the next one is found.

        let l = 0;
        for (l = i + 1; l < hDivsToCheck.length; l++) {
          //console.log("    finding hDiv to use, hDivsToCheck x = " + hDivsToCheck[l].position.z);
          var thisNextHdivBox = new THREE.Box3().setFromObject(hDivsToCheck[l]);
          var thisNextVdivBox = new THREE.Box3().setFromObject(
            vDivXsToDo[k + 1],
          );
          thisvDivbBox = new THREE.Box3().setFromObject(vDivXsToDo[k]);
          if (
            thisvDivbBox.intersectsBox(thisNextHdivBox) &&
            thisNextVdivBox.intersectsBox(thisNextHdivBox)
          ) {
            areaDepth = Math.abs(
              hDivsToCheck[i].position.z -
                hDivsToCheck[l].position.z +
                boardThickness * 2,
            );
            areaZOffset = Math.abs(
              hDivsToCheck[i].position.z - hDivsToCheck[l].position.z,
            );
            //console.log("      set areaDepth as hDiv at x = " + hDivsToCheck[l].position.z + " intersects.");
            break;
          }
        }

        if (areaDepth == 0) {
          console.log("Error: should always have found the areaDepth");
        }

        // check if the area is already occupied by a small knifeblock
        let m = 0;
        for (m = 0; m < knifeblockBladeGroup.length; m++) {
          //console.log("checking knifeblockBladeGroup m = " +  m);
          const kbWidth =
            knifeblockBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          // console.log("checking vDivXsToDo[k]." + vDivXsToDo[k].name);
          // console.log("and hDivsToCheck[i]." + hDivsToCheck[i].name);
          // console.log("vDivXsToDo[k].position.x.toFixed(4) = " + vDivXsToDo[k].position.x.toFixed(4));
          // console.log("kbMinX.toFixed(4) = " + kbMinX.toFixed(4));
          // console.log("hDivsToCheck[i + 1].position.z = " + hDivsToCheck[i + 1].position.z.toFixed(4));
          // console.log("knifeblockBladeGroup[m].position.z = " + knifeblockBladeGroup[m].position.z.toFixed(4));
          // console.log("knifeblockSmallBladeDistFromBottom = " + knifeblockSmallBladeDistFromBottom.toFixed(4));
          // console.log("(knifeblockBladeGroup[m].position.z - knifeblockSmallBladeDistFromBottom).toFixed(4) = " + (knifeblockBladeGroup[m].position.z + knifeblockSmallBladeDistFromBottom).toFixed(4));
          // console.log("-----------");

          if (
            vDivXsToDo[k].position.x.toFixed(4) == kbMinX.toFixed(4) &&
            hDivsToCheck[i + 1].position.z.toFixed(4) ==
              (
                knifeblockBladeGroup[m].position.z + (boardThickness / 2) +
                knifeblockSmallBladeDistFromBottom
              ).toFixed(4)
          ) {
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a large knifeblock
        m = 0;
        for (m = 0; m < knifeblockLargeBladeGroup.length; m++) {
          //console.log("checking knifeblockLargeBladeGroup m = " +  m);
          const kbWidth =
            knifeblockLargeBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockLargeBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockLargeBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          // console.log("checking vDivXsToDo[k]." + vDivXsToDo[k].name);
          // console.log("and hDivsToCheck[i]." + hDivsToCheck[i].name);
          // console.log("vDivXsToDo[k].position.x.toFixed(6) = " + vDivXsToDo[k].position.x.toFixed(6));
          // console.log("kbMinX.toFixed(6) = " + kbMinX.toFixed(6));
          // console.log("hDivsToCheck[i + 1].position.z.toFixed(4) = " + hDivsToCheck[i + 1].position.z.toFixed(4));
          // console.log("knifeblockLargeBladeGroup[m].position.z = " + knifeblockLargeBladeGroup[m].position.z.toFixed(4));
          // console.log("knifeblockLargeBladeDistFromBottom = " + knifeblockLargeBladeDistFromBottom.toFixed(4));
          // console.log("(knifeblockLargeBladeGroup[m].position.z + (boardThickness / 2) + knifeblockLargeBladeDistFromBottom).toFixed(4) = " + (knifeblockLargeBladeGroup[m].position.z + (boardThickness / 2) + knifeblockLargeBladeDistFromBottom).toFixed(4));
          // console.log("-----------");

          if (
            vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6) &&
            hDivsToCheck[i + 1].position.z.toFixed(4) ==
              (
                knifeblockLargeBladeGroup[m].position.z + (boardThickness / 2) +
                knifeblockLargeBladeDistFromBottom
              ).toFixed(4)
          ) {
            areaOccupied = true;
          }
        }

        var areaColour;
        const minAreaWidth = 0.1;
        const minAreaDepth = 0.2;

        if (areaOccupied == true) {
          const geometry = new THREE.BoxGeometry(areaWidth, 0.00001, areaDepth);
          areaColour = 0x98a698;
          const material = new THREE.MeshPhongMaterial({
            color: areaColour,
            emissive: 0x000000,
          });
          var area = new THREE.Mesh(geometry, material);

          area.position.x =
            vDivXsToDo[k].position.x +
            Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) /
              2;
          area.position.y = insertHeight / 4;
          area.position.z = hSpanZ + areaDepth / 2;

          area.name =
            "knifeblockDeleteSelectArea." + knifeblockSelectAreaCounter;

          validBottomAreas.push(area);
          bottomAreas.push(area);
          knifeblockSelectAreaCounter++;
          drawer_insert.add(area);
        }
      }
    }

    render();

    sControls = new DragControls(validBottomAreas, camera, renderer.domElement);
    sControls.addEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.addEventListener("hoveroff", hoverOffKnifeblockHandle, false);

    renderer.domElement.addEventListener(
      "click",
      clickHandleRemoveKnifeblock,
      false,
    );
  }

  function addSpicerackSelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    dControls.removeEventListener("drag", dragHandle, false);
    dControls.removeEventListener("hoveron", hoverOnHandle, false);
    dControls.removeEventListener("hoveroff", hoverOffHandle, false);
    dControls.enabled = false;

    // create array of objects for the bottom of each area
    bottomAreas = [];
    var spicerackSelectAreaCounter = 0;

    let hDivsToCheck = [];
    hDivsToCheck.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);
    hDivsToCheck.push(drawer_insert.children[3]);

    hDivsToCheck.sort(function (a, b) {
      return a.position.z - b.position.z;
    });

    let i = 0;
    for (i = 0; i < hDivsToCheck.length - 1; i++) {
      //console.log("checking hDiv = " + hDivsToCheck[i].name);

      var thisHorizbBox = new THREE.Box3().setFromObject(hDivsToCheck[i]);
      let vDivsToCheck = [];
      let vDivXsToDo = [];
      let thisvDivbBox;
      let hSpanZ = 0;
      let vDivMinZ = 0;
      let vDivMaxZ = 0;
      vDivsToCheck.push(drawer_insert.children[1]);
      vDivsToCheck.push(drawer_insert.children[2]);
      Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);
      Array.prototype.push.apply(vDivsToCheck, spanVertDivGroup);

      vDivsToCheck.forEach((j) => {
        thisvDivbBox = new THREE.Box3().setFromObject(j);
        //console.log("  checking vDiv = " + j.name + " @ pos x = " + j.position.x.toFixed(6));
        hSpanZ = hDivsToCheck[i].position.z;
        vDivMinZ = thisvDivbBox.min.z;
        vDivMaxZ = thisvDivbBox.max.z;
        if (
          thisHorizbBox.intersectsBox(thisvDivbBox) &&
          (+((hSpanZ - boardThickness / 2).toFixed(6) == vDivMinZ.toFixed(6)) ||
            (hSpanZ > vDivMinZ + boardThickness + 0.005 &&
              hSpanZ < vDivMaxZ - boardThickness - 0.005) ||
            j.name == "leftBoardMesh" ||
            j.name == "rightBoardMesh" ||
            j.name == "fullVertBoardMesh")
        ) {
          // then add to the list of verticial dividers to create areas for
          vDivXsToDo.push(j);
        }
      });

      // descending sort the vDivZsToDo array and loop through it
      vDivXsToDo.sort(function (a, b) {
        return a.position.x - b.position.x;
      });
      // console.log("vDivXsToDo = ");
      // console.log(vDivXsToDo);

      let k = 0;
      for (k = 0; k < vDivXsToDo.length - 1; k++) {
        //console.log("  doing vDivXsToDo x = " + vDivXsToDo[k].position.x);

        let areaWidth =
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) -
          boardThickness * 2;
        let spicerackWidth =
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) -
          boardThickness;
        let areaDepth = 0;
        let areaZOffset = 0;
        let areaOccupied = false;

        // figure out the depth of the area bounded by the hDiv and vDiv being done. Go through all the hDivs below
        // the current one being checked until one that intesects both this vDiv and the next one is found.

        let l = 0;
        for (l = i + 1; l < hDivsToCheck.length; l++) {
          //console.log("    finding hDiv to use, hDivsToCheck x = " + hDivsToCheck[l].position.z);
          var thisNextHdivBox = new THREE.Box3().setFromObject(hDivsToCheck[l]);
          var thisNextVdivBox = new THREE.Box3().setFromObject(
            vDivXsToDo[k + 1],
          );
          thisvDivbBox = new THREE.Box3().setFromObject(vDivXsToDo[k]);
          if (
            thisvDivbBox.intersectsBox(thisNextHdivBox) &&
            thisNextVdivBox.intersectsBox(thisNextHdivBox)
          ) {
            areaDepth = Math.abs(
              hDivsToCheck[i].position.z -
                hDivsToCheck[l].position.z +
                boardThickness * 2,
            );
            areaZOffset = Math.abs(
              hDivsToCheck[i].position.z - hDivsToCheck[l].position.z,
            );
            //console.log("      set areaDepth as hDiv at x = " + hDivsToCheck[l].position.z + " intersects.");
            break;
          }
        }

        if (areaDepth == 0) {
          console.log("Error: should always have found the areaDepth");
        }

        // check if the area is already occupied by a knifeblock
        let m = 0;
        for (m = 0; m < knifeblockBladeGroup.length; m++) {
          const kbWidth =
            knifeblockBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6) &&
            hSpanZ < knifeblockHandleGroup[m].position.z) {
            //console.log("area Occupied by a small knifeblock");
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a Large knifeblock
        m = 0;
        for (m = 0; m < knifeblockLargeBladeGroup.length; m++) {
          const kbWidth =
            knifeblockLargeBladeGroup[m].geometry.boundingBox.max.x -
            knifeblockLargeBladeGroup[m].geometry.boundingBox.min.x;
          const kbMinX =
            knifeblockLargeBladeGroup[m].position.x -
            kbWidth / 2 +
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == kbMinX.toFixed(6) &&
            hSpanZ < knifeblockLargeHandleGroup[m].position.z) {
            //console.log("area Occupied by a large knifeblock");
            areaOccupied = true;
          }
        }

        // check if the area is already occupied by a Spicerack
        m = 0;
        for (m = 0; m < spicerackInsertGroup.length; m++) {
          const srWidth =
            spicerackInsertGroup[m].geometry.boundingBox.max.x -
            spicerackInsertGroup[m].geometry.boundingBox.min.x;
          const srMinX =
            spicerackInsertGroup[m].position.x -
            srWidth / 2 -
            boardThickness / 2;

          if (vDivXsToDo[k].position.x.toFixed(6) == srMinX.toFixed(6) &&
            (hSpanZ + (spicerackAreaDepth / 2) + (boardThickness / 2)) <= (spicerackInsertGroup[m].position.z + 0.001) &&
            (hSpanZ + (spicerackAreaDepth / 2) + (boardThickness / 2)) >= (spicerackInsertGroup[m].position.z - 0.001)) {
            //console.log("area Occupied by a spicerack");
            areaOccupied = true;
          }
        }

        var areaColour;
        var arDepth = Math.round((areaDepth + boardThickness) * 1000) / 1000;

        const geometry = new THREE.BoxGeometry(areaWidth, 0.00001, areaDepth);
        if (
          spicerackWidth > minSpicerackAreaWidth &&
          spicerackWidth < maxSpicerackAreaWidth &&
          arDepth <= spicerackAreaDepth + 0.001 &&
          arDepth >= spicerackAreaDepth - 0.001 &&
          areaOccupied == false
        ) {
          areaColour = 0x98a698;
        } else {
          areaColour = 0xff5050;
        }
        const material = new THREE.MeshPhongMaterial({
          color: areaColour,
          emissive: 0x000000,
        });
        var area = new THREE.Mesh(geometry, material);

        area.position.x =
          vDivXsToDo[k].position.x +
          Math.abs(vDivXsToDo[k].position.x - vDivXsToDo[k + 1].position.x) / 2;
        area.position.y = insertHeight / 4;
        area.position.z = hSpanZ + (areaDepth / 2) + boardThickness;

        area.name = "spicerackSelectArea." + spicerackSelectAreaCounter;

        if (
          spicerackWidth > minSpicerackAreaWidth &&
          spicerackWidth < maxSpicerackAreaWidth &&
          arDepth <= spicerackAreaDepth + 0.001 &&
          arDepth >= spicerackAreaDepth - 0.001 &&
          areaOccupied == false
        ) {
          validBottomAreas.push(area);
        }
        bottomAreas.push(area);
        spicerackSelectAreaCounter++;
        drawer_insert.add(area);
      }
    }

    render();

    sControls = new DragControls(validBottomAreas, camera, renderer.domElement);
    sControls.addEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.addEventListener("hoveroff", hoverOffKnifeblockHandle, false);

    renderer.domElement.addEventListener(
      "click",
      clickHandleAddSpicerack,
      false,
    );
  }

  function cancelAddSpicerackSelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddSpicerack,
      false,
    );
    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }
    render();
    bottomAreas = [];
    validBottomAreas = [];

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function addSpicerack(selectedArea) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleAddSpicerack,
      false,
    );

    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }

    render();
    bottomAreas = [];
    validBottomAreas = [];

    selectedArea.geometry.computeBoundingBox();
    const material = new THREE.MeshPhongMaterial({ map: textureSideInUse });

    const origSpicerackWidth =
      selectedArea.geometry.boundingBox.max.x -
      selectedArea.geometry.boundingBox.min.x +
      boardThickness;

    // generate the new spicerack insert and add it to the main drawer_insert object
    const newSpicerackInsertGeometry =
      makeSpicerackInsertGeometry(origSpicerackWidth);

    const spicerackInsertBoardMesh = new THREE.Mesh(
      newSpicerackInsertGeometry,
      material,
    );

    spicerackInsertBoardMesh.translateY(0.025);
    spicerackInsertBoardMesh.position.x = selectedArea.position.x;
    spicerackInsertBoardMesh.position.z = selectedArea.position.z;

    spicerackInsertBoardMesh.rotateX(5.0);

    spicerackInsertBoardMesh.name = "spicerackInsertBoardMesh";

    drawer_insert.add(spicerackInsertBoardMesh);

    spicerackInsertGroup.push(spicerackInsertBoardMesh);
    spicerackDisabledMoveableObjects.push([]);

    // const gltfloader = new GLTFLoader();
    //   gltfloader.load( '../assets/scene.gltf', function ( gltf ) {
    //
    //     scene.add( gltf.scene );
    //
    //   }, undefined, function ( error ) {
    //
    //     console.error( error );
    //
    //   } );

    // i = 0;
    // for (i = 0; i < knifeModel.children[0].children[0].children.length; i++) {
    //   //knifeModel.children[0].children[0].children[i].geometry.computeVertexNormals();
    //   knifeModel.children[0].children[0].children[i].material.metalness = 0;
    // }
    //
    //
    // console.log(knifeModel);
    // scene.add(knifeModel);

    spicerackDisableAdjacentDivs(selectedArea.position.z);

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
    redoInsert();
  }

  function cancelRemoveSpicerackSelect() {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleRemoveSpicerack,
      false,
    );
    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }
    render();
    bottomAreas = [];
    validBottomAreas = [];

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";
  }

  function removeSpicerack(selectedArea) {
    renderer.domElement.removeEventListener(
      "click",
      clickHandleRemoveSpicerack,
      false,
    );
    sControls.removeEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.removeEventListener("hoveroff", hoverOffKnifeblockHandle, false);
    sControls.enabled = false;

    //remove the selection areas and empty the bottomAreas array
    let i = 0;
    for (i = 0; i < bottomAreas.length; i++) {
      bottomAreas[i].geometry.dispose();
      bottomAreas[i].material.dispose();
      scene.remove(bottomAreas[i]);
      drawer_insert.remove(bottomAreas[i]);
    }

    render();
    bottomAreas = [];
    validBottomAreas = [];
    selectedArea.geometry.computeBoundingBox();

    // find the spicerack that matches the selectedArea
    let j = 0;
    for (j = 0; j < spicerackInsertGroup.length; j++) {
      spicerackInsertGroup[j].geometry.computeBoundingBox();

      if (
        selectedArea.position.x.toFixed(3) ==
          spicerackInsertGroup[j].position.x.toFixed(3) &&
        selectedArea.position.z.toFixed(2) ==
          spicerackInsertGroup[j].position.z.toFixed(2)
      ) {
        spicerackInsertGroup[j].geometry.dispose();
        spicerackInsertGroup[j].material.dispose();
        scene.remove(spicerackInsertGroup[j]);
        drawer_insert.remove(spicerackInsertGroup[j]);

        spicerackInsertGroup.splice(j, 1);
        moveableObjects.push(...spicerackDisabledMoveableObjects[j]);
      }
    }

    controls.enabled = true;

    dControls.enabled = true;
    dControls.addEventListener("dragstart", dragStartHandle, false);
    dControls.addEventListener("dragend", dragEndHandle, false);
    dControls.addEventListener("drag", dragHandle, false);
    dControls.addEventListener("hoveron", hoverOnHandle, false);
    dControls.addEventListener("hoveroff", hoverOffHandle, false);

    window.parent.document.getElementById("myCanvas").style.cursor = "default";

    redoInsert();
  }

  function removeSpicerackSelect() {
    controls.enabled = false;
    dControls.removeEventListener("dragstart", dragStartHandle, false);
    dControls.removeEventListener("dragend", dragEndHandle, false);
    dControls.removeEventListener("drag", dragHandle, false);
    dControls.removeEventListener("hoveron", hoverOnHandle, false);
    dControls.removeEventListener("hoveroff", hoverOffHandle, false);
    dControls.enabled = false;

    // create array of objects for the bottom of each occupied area to potentially remove a spicereack
    bottomAreas = [];
    var spicerackSelectAreaCounter = 0;
    var areaColour;

    let m = 0;
    for (m = 0; m < spicerackInsertGroup.length; m++) {
      const spWidth =
        spicerackInsertGroup[m].geometry.boundingBox.max.x -
        spicerackInsertGroup[m].geometry.boundingBox.min.x +
        boardThickness * 2;
      const spMinX =
        spicerackInsertGroup[m].position.x - spWidth / 2 + boardThickness / 2;

      const geometry = new THREE.BoxGeometry(
        spWidth - boardThickness * 4,
        0.00001,
        spicerackAreaDepth - boardThickness * 2,
      );
      areaColour = 0x98a698;
      const material = new THREE.MeshPhongMaterial({
        color: areaColour,
        emissive: 0x000000,
      });
      var area = new THREE.Mesh(geometry, material);

      area.position.x = spicerackInsertGroup[m].position.x;
      area.position.y = insertHeight - 0.01;
      area.position.z = spicerackInsertGroup[m].position.z;

      area.name = "spicerackDeleteSelectArea." + spicerackSelectAreaCounter;

      validBottomAreas.push(area);
      bottomAreas.push(area);
      spicerackSelectAreaCounter++;
      drawer_insert.add(area);
    }

    render();

    sControls = new DragControls(validBottomAreas, camera, renderer.domElement);
    sControls.addEventListener("hoveron", hoverOnKnifeblockHandle, false);
    sControls.addEventListener("hoveroff", hoverOffKnifeblockHandle, false);

    renderer.domElement.addEventListener(
      "click",
      clickHandleRemoveSpicerack,
      false,
    );
  }

  function spicerackDisableAdjacentDivs(spicerackZ) {
    // remove the horizontal dividers bordering the spicerack from the moveableObjects array
    // as the spicerack openings needs to stay fixed at 4 3/4" depth

    let hDivsToCheck = [];
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);

    hDivsToCheck.sort(function (a, b) {
      return b.position.z - a.position.z;
    });

    let k = 0;
    for (k = 0; k < hDivsToCheck.length; k++) {
      //console.log("checking " + hDivsToCheck[k].name);

      var hDivZ = Math.round(hDivsToCheck[k].position.z * 100000 + Number.EPSILON) / 100000;
      var spInsertZfront = Math.round((spicerackZ + (spicerackAreaDepth / 2) + (boardThickness / 2)) * 100000 + Number.EPSILON,) / 100000;
      var spInsertZback = Math.round((spicerackZ - (spicerackAreaDepth / 2) - (boardThickness / 2)) * 100000 + Number.EPSILON,) / 100000;

      // console.log("hDivZ = " + hDivZ.toFixed(2));
      // console.log("spicerack insert area z = " + spicerackZ);
      // console.log("spInsertZfront z = " + spInsertZfront.toFixed(2));
      // console.log("spInsertZback z = " + spInsertZback.toFixed(2));

      if (hDivZ.toFixed(2) == spInsertZfront.toFixed(2) || hDivZ.toFixed(2) == spInsertZback.toFixed(2)) {
        //console.log('removing from moveableObjects: ' + hDivsToCheck[k].name);
        let i = 0;
        for (i = 0; i < moveableObjects.length; i++) {
          if (hDivsToCheck[k] === moveableObjects[i]) {
            moveableObjects.splice(i, 1);
            //console.log(". adding to spicerackDisabledMoveableObjects at pos = " + (spicerackInsertGroup.length - 1));
            spicerackDisabledMoveableObjects[spicerackInsertGroup.length - 1].push(hDivsToCheck[k]);
            break;
          }
        }
      }
    }
  }

  function redoInsert() {
    //console.log("running redoInsert - start");
    //debugger;

    // Create new BufferGeometries for the main side parts

    // replace the existing BufferGeometries in the 4 primary side meshes
    // left side mesh
    drawer_insert.children[1].geometry.dispose();
    drawer_insert.children[1].geometry.copy(makeSideGeometry());
    // right side mesh
    drawer_insert.children[2].geometry.dispose();
    drawer_insert.children[2].geometry.copy(makeSideGeometry());
    // front mesh
    drawer_insert.children[3].geometry.dispose();
    drawer_insert.children[3].geometry.copy(makeFbGeometry());

    // back mesh
    drawer_insert.children[4].geometry.dispose();
    drawer_insert.children[4].geometry.copy(makeFbGeometry());

    // position the sides, front and back
    drawer_insert.children[1].position.x = 0;
    drawer_insert.children[1].position.y = divHeight / 2 + baseThickness / 2;
    drawer_insert.children[1].translateZ(
      0 - (insertWidth / 2 - boardThickness / 2),
    );
    drawer_insert.children[2].position.x = 0;
    drawer_insert.children[2].position.y = divHeight / 2 + baseThickness / 2;
    drawer_insert.children[2].translateZ(insertWidth / 2 - boardThickness / 2);
    drawer_insert.children[3].position.z = 0;
    drawer_insert.children[3].position.y = divHeight / 2 + baseThickness / 2;
    drawer_insert.children[3].translateZ(insertDepth / 2 - boardThickness / 2);
    drawer_insert.children[4].position.z = 0;
    drawer_insert.children[4].position.y = divHeight / 2 + baseThickness / 2;
    drawer_insert.children[4].translateZ(
      0 - (insertDepth / 2 - boardThickness / 2),
    );


    // redo the translucent drawer box unless it is switched off

    dbRightMesh.geometry.dispose();
    dbLeftMesh.geometry.dispose();
    dbBackMesh.geometry.dispose();
    dbFrontMesh.geometry.dispose();
    dbBaseMesh.geometry.dispose();
    
    if ( dbSwitchOn == true ) {

      dbRightMesh.geometry.copy(makeDbSideGeometry());
      dbLeftMesh.geometry.copy(makeDbSideGeometry());
      dbBackMesh.geometry.copy(makeDbBackGeometry());
      dbFrontMesh.geometry.copy(makeDbFrontGeometry());
      dbBaseMesh.geometry.copy(makeDbBaseGeometry());

      dbRightMesh.visible = true;
      dbLeftMesh.visible = true;
      dbBackMesh.visible = true;
      dbFrontMesh.visible = true;
      dbBaseMesh.visible = true; 

      dbRightMesh.position.x = insertWidth / 2 + (drawerboxThickness / 2) + drawerboxSpace;
      dbRightMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2);
      
      dbLeftMesh.position.x = 0 - (insertWidth / 2 + (drawerboxThickness / 2) + drawerboxSpace);
      dbLeftMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2);
      
      dbBackMesh.position.z = 0 - (insertDepth / 2) - (drawerboxThickness / 2) - drawerboxSpace;
      dbBackMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2);
      dbFrontMesh.position.z = 0 + (insertDepth / 2) + (drawerboxThickness / 2) + drawerboxSpace;
      dbFrontMesh.position.y = drawerboxHeight / 2 - (baseThickness / 2) - 0.00125;

      dbBaseMesh.position.z = 0 - (drawerboxThickness / 2);
      dbBaseMesh.position.y = 0 - (drawerboxThickness / 2) - (baseThickness / 2);

    } else {
      dbRightMesh.visible = false;
      dbLeftMesh.visible = false;
      dbBackMesh.visible = false;
      dbFrontMesh.visible = false;
      dbBaseMesh.visible = false;      
    }

    //the order of replacing geometries is important. partial divs are last as they need to be last to have
    //the notches added
  
    // replace the BufferGeometries in the full vertical dividers
    fullVertDivGroup.forEach((i) => {
      const newFvdGeometry = makeFullVertDivGeometry();
      i.geometry.dispose();
      i.geometry.copy(newFvdGeometry);

      //turn off clamping
      i.userData.limit = {
        min: new THREE.Vector3(
          0 - (insertWidth / 2 - minDivWidth),
          1,
          i.position.z,
        ),
        max: new THREE.Vector3(insertWidth / 2 - minDivWidth, 1, i.position.z),
      };

      // move the divider up into position
      i.position.y = divHeight / 2 + baseThickness / 2;

      // turn clamping back on
      i.userData.limit = {
        min: new THREE.Vector3(
          0 - (insertWidth / 2 - minDivWidth),
          i.position.y,
          i.position.z,
        ),
        max: new THREE.Vector3(
          insertWidth / 2 - minDivWidth,
          i.position.y,
          i.position.z,
        ),
      };
    });

    // replace the BufferGeometries in the full horizontal dividers
    fullHorizDivGroup.forEach((i) => {
      const newFhdGeometry = makeFullHorizDivGeometry();
      i.geometry.dispose();
      i.geometry.copy(newFhdGeometry);

      //turn off clamping
      i.userData.limit = {
        min: new THREE.Vector3(
          1,
          i.position.y,
          0 - (insertDepth / 2 - minDivWidth),
        ),
        max: new THREE.Vector3(1, i.position.y, insertDepth / 2 - minDivWidth),
      };

      // move the divider up into position
      i.position.y = divHeight / 2 + baseThickness / 2;

      // turn clamping back on
      i.userData.limit = {
        min: new THREE.Vector3(
          i.position.x,
          i.position.y,
          0 - (insertDepth / 2 - minDivWidth),
        ),
        max: new THREE.Vector3(
          i.position.x,
          i.position.y,
          insertDepth / 2 - minDivWidth,
        ),
      };
    });

    // do any small Knifeblocks
    let i = 0;
    for (i = 0; i < knifeblockBladeGroup.length; i++) {
      // figure out the length and location then replace the knifeblock geometries
      let closestPosVDiv = drawer_insert.children[2].position.x;
      let closestNegVDiv = drawer_insert.children[1].position.x;

      fullVertDivGroup.forEach((j) => {

        if (
          j.position.x > knifeblockBladeGroup[i].position.x &&
          j.position.x < closestPosVDiv
        ) {
          closestPosVDiv = j.position.x;
        }

        if (
          j.position.x < knifeblockBladeGroup[i].position.x &&
          j.position.x > closestNegVDiv
        ) {
          closestNegVDiv = j.position.x;
        }
      });

      let j = 0;
      for (j = 0; j < spanVertDivGroup.length; j++) {
        var bBox = new THREE.Box3().setFromObject(spanVertDivGroup[j]);

        // if this spanning vertical divider hits this spanning knifeblock divider
        let endZofHorizDivBack = +(knifeblockBladeGroup[i].position.z - (boardThickness / 2)).toFixed(6);
        let endZofHorizDivFront = +(knifeblockBladeGroup[i].position.z + (boardThickness / 2)).toFixed(6);
        let endZofHorizDivMid = +knifeblockBladeGroup[i].position.z.toFixed(6);
        let endZofVertDivBack = +bBox.min.z.toFixed(6);
        let endZofVertDivFront = +bBox.max.z.toFixed(6);

        if (
          endZofHorizDivBack <= endZofVertDivBack ||
          endZofHorizDivFront >= endZofVertDivFront
        ) {
          continue;
        }

        if (
          spanVertDivGroup[j].position.x > knifeblockBladeGroup[i].position.x &&
          spanVertDivGroup[j].position.x < closestPosVDiv
        ) {
          closestPosVDiv = spanVertDivGroup[j].position.x;
        }

        if (
          spanVertDivGroup[j].position.x < knifeblockBladeGroup[i].position.x &&
          spanVertDivGroup[j].position.x > closestNegVDiv
        ) {
          closestNegVDiv = spanVertDivGroup[j].position.x;
        }
      }

      const newKnifeblockWidth =
        closestPosVDiv - closestNegVDiv + boardThickness;
      const newKnifeblockLocateX =
        closestNegVDiv + (closestPosVDiv - closestNegVDiv) / 2;

      // find the next horizontal divider towards the front from the z location of
      // the handle div to set the z spacing of the two knifeblock divs
      let hDivsToCheck = [];
      hDivsToCheck.push(drawer_insert.children[3]);
      Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
      Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);
      hDivsToCheck.push(drawer_insert.children[4]);

      hDivsToCheck.sort(function (a, b) {
        return b.position.z - a.position.z;
      });

      var closestFrontHDiv = drawer_insert.children[3];

      let k = 0;
      for (k = 0; k < hDivsToCheck.length; k++) {
        //check if this hDiv is closest to the handle div
        //lowest z where closestPosVDiv and closestNegVDiv are both within the max-min z bounds of the hDiv
        //hDivsToCheck[i].geometry.computeBoundingBox();
        //console.log("checking hDiv " + hDivsToCheck[k].name);
        var bBox = new THREE.Box3().setFromObject(hDivsToCheck[k]);

        // console.log("  hDiv at z = " + hDivsToCheck[k].position.z);
        // console.log("  handle at z = " + knifeblockHandleGroup[i].position.z);

        // end checking once the hdiv being checked is behind the handle div of the knifeblock
        if (hDivsToCheck[k].position.z < knifeblockHandleGroup[i].position.z) {
          //console.log(". ending checking hDiv " + hDivsToCheck[k].name);
          break;
        }

        // console.log("  bBox.max.x - boardThickness = " + (bBox.max.x - boardThickness).toFixed(6));
        // console.log("  closestPosVDiv - (boardThickness / 2) = " + (closestPosVDiv - (boardThickness / 2)).toFixed(6));
        // console.log("  bBox.min.x + boardThickness = " + (bBox.min.x + boardThickness).toFixed(6));
        // console.log("  closestNegVDiv + (boardThickness / 2) = " + (closestNegVDiv + (boardThickness / 2)).toFixed(6));

        if ((bBox.max.x - boardThickness).toFixed(6) == (closestPosVDiv - (boardThickness / 2)).toFixed(6) || 
          (bBox.min.x + boardThickness).toFixed(6) == (closestNegVDiv + (boardThickness / 2)).toFixed(6)) {
          closestFrontHDiv = hDivsToCheck[k];
        }
      }

      const newBladeDivGeometry = makeKnifeblockBladeGeometry(newKnifeblockWidth);
      const newHandleDivGeometry = makeKnifeblockHandleGeometry(
        newKnifeblockWidth,
        knifeblockHandleHeight);

      knifeblockBladeGroup[i].geometry.dispose();
      knifeblockHandleGroup[i].geometry.dispose();
      knifeblockBladeGroup[i].geometry.copy(newBladeDivGeometry);
      knifeblockHandleGroup[i].geometry.copy(newHandleDivGeometry);
      knifeblockBladeGroup[i].material.map = textureInUse;
      knifeblockHandleGroup[i].material.map = textureInUse;
      knifeblockBladeGroup[i].position.x = newKnifeblockLocateX;
      knifeblockHandleGroup[i].position.x = newKnifeblockLocateX;
      knifeblockBladeGroup[i].position.z =
        closestFrontHDiv.position.z - (boardThickness / 2) - knifeblockSmallBladeDistFromBottom;
      knifeblockHandleGroup[i].position.z =
        closestFrontHDiv.position.z - (boardThickness / 2) - knifeblockHandleDistFromBottom;
      knifeblockBladeGroup[i].visible = true;
      knifeblockHandleGroup[i].visible = true;
      knifeblockBladeGroup[i].geometry.computeBoundingBox();
      knifeblockHandleGroup[i].geometry.computeBoundingBox();

      // add notches to the full vertical boards for each of the two knifeblock boards
      addNotchVert(knifeblockBladeGroup[i]);
      addNotchVert(knifeblockHandleGroup[i]);
    } // end redo small knifeblocks

    // do any large Knifeblocks
    i = 0;
    for (i = 0; i < knifeblockLargeBladeGroup.length; i++) {
      // figure out the length and location then replace the knifeblock geometries
      let closestPosVDiv = drawer_insert.children[2].position.x;
      let closestNegVDiv = drawer_insert.children[1].position.x;

      fullVertDivGroup.forEach((j) => {
        if (knifeblockLargeBladeGroup[i].position.x >= closestPosVDiv) {
          console.log(
            "Error: click location greater than left side location @ x = " +
              closestPosVDiv,
          );
        }
        if (
          j.position.x > knifeblockLargeBladeGroup[i].position.x &&
          j.position.x < closestPosVDiv
        ) {
          closestPosVDiv = j.position.x;
        }
        if (knifeblockLargeBladeGroup[i].position.x <= closestNegVDiv) {
          console.log("Error: click location less than right side location");
        }
        if (
          j.position.x < knifeblockLargeBladeGroup[i].position.x &&
          j.position.x > closestNegVDiv
        ) {
          closestNegVDiv = j.position.x;
        }
      });

      let j = 0;
      for (j = 0; j < spanVertDivGroup.length; j++) {
        var bBox = new THREE.Box3().setFromObject(spanVertDivGroup[j]);

        // if this spanning vertical divider hits this spanning horizintal divider at the end then ignore it
        let endZofHorizDivBack = +(
          knifeblockLargeBladeGroup[i].position.z -
          boardThickness / 2
        ).toFixed(6);
        let endZofHorizDivFront = +(
          knifeblockLargeBladeGroup[i].position.z +
          boardThickness / 2
        ).toFixed(6);
        let endZofHorizDivMid =
          +knifeblockLargeBladeGroup[i].position.z.toFixed(6);
        let endZofVertDivBack = +bBox.min.z.toFixed(6);
        let endZofVertDivFront = +bBox.max.z.toFixed(6);

        if (
          endZofHorizDivBack <= endZofVertDivBack ||
          endZofHorizDivFront >= endZofVertDivFront
        ) {
          continue;
        }

        if (knifeblockLargeBladeGroup[i].position.x >= closestPosVDiv) {
          console.log(
            "Error: click location greater than left side location @ x = " +
              closestPosVDiv,
          );
        }
        if (
          spanVertDivGroup[j].position.x >
            knifeblockLargeBladeGroup[i].position.x &&
          spanVertDivGroup[j].position.x < closestPosVDiv
        ) {
          closestPosVDiv = spanVertDivGroup[j].position.x;
        }
        if (knifeblockLargeBladeGroup[i].position.x <= closestNegVDiv) {
          console.log("Error: click location less than right side location");
        }
        if (
          spanVertDivGroup[j].position.x <
            knifeblockLargeBladeGroup[i].position.x &&
          spanVertDivGroup[j].position.x > closestNegVDiv
        ) {
          closestNegVDiv = spanVertDivGroup[j].position.x;
        }
      }

      const newKnifeblockWidth =
        closestPosVDiv - closestNegVDiv + boardThickness;
      const newKnifeblockLocateX =
        closestNegVDiv + (closestPosVDiv - closestNegVDiv) / 2;

      // find the next horizontal divider towards the front from the z location of
      // the handle div to set the z spacing of the two knifeblock divs
      let hDivsToCheck = [];
      hDivsToCheck.push(drawer_insert.children[3]);
      Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
      Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);

      hDivsToCheck.sort(function (a, b) {
        return b.position.z - a.position.z;
      });

      var closestFrontHDiv = drawer_insert.children[3];

      let k = 0;
      for (k = 0; k < hDivsToCheck.length; k++) {
        //check if this hDiv is closest to the handle div
        //lowest z where closestPosVDiv and closestNegVDiv are both within the max-min z bounds of the hDiv
        //console.log("checking hDiv " + hDivsToCheck[k].name);
        hDivsToCheck[i].geometry.computeBoundingBox();
        var bBox = new THREE.Box3().setFromObject(hDivsToCheck[k]);

        // end checking once the hdiv being checked is behind the handle div of the knifeblock
        if (
          hDivsToCheck[k].position.z < knifeblockLargeHandleGroup[i].position.z
        ) {
          //console.log(". ending checking hDiv " + hDivsToCheck[k].name);
          break;
        }
      
        if ((bBox.max.x - boardThickness).toFixed(6) == (closestPosVDiv - (boardThickness / 2)).toFixed(6) || 
          (bBox.min.x + boardThickness).toFixed(6) == (closestNegVDiv + (boardThickness / 2)).toFixed(6)) {
          //console.log("  closestHDiv so far div at z = " + hDivsToCheck[i].position.z);

          closestFrontHDiv = hDivsToCheck[k];
        }
      }

      const newBladeDivGeometry =
        makeKnifeblockBladeGeometry(newKnifeblockWidth);
      const newHandleDivGeometry = makeKnifeblockHandleGeometry(
        newKnifeblockWidth,
        knifeblockLargeHandleHeight,
      );
      const newHandle2DivGeometry = makeKnifeblockHandleGeometry(
        newKnifeblockWidth,
        knifeblockHandleHeight,
      );

      knifeblockLargeBladeGroup[i].geometry.dispose();
      knifeblockLargeHandleGroup[i].geometry.dispose();
      knifeblockLargeHandle2Group[i].geometry.dispose();

      knifeblockLargeBladeGroup[i].geometry.copy(newBladeDivGeometry);
      knifeblockLargeHandleGroup[i].geometry.copy(newHandleDivGeometry);
      knifeblockLargeHandle2Group[i].geometry.copy(newHandle2DivGeometry);

      knifeblockLargeBladeGroup[i].material.map = textureInUse;
      knifeblockLargeHandleGroup[i].material.map = textureInUse;
      knifeblockLargeHandle2Group[i].material.map = textureInUse;

      knifeblockLargeBladeGroup[i].position.x = newKnifeblockLocateX;
      knifeblockLargeHandleGroup[i].position.x = newKnifeblockLocateX;
      knifeblockLargeHandle2Group[i].position.x = newKnifeblockLocateX;

      knifeblockLargeBladeGroup[i].position.z =
        closestFrontHDiv.position.z - (boardThickness / 2) - knifeblockLargeBladeDistFromBottom;
      knifeblockLargeHandleGroup[i].position.z =
        closestFrontHDiv.position.z - (boardThickness / 2) - knifeblockHandleDistFromBottom;
      knifeblockLargeHandle2Group[i].position.z =
        closestFrontHDiv.position.z - (boardThickness / 2) - knifeblockHandle2DistFromBottom;

      knifeblockLargeBladeGroup[i].visible = true;
      knifeblockLargeHandleGroup[i].visible = true;
      knifeblockLargeHandle2Group[i].visible = true;

      knifeblockLargeBladeGroup[i].geometry.computeBoundingBox();
      knifeblockLargeHandleGroup[i].geometry.computeBoundingBox();
      knifeblockLargeHandle2Group[i].geometry.computeBoundingBox();

      // add notches to the full vertical boards for each of the two knifeblock boards
      addNotchVert(knifeblockLargeBladeGroup[i]);
      addNotchVert(knifeblockLargeHandleGroup[i]);
      addNotchVert(knifeblockLargeHandle2Group[i]);
    } // end redo Large knifeblock

    // do any spiceracks
    i = 0;
    for (i = 0; i < spicerackInsertGroup.length; i++) {
      // figure out the length and location then replace the spicerack geometry
      let closestPosVDiv = drawer_insert.children[2].position.x;
      let closestNegVDiv = drawer_insert.children[1].position.x;

      fullVertDivGroup.forEach((j) => {
        if (spicerackInsertGroup[i].position.x >= closestPosVDiv) {
          console.log(
            "Error: click location greater than left side location @ x = " +
              closestPosVDiv,
          );
        }
        if (
          j.position.x > spicerackInsertGroup[i].position.x &&
          j.position.x < closestPosVDiv
        ) {
          closestPosVDiv = j.position.x;
        }
        if (spicerackInsertGroup[i].position.x <= closestNegVDiv) {
          console.log("Error: click location less than right side location");
        }
        if (
          j.position.x < spicerackInsertGroup[i].position.x &&
          j.position.x > closestNegVDiv
        ) {
          closestNegVDiv = j.position.x;
        }
      });

      let j = 0;
      for (j = 0; j < spanVertDivGroup.length; j++) {
        var bBox = new THREE.Box3().setFromObject(spanVertDivGroup[j]);

        // if this spanning vertical divider hits this spanning horizintal divider at the end then ignore it
        let endZofHorizDivBack = +(
          spicerackInsertGroup[i].position.z -
          boardThickness / 2
        ).toFixed(6);
        let endZofHorizDivFront = +(
          spicerackInsertGroup[i].position.z +
          boardThickness / 2
        ).toFixed(6);
        let endZofHorizDivMid = +spicerackInsertGroup[i].position.z.toFixed(6);
        let endZofVertDivBack = +bBox.min.z.toFixed(6);
        let endZofVertDivFront = +bBox.max.z.toFixed(6);

        if (
          endZofHorizDivBack <= endZofVertDivBack ||
          endZofHorizDivFront >= endZofVertDivFront
        ) {
          continue;
        }

        if (spicerackInsertGroup[i].position.x >= closestPosVDiv) {
          console.log(
            "Error: click location greater than left side location @ x = " +
              closestPosVDiv,
          );
        }
        if (
          spanVertDivGroup[j].position.x > spicerackInsertGroup[i].position.x &&
          spanVertDivGroup[j].position.x < closestPosVDiv
        ) {
          closestPosVDiv = spanVertDivGroup[j].position.x;
        }
        if (spicerackInsertGroup[i].position.x <= closestNegVDiv) {
          console.log("Error: click location less than right side location");
        }
        if (
          spanVertDivGroup[j].position.x < spicerackInsertGroup[i].position.x &&
          spanVertDivGroup[j].position.x > closestNegVDiv
        ) {
          closestNegVDiv = spanVertDivGroup[j].position.x;
        }
      }

      const newSpicerackWidth =
        closestPosVDiv - closestNegVDiv - boardThickness;
      const newSpicerackLocateX =
        closestNegVDiv + (closestPosVDiv - closestNegVDiv) / 2;

      const newSpicerackInsertGeometry =
        makeSpicerackInsertGeometry(newSpicerackWidth);

      spicerackInsertGroup[i].geometry.dispose();
      spicerackInsertGroup[i].geometry.copy(newSpicerackInsertGeometry);
      spicerackInsertGroup[i].material.map = textureInUse;
      spicerackInsertGroup[i].position.x = newSpicerackLocateX;
      spicerackInsertGroup[i].visible = true;
      spicerackInsertGroup[i].geometry.computeBoundingBox();
    } // end redo spiceracks

    // replace the BufferGeometries in the spanning vertical dividers
    spanVertDivGroup.forEach((i) => {
      // console.log("Calculating geometry for spanning vertical div = " + i.id + " " + i.name);
      // console.log("  lastDivDragged Vert = " + lastDivDragged);
      // console.log("  checkValidMove = " + checkValidMove);

      if (lastDivDragged != i.id) {
        //console.log("  Calculating geometry for spanning vertical div = " + i.id + " " + i.name);
        // figure out the length of the new divider
        // determine which horizontal dividers, front or back board are closest
        // chech in the positive and then the negative direction.
        // the back is the default closest negative divider and the front is the closest positive divider
        let closestPosDiv = drawer_insert.children[3].position.z;
        let closestNegDiv = drawer_insert.children[4].position.z;

        fullHorizDivGroup.forEach((j) => {
          
          
          if (j.position.z > i.position.z && j.position.z < closestPosDiv) {
            closestPosDiv = j.position.z;
            //console.log("setting closestPosDiv = " + closestPosDiv);
          }
          
          if (j.position.z < i.position.z && j.position.z > closestNegDiv) {
            closestNegDiv = j.position.z;
            //console.log("setting closestNegDiv = " + closestNegDiv);
          }
         
        });

        let j = 0;
        for (j = 0; j < spanHorizDivGroup.length; j++) {
          // if this spanning horizontal divider hits this spanning vertical divider at the end then ignore it
          var bBox = new THREE.Box3().setFromObject(spanHorizDivGroup[j]);

          // if this spanning vertical divider hits this spanning horizintal divider at the end then ignore it
          let endXofVertDivLeft = +(i.position.x - boardThickness / 2).toFixed(
            6,
          );
          let endXofVertDivRight = +(i.position.x + boardThickness / 2).toFixed(
            6,
          );
          let endXofHorizDivLeft = +bBox.min.x.toFixed(6);
          let endXofHorizDivRight = +bBox.max.x.toFixed(6);

          if (
            endXofVertDivLeft <= endXofHorizDivLeft ||
            endXofVertDivRight >= endXofHorizDivRight ||
            endXofVertDivLeft >= endXofHorizDivRight
          ) {
            continue;
          }
          if (i.position.z >= closestPosDiv) {
            console.log(
              "Error: click location greater than front location @ z = " +
                closestPosDiv,
            );
          }
          if (
            spanHorizDivGroup[j].position.z > i.position.z &&
            spanHorizDivGroup[j].position.z < closestPosDiv
          ) {
            closestPosDiv = spanHorizDivGroup[j].position.z;
          }
          if (i.position.z <= closestNegDiv) {
            console.log("Error: click location less than back location");
          }
          if (
            spanHorizDivGroup[j].position.z < i.position.z &&
            spanHorizDivGroup[j].position.z > closestNegDiv
          ) {
            closestNegDiv = spanHorizDivGroup[j].position.z;
          }
        }

        const newSpanVertDivLength =
          closestPosDiv - closestNegDiv + boardThickness;
        const newSpanVertDivLocateZ =
          closestNegDiv + (closestPosDiv - closestNegDiv) / 2;

        const newSvdGeometry = makeSpanDivGeometry(newSpanVertDivLength);
        i.geometry.dispose();
        i.geometry.copy(newSvdGeometry);
        i.geometry.computeBoundingBox();

        //turn off y axis clamping
        i.userData.limit = {
          min: new THREE.Vector3(
            0 - (insertWidth / 2 - minDivWidth),
            1,
            i.position.z,
          ),
          max: new THREE.Vector3(
            insertWidth / 2 - minDivWidth,
            1,
            i.position.z,
          ),
        };

        // move the divider up into position
        i.position.y = divHeight / 2 + baseThickness / 2;

        // move the divider along the z axis after a resize in that direction
        i.position.z = newSpanVertDivLocateZ;

        // turn clamping back on
        i.userData.limit = {
          min: new THREE.Vector3(
            0 - (insertWidth / 2 - minDivWidth),
            i.position.y,
            i.position.z,
          ),
          max: new THREE.Vector3(
            insertWidth / 2 - minDivWidth,
            i.position.y,
            i.position.z,
          ),
        };
      }

      if (lastDivDragged == i.id || checkValidMove.includes(i.id)) {
        // make sure this location doesn't interefere with another span vert

        // console.log("  checking valid move = " + i.id + " " + i.name);
        // console.log(spanVertDivGroup);
        // console.log("  x = " + i.position.x + " z = " + i.position.z);

        const index = checkValidMove.indexOf(i.id);

        if (index > -1 && lastDivDragged != i.id) {
          checkValidMove.splice(index, 1);
        }

        lastDivDragged = "";

        let j = 0;
        for (j = 0; j < spanVertDivGroup.length; j++) {
          if (i.id == spanVertDivGroup[j].id) {
            //console.log("  can't collide with itself, skipping id = " + i.id);
            continue;
          }

          const iLength =
            i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
          const jLength =
            spanVertDivGroup[j].geometry.boundingBox.max.x -
            spanVertDivGroup[j].geometry.boundingBox.min.x;

          const iBottomX =
            Math.round(
              (i.position.z + iLength / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const iTopX =
            Math.round(
              (i.position.z - iLength / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const jTopX =
            Math.round(
              (spanVertDivGroup[j].position.z - jLength / 2 + boardThickness) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;
          const jBottomX =
            Math.round(
              (spanVertDivGroup[j].position.z + jLength / 2 - boardThickness) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;

          if (iBottomX == jTopX || iTopX == jBottomX) {
            //console.log("  dividers could interfere...");
            if (
              i.position.x >=
                spanVertDivGroup[j].position.x - 0.01 - boardThickness / 2 &&
              i.position.x <=
                spanVertDivGroup[j].position.x + 0.01 + boardThickness / 2
            ) {
              //console.log("    dividers interfere, resetting X...");

              if (i.position.x >= spanVertDivGroup[j].position.x) {
                i.position.x =
                  spanVertDivGroup[j].position.x - 0.01 - boardThickness / 2;
              } else if (i.position.x <= spanVertDivGroup[j].position.x) {
                i.position.x =
                  spanVertDivGroup[j].position.x + 0.01 + boardThickness / 2;
              }

              spanVertDivGroup[j].material.dispose();
              spanVertDivGroup[j].material = new THREE.MeshPhongMaterial({
                color: 0xff3333,
                emissive: 0x000000,
              });
            }
          }
        }
      }

      
      // add notches to the horizontal divs that meet this spanning veritcal div
      addNotchHoriz(i);
      i.geometry.computeBoundingBox();
      // add notches to this vertical div's geometry for spanning horizontal divs that meet it.
      makeVertSpanDivGeoNotch(i);
      i.geometry.computeBoundingBox();
    });

    // replace the BufferGeometries in the spanning horizontal dividers
    spanHorizDivGroup.forEach((i) => {
      //console.log("Calculating geometry for spanning Horiz div = " + i.id + " " + i.name);

      //console.log("  lastDivDragged Horiz = " + lastDivDragged);

      if (lastDivDragged != i.id) {
        // figure out the length of the new divider
        // determine which vertical dividers, front or back board are closest
        // chech in the positive and then the negative direction.
        // the back is the default closest negative divider and the front is the closest positive divider
        let closestPosDiv = drawer_insert.children[2].position.x;
        let closestNegDiv = drawer_insert.children[1].position.x;

        // set this so interference with other spanning divs will be checked
        //lastDivDragged = i.id;

        fullVertDivGroup.forEach((j) => {
          if (i.position.x >= closestPosDiv) {
            console.log(
              "Error: click location greater than left side location @ x = " +
                closestPosDiv,
            );
          }
          if (j.position.x > i.position.x && j.position.x < closestPosDiv) {
            closestPosDiv = j.position.x;
          }
          if (i.position.x <= closestNegDiv) {
            console.log("Error: click location less than right side location");
          }
          if (j.position.x < i.position.x && j.position.x > closestNegDiv) {
            closestNegDiv = j.position.x;
          }
        });

        let j = 0;
        for (j = 0; j < spanVertDivGroup.length; j++) {
          var bBox = new THREE.Box3().setFromObject(spanVertDivGroup[j]);

          // if this spanning vertical divider hits this spanning horizintal divider at the end then ignore it
          let endZofHorizDivBack = +(i.position.z - boardThickness / 2).toFixed(
            6,
          );
          let endZofHorizDivFront = +(
            i.position.z +
            boardThickness / 2
          ).toFixed(6);
          let endZofHorizDivMid = +i.position.z.toFixed(6);
          let endZofVertDivBack = +bBox.min.z.toFixed(6);
          let endZofVertDivFront = +bBox.max.z.toFixed(6);

          if (
            endZofHorizDivBack <= endZofVertDivBack ||
            endZofHorizDivFront >= endZofVertDivFront
          ) {
            continue;
          }
          if (i.position.x >= closestPosDiv) {
            console.log(
              "Error: click location greater than left side location @ x = " +
                closestPosDiv,
            );
          }
          if (
            spanVertDivGroup[j].position.x > i.position.x &&
            spanVertDivGroup[j].position.x < closestPosDiv
          ) {
            closestPosDiv = spanVertDivGroup[j].position.x;
          }
          if (i.position.x <= closestNegDiv) {
            console.log("Error: click location less than right side location");
          }
          if (
            spanVertDivGroup[j].position.x < i.position.x &&
            spanVertDivGroup[j].position.x > closestNegDiv
          ) {
            closestNegDiv = spanVertDivGroup[j].position.x;
          }
        }

        const newSpanHorizDivLength =
          closestPosDiv - closestNegDiv + boardThickness;
        const newSpanHorizDivLocateX =
          closestNegDiv + (closestPosDiv - closestNegDiv) / 2;

        const newShdGeometry = makeSpanDivGeometry(newSpanHorizDivLength);
        i.geometry.dispose();
        i.geometry.copy(newShdGeometry);
        i.geometry.computeBoundingBox();

        //turn off clamping
        i.userData.limit = {
          min: new THREE.Vector3(
            i.position.x,
            1,
            0 - (insertDepth / 2 - minDivWidth),
          ),
          max: new THREE.Vector3(
            i.position.x,
            1,
            insertDepth / 2 - minDivWidth,
          ),
        };

        // move the divider up into position
        i.position.y = divHeight / 2 + baseThickness / 2;
        // move the divider along the x axis after a resize in that direction
        i.position.x = newSpanHorizDivLocateX;

        // turn clamping back on
        i.userData.limit = {
          min: new THREE.Vector3(
            i.position.x,
            i.position.y,
            0 - (insertDepth / 2 - minDivWidth),
          ),
          max: new THREE.Vector3(
            i.position.x,
            i.position.y,
            insertDepth / 2 - minDivWidth,
          ),
        };
      }

      if (lastDivDragged == i.id || checkValidMove.includes(i.id)) {
        // make sure this location doesn't interefere with another span horiz or knifeblock piece

        // console.log("  checking valid Horizontal move = " + i.id + " " + i.name);
        // console.log(spanHorizDivGroup);
        // console.log("  x = " + i.position.x + " z = " + i.position.z);

        const index = checkValidMove.indexOf(i.id);

        if (index > -1 && lastDivDragged != i.id) {
          checkValidMove.splice(index, 1);
        }

        lastDivDragged = "";

        const allHorizSpan = spanHorizDivGroup.concat(knifeblockBladeGroup,knifeblockHandleGroup,
          knifeblockLargeBladeGroup,knifeblockLargeHandleGroup, knifeblockLargeHandle2Group);

        let j = 0;
        for (j = 0; j < allHorizSpan.length; j++) {
          if (i.id == allHorizSpan[j].id) {
            //console.log("  can't collide with itself, skipping id = " + i.id);
            continue;
          }

          const iLength =
            i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
          const jLength =
            allHorizSpan[j].geometry.boundingBox.max.x -
            allHorizSpan[j].geometry.boundingBox.min.x;

          const iRightX =
            Math.round(
              (i.position.x + iLength / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const iLeftX =
            Math.round(
              (i.position.x - iLength / 2) * 1000000 + Number.EPSILON,
            ) / 1000000;
          const jLeftX =
            Math.round(
              (allHorizSpan[j].position.x - jLength / 2 + boardThickness) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;
          const jRightX =
            Math.round(
              (allHorizSpan[j].position.x + jLength / 2 - boardThickness) *
                1000000 +
                Number.EPSILON,
            ) / 1000000;

          if (iRightX == jLeftX || iLeftX == jRightX) {
            //console.log("  dividers could interfere...");
            if (
              i.position.z >=
                allHorizSpan[j].position.z - 0.01 - boardThickness / 2 &&
              i.position.z <=
                allHorizSpan[j].position.z + 0.01 + boardThickness / 2
            ) {
              //console.log("    dividers interfere, resetting Z...");

              if (i.position.z >= allHorizSpan[j].position.z) {
                i.position.z =
                  allHorizSpan[j].position.z - 0.01 - boardThickness / 2;
              } else if (i.position.z <= allHorizSpan[j].position.z) {
                i.position.z =
                  allHorizSpan[j].position.z + 0.01 + boardThickness / 2;
              }

              allHorizSpan[j].material.dispose();
              allHorizSpan[j].material = new THREE.MeshPhongMaterial({
                color: 0xff3333,
                emissive: 0x000000,
              });
            }
          }
        }
      }

      // add notches to the sides and full vertical divs that meet this spanning horzontal div
      //i.geometry.computeBoundingBox();
      addNotchVert(i);
      // add notches to this horizontal div's geometry for spanning vertical divs that meet it.
      makeHorizSpanDivGeoNotch(i);
      i.geometry.computeBoundingBox();
    });

 

    // replace the vertical measurement lines, start at the left side and move right
    if (vDimOn == true) {
      addVertMeasurementLines();
      addVertOutsideMeasurementLine();
      addHeightOutsideMeasurementLine();
    }

    // replace the horizontal measurement lines if the switch is on, start at the back and move forward
    if (hDimOn == true) {
      addHorizMeasurementLines();
      addHorizOutsideMeasurementLine();
    }

    //loop through the array of dividers that have been previously selected to have a
    // cuttaway added.
    divsWithCutaway.forEach((i) => {
      addCutawayToMesh(i);
    });

    //console.log("redo the base geometry as the last step");
    if (bottomReqSwitchOn == true) {
      // redo the base geometry to include overall size change
      const newBaseGeometry = makeBaseGeometry();
      drawer_insert.children[0].geometry.dispose();
      drawer_insert.children[0].geometry.copy(newBaseGeometry);
      drawer_insert.children[0].material.map = textureInUse;
      drawer_insert.children[0].visible = true;
      //drawer_insert.children[0].material.wireframe = true;
    } else {
      drawer_insert.children[0].visible = false;
    }

    //resize the translucent drawer box


    //resize the felt or antislip bottom
    if ( feltBottomMesh != false) {
      const newFeltGeometry = new THREE.BoxGeometry(insertWidth, 0.00001, insertDepth);
      feltBottomMesh.geometry.dispose();
      feltBottomMesh.geometry.copy(newFeltGeometry);
    }

    //resize the felt or antislip bottom
    if ( antislipBottomMesh != false) {
      const newAntislipGeometry = new THREE.BoxGeometry(insertWidth, 0.00001, insertDepth);
      antislipBottomMesh.geometry.dispose();
      antislipBottomMesh.geometry.copy(newAntislipGeometry);
    }

    //assign the UV's to the geometry of each mesh
    //console.log("drawer_insert before assigning UVs");
    //console.log(drawer_insert);
    let k = 0;
    for (k = 0; k < 5; k++) {
      assignUVs(drawer_insert.children[k]);
    }
    fullVertDivGroup.forEach((i) => {
      assignUVs(i);
    });
    fullHorizDivGroup.forEach((i) => {
      assignUVs(i);
    });
    spanVertDivGroup.forEach((i) => {
      assignUVs(i);
    });
    spanHorizDivGroup.forEach((i) => {
      assignUVs(i);
    });
    knifeblockBladeGroup.forEach((i) => {
      assignUVs(i);
    });
    knifeblockHandleGroup.forEach((i) => {
      assignUVs(i);
    });
    knifeblockLargeBladeGroup.forEach((i) => {
      assignUVs(i);
    });
    knifeblockLargeHandleGroup.forEach((i) => {
      assignUVs(i);
    });
    knifeblockLargeHandle2Group.forEach((i) => {
      assignUVs(i);
    });
    spicerackInsertGroup.forEach((i) => {
      assignUVs(i);
    });

    renderer.render(scene, camera);

    // undo/redo
    if (justLoaded == false) {
      histPosition++;
      history.push(saveInsert(true));
      //console.log("adding record to history array, pos = " + histPosition + " len = " + history.length);
      if (history.length > 100) {
        history.shift();
        histPosition--;
      }
    } else if (history.length == 1) {
      //console.log("just loaded, history array, pos = " + histPosition + " len = " + history.length);
      history[0] = saveInsert(true);
      justLoaded = false;
    } else {
      justLoaded = false;
    }
  } // End of redoInsert

  function addCutawayToMesh(divMesh) {
    divMesh.geometry.computeBoundingBox();
    const cutAwayDiameter =
      (divMesh.geometry.boundingBox.max.x -
        divMesh.geometry.boundingBox.min.x) /
      2;
    const cutAwayXStart =
      divMesh.geometry.boundingBox.max.x -
      (divMesh.geometry.boundingBox.max.x -
        divMesh.geometry.boundingBox.min.x) /
        4;

    const curve = new THREE.Shape();

    curve.moveTo(cutAwayXStart, divHeight / 2);
    curve.bezierCurveTo(
      cutAwayXStart - cutAwayDiameter / 4,
      0,
      (cutAwayXStart - cutAwayDiameter / 4) * -1,
      0,
      cutAwayXStart * -1,
      divHeight / 2,
    );

    const extrudeSettings = {
      curveSegments: 32,
      steps: 1,
      depth: 0.02,
      bevelEnabled: false,
    };

    const cutawayGeometry = new THREE.ExtrudeGeometry(curve, extrudeSettings);
    cutawayGeometry.translate(0, 0, -0.01);

    const newCutawayDivCSG = CSG.subtract([divMesh.geometry, cutawayGeometry]);
    cutawayGeometry.dispose();
    let saveName = divMesh.geometry.name;
    divMesh.geometry.dispose();
    divMesh.geometry.copy(CSG.BufferGeometry(newCutawayDivCSG));
    divMesh.geometry.name = saveName;
    divMesh.geometry.computeBoundingBox();
  }

  function addNotchHoriz(vDivMesh) {
    // replace the BufferGeometries where this vertical spanning divider intersects with
    // front, back and full dividers

    var thisSpanVertbBox = new THREE.Box3().setFromObject(vDivMesh);

    // replace the BufferGeometries where this vertical spanning divider intersects with
    // front, back and full dividers
    let hDivsToCheck = [];
    hDivsToCheck.push(drawer_insert.children[3]);
    hDivsToCheck.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);

    hDivsToCheck.forEach((j) => {
      var thisDivbBox = new THREE.Box3().setFromObject(j);

      if (thisSpanVertbBox.intersectsBox(thisDivbBox)) {
        let bigNotchGeometry = new THREE.BoxBufferGeometry(
          boardThickness,
          divHeight - 2 * boardThickness,
          boardThickness,
        );
        bigNotchGeometry.translate(
          0 - j.position.x + vDivMesh.position.x,
          0,
          0,
        );
        const newNotchedBoardCSG = CSG.subtract([j.geometry, bigNotchGeometry]);
        bigNotchGeometry.dispose();
        let saveName = j.geometry.name;
        j.geometry.dispose();
        j.geometry.copy(CSG.BufferGeometry(newNotchedBoardCSG));
        j.geometry.name = saveName;
        j.geometry.computeBoundingBox();
      }
    });
  }

  function addNotchVert(hDivMesh) {
    // replace the BufferGeometries where this horizontal spanning divider intersects with
    // front, back and full dividers

    var thisSpanHorizbBox = new THREE.Box3().setFromObject(hDivMesh);

    let thisSpanHorizHeight =
      hDivMesh.geometry.boundingBox.max.y - hDivMesh.geometry.boundingBox.min.y;

    let vDivsToCheck = [];
    vDivsToCheck.push(drawer_insert.children[1]);
    vDivsToCheck.push(drawer_insert.children[2]);
    Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);

    //console.log("Adding vert notches for " + hDivMesh.name);


    vDivsToCheck.forEach((j) => {
      var thisDivbBox = new THREE.Box3().setFromObject(j);
      //console.log("  checking j.name " + j.name);

      if (thisSpanHorizbBox.intersectsBox(thisDivbBox)) {
        //console.log("    adding notch for height = " + thisSpanHorizHeight);
        let bigNotchGeometry = new THREE.BoxBufferGeometry(
          boardThickness,
          thisSpanHorizHeight - 2 * boardThickness,
          boardThickness,
        );
        if (hDivMesh.name == "spanVertBoardMesh") {
          //console.log("    spanvert notch at y = 0");
          bigNotchGeometry.translate(
            0 - hDivMesh.position.z + j.position.z,
            0,
            0,
          );
        } else if (hDivMesh.name == "knifeblockBladeBoardMesh" ||
            hDivMesh.name == "knifeblockLargeBladeBoardMesh" ||
            hDivMesh.name == "knifeblockHandleBoardMesh" ||
            hDivMesh.name == "knifeblockLargeHandleBoardMesh" ||
            hDivMesh.name == "knifeblockLargeHandle2BoardMesh"
            ) {
          //console.log("    kb notch at y = " + (0 - divHeight / 2 + thisSpanHorizHeight / 2));
          bigNotchGeometry.translate(
            0 - hDivMesh.position.z,
            0 - divHeight / 2 + thisSpanHorizHeight / 2,
            0,
          );
        } else {
          //console.log("    default notch at y = 0");
          bigNotchGeometry.translate(0 - hDivMesh.position.z, 0, 0);
        }
        const newNotchedBoardCSG = CSG.subtract([j.geometry, bigNotchGeometry]);
        bigNotchGeometry.dispose();
        let saveName = j.geometry.name;
        j.geometry.dispose();
        j.geometry.copy(CSG.BufferGeometry(newNotchedBoardCSG));
        j.geometry.name = saveName;
        j.geometry.computeBoundingBox();
      }
    });
  }

  function makeSpanDivGeometry(insertLength) {
    const svGeometry = new THREE.BoxBufferGeometry(
      insertLength,
      divHeight,
      boardThickness,
    );
    let notch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch3Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch4Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );

    notch1Geometry.translate(
      insertLength / 2 - boardThickness / 2,
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch2Geometry.translate(
      0 - (insertLength / 2 - boardThickness / 2),
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch3Geometry.translate(
      insertLength / 2 - boardThickness / 2,
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );
    notch4Geometry.translate(
      0 - (insertLength / 2 - boardThickness / 2),
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );

    const newSvDivCSG = CSG.subtract([
      svGeometry,
      notch1Geometry,
      notch2Geometry,
      notch3Geometry,
      notch4Geometry,
    ]);

    notch1Geometry.dispose();
    notch2Geometry.dispose();
    notch3Geometry.dispose();
    notch4Geometry.dispose();

    let newSpanDivGeometry = CSG.BufferGeometry(newSvDivCSG);

    newSpanDivGeometry.name = "spanDivGeometry";

    return newSpanDivGeometry;
  }

  function makeKnifeblockBladeGeometry(knifeblockWidth) {
    //console.log("running makeKnifeblockBladeGeometry with knifeblockWidth = " + knifeblockWidth);

    const svGeometry = new THREE.BoxBufferGeometry(
      knifeblockWidth,
      knifeblockBladeHeight,
      boardThickness,
    );

    let notch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch3Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch4Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );

    notch1Geometry.translate(
      knifeblockWidth / 2 - boardThickness / 2,
      knifeblockBladeHeight / 2 - boardThickness / 2,
      0,
    );
    notch2Geometry.translate(
      0 - (knifeblockWidth / 2 - boardThickness / 2),
      knifeblockBladeHeight / 2 - boardThickness / 2,
      0,
    );
    notch3Geometry.translate(
      knifeblockWidth / 2 - boardThickness / 2,
      0 - (knifeblockBladeHeight / 2 - boardThickness / 2),
      0,
    );
    notch4Geometry.translate(
      0 - (knifeblockWidth / 2 - boardThickness / 2),
      0 - (knifeblockBladeHeight / 2 - boardThickness / 2),
      0,
    );

    const newSvDivCSG = CSG.subtract([
      svGeometry,
      notch1Geometry,
      notch2Geometry,
      notch3Geometry,
      notch4Geometry,
    ]);

    svGeometry.dispose();
    notch1Geometry.dispose();
    notch2Geometry.dispose();
    notch3Geometry.dispose();
    notch4Geometry.dispose();

    var newKnifeblockBladeDivGeometry = CSG.BufferGeometry(newSvDivCSG);

    // subtract blade slots
    let numBladeSlots =
      Math.round((knifeblockWidth - boardThickness * 2) / knifeblockSlotSpacing) - 1;
    let outsideOffset =
      (knifeblockWidth -
        boardThickness * 2 -
        knifeblockSlotSpacing * numBladeSlots) /
      2;

    let handleBladeXStart =
      0 - (knifeblockWidth - boardThickness * 2) / 2 + outsideOffset;


    const slot = new THREE.Shape();
    
    slot.moveTo(0, 0);
    slot.lineTo(0, bladeSlotCurveSize);
    slot.lineTo(bladeSlotCurveSize, bladeSlotCurveSize);
    slot.quadraticCurveTo(bladeSlotCurveSize * 2, bladeSlotCurveSize, bladeSlotCurveSize * 2, bladeSlotCurveSize * 2);
    slot.lineTo(bladeSlotCurveSize * 2, bladeSlotHeight);
    slot.bezierCurveTo(bladeSlotCurveSize * 2, bladeSlotHeight + bladeSlotWidth, 
      (bladeSlotCurveSize * 2) + bladeSlotWidth, bladeSlotHeight + bladeSlotWidth,
      (bladeSlotCurveSize * 2) + bladeSlotWidth, bladeSlotHeight);
    slot.lineTo((bladeSlotCurveSize * 2) + bladeSlotWidth, bladeSlotCurveSize * 2);
    slot.quadraticCurveTo((bladeSlotCurveSize * 2) + bladeSlotWidth, bladeSlotCurveSize, 
      (bladeSlotCurveSize * 2) + bladeSlotWidth + bladeSlotCurveSize, bladeSlotCurveSize);
    slot.lineTo((bladeSlotCurveSize * 2) + bladeSlotWidth + (bladeSlotCurveSize * 2), bladeSlotCurveSize);
    slot.lineTo((bladeSlotCurveSize * 2) + bladeSlotWidth + (bladeSlotCurveSize * 2), 0);
    slot.lineTo(0, 0);

    const extrudeSettings = {
        curveSegments: 8,
        steps: 1,
        depth: 0.02,
        bevelEnabled: false,
      };
    
    const slotGeometry = new THREE.ExtrudeGeometry(
        slot,
        extrudeSettings,
      );

    slotGeometry.rotateZ(radNinety * 2);
    slotGeometry.translate(handleBladeXStart - (knifeblockSlotSpacing / 2) + bladeSlotWidth,
          0 + knifeblockBladeHeight / 2 + 0.0021,  
          0 - .01 );

    let k = 0;
    for (k = 0; k < numBladeSlots; k++) {
      
      slotGeometry.translate(knifeblockSlotSpacing + (bladeSlotWidth / 2), 0, 0);
      
      const newKbBDivCSG = CSG.subtract([newKnifeblockBladeDivGeometry, slotGeometry]);

      slotGeometry.dispose();

      newKnifeblockBladeDivGeometry.dispose();
      newKnifeblockBladeDivGeometry = CSG.BufferGeometry(newKbBDivCSG);
    }

    newKnifeblockBladeDivGeometry.name = "knifeblockBladeDivGeometry";

    return newKnifeblockBladeDivGeometry;
  }

  function makeKnifeblockHandleGeometry(knifeblockWidth, handleHeight) {
    const svGeometry = new THREE.BoxBufferGeometry(
      knifeblockWidth,
      handleHeight,
      boardThickness,
    );
    let notch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch3Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch4Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );

    notch1Geometry.translate(
      knifeblockWidth / 2 - boardThickness / 2,
      handleHeight / 2 - boardThickness / 2,
      0,
    );
    notch2Geometry.translate(
      0 - (knifeblockWidth / 2 - boardThickness / 2),
      handleHeight / 2 - boardThickness / 2,
      0,
    );
    notch3Geometry.translate(
      knifeblockWidth / 2 - boardThickness / 2,
      0 - (handleHeight / 2 - boardThickness / 2),
      0,
    );
    notch4Geometry.translate(
      0 - (knifeblockWidth / 2 - boardThickness / 2),
      0 - (handleHeight / 2 - boardThickness / 2),
      0,
    );

    const newSvDivCSG = CSG.subtract([
      svGeometry,
      notch1Geometry,
      notch2Geometry,
      notch3Geometry,
      notch4Geometry,
    ]);

    notch1Geometry.dispose();
    notch2Geometry.dispose();
    notch3Geometry.dispose();
    notch4Geometry.dispose();


    let newKnifeblockHandleDivGeometry = CSG.BufferGeometry(newSvDivCSG);

    // subtract Handle slots
    let numHandleSlots =
      Math.round(
        (knifeblockWidth - boardThickness * 2) / knifeblockSlotSpacing,
      ) - 1;
    let outsideOffset =
      (knifeblockWidth -
        boardThickness * 2 -
        knifeblockSlotSpacing * numHandleSlots) /
      2;
    let handleCurveXStart =
      0 - (knifeblockWidth - boardThickness * 2) / 2 + outsideOffset;

    let k = 0;
    for (k = 0; k < numHandleSlots; k++) {
      //console.log(" adding Handle Slots # " + k + " @ offSet = " + outsideOffset);

      newKnifeblockHandleDivGeometry.computeBoundingBox();

      const curve = new THREE.Shape();

      curve.moveTo(
        handleCurveXStart +
          knifeblockSlotSpacing * k +
          knifeblockHandleSpaceBetweenCurves / 2,
        handleHeight / 2,
      );
      curve.bezierCurveTo(
        handleCurveXStart +
          knifeblockSlotSpacing * k +
          knifeblockHandleSpaceBetweenCurves / 2,
        handleHeight / 2 - knifeblockHandleCurveDepth,
        handleCurveXStart +
          knifeblockSlotSpacing * (k + 1) -
          knifeblockHandleSpaceBetweenCurves / 2,
        handleHeight / 2 - knifeblockHandleCurveDepth,
        handleCurveXStart +
          knifeblockSlotSpacing * (k + 1) -
          knifeblockHandleSpaceBetweenCurves / 2,
        handleHeight / 2,
      );

      const extrudeSettings = {
        curveSegments: 32,
        steps: 1,
        depth: 0.02,
        bevelEnabled: false,
      };

      const handleCurveGeometry = new THREE.ExtrudeGeometry(
        curve,
        extrudeSettings,
      );
      handleCurveGeometry.translate(0, 0, -0.01);

      const newHandleCurveDivCSG = CSG.subtract([
        newKnifeblockHandleDivGeometry,
        handleCurveGeometry,
      ]);

      handleCurveGeometry.dispose();

      newKnifeblockHandleDivGeometry = CSG.BufferGeometry(newHandleCurveDivCSG);
    }

    newKnifeblockHandleDivGeometry.name = "knifeblockHandleDivGeometry";

    return newKnifeblockHandleDivGeometry;
  }

  function makeSpicerackInsertGeometry(spicerackWidth) {
    const svGeometry = new THREE.BoxBufferGeometry(
      spicerackWidth,
      spicerackInsertDepth,
      boardThickness,
    );

    var newSpicerackInsertDivGeometry = svGeometry;

    const curve = new THREE.Shape();
    const curve2 = new THREE.Shape();

    curve.moveTo(spicerackWidth / 2, spicerackCurveDepth);
    curve2.moveTo(0 - spicerackWidth / 2, spicerackCurveDepth);

    curve.bezierCurveTo(
      spicerackWidth / 2 - spicerackCurveDepth,
      spicerackCurveDepth,
      spicerackWidth / 2 - spicerackCurveDepth,
      -spicerackCurveDepth,
      spicerackWidth / 2,
      -spicerackCurveDepth,
    );
    curve2.bezierCurveTo(
      0 - spicerackWidth / 2 + spicerackCurveDepth,
      spicerackCurveDepth,
      0 - spicerackWidth / 2 + spicerackCurveDepth,
      -spicerackCurveDepth,
      0 - spicerackWidth / 2,
      -spicerackCurveDepth,
    );

    const extrudeSettings = {
      curveSegments: 24,
      steps: 1,
      depth: 0.02,
      bevelEnabled: false,
    };

    const spicerackNotchGeometry = new THREE.ExtrudeGeometry(
      curve,
      extrudeSettings,
    );
    const spicerackNotch2Geometry = new THREE.ExtrudeGeometry(
      curve2,
      extrudeSettings,
    );
    spicerackNotchGeometry.translate(0, 0, -0.01);
    spicerackNotch2Geometry.translate(0, 0, -0.01);

    const newSpicerackInsertDivCSG = CSG.subtract([
      newSpicerackInsertDivGeometry,
      spicerackNotchGeometry,
      spicerackNotch2Geometry,
    ]);

    spicerackNotchGeometry.dispose();
    spicerackNotch2Geometry.dispose();

    newSpicerackInsertDivGeometry = CSG.BufferGeometry(
      newSpicerackInsertDivCSG,
    );

    newSpicerackInsertDivGeometry.name = "spicerackInsertDivGeometry";

    return newSpicerackInsertDivGeometry;
  }

  function makeVertSpanDivGeoNotch(vertSpanMesh) {
    // add notches where other horizontal spanning dividers meet this vertical spanning divider

    // check horizontal spanning divs and the two divs making up a knifeblock
    let hDivsToCheck = [];
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, knifeblockBladeGroup);
    Array.prototype.push.apply(hDivsToCheck, knifeblockHandleGroup);
    Array.prototype.push.apply(hDivsToCheck, knifeblockLargeBladeGroup);
    Array.prototype.push.apply(hDivsToCheck, knifeblockLargeHandleGroup);
    Array.prototype.push.apply(hDivsToCheck, knifeblockLargeHandle2Group);

    //console.log("adding notches to " + vertSpanMesh.name + " at z = " + vertSpanMesh.position.z.toFixed(4));

    hDivsToCheck.forEach((j) => {
      var thisDivbBox = new THREE.Box3().setFromObject(j);

      let vSpanX = +vertSpanMesh.position.x.toFixed(6);
      let hDivMinX = +thisDivbBox.min.x.toFixed(6);
      let hDivMaxX = +thisDivbBox.max.x.toFixed(6);

      if (
        +((vSpanX - boardThickness / 2).toFixed(6) == hDivMinX) ||
        +((vSpanX + boardThickness / 2).toFixed(6) == hDivMaxX)
      ) {
        //console.log("  adding notches for " + j.name + " at z = " + j.position.z.toFixed(4));
        var bigNotchGeometry;
        if (j.name == "knifeblockBladeBoardMesh" || j.name == "knifeblockLargeBladeBoardMesh") {
          bigNotchGeometry = new THREE.BoxBufferGeometry(
            boardThickness,
            knifeblockBladeHeight - 2 * boardThickness,
            boardThickness,
          );
          bigNotchGeometry.translate(
            vertSpanMesh.position.z - j.position.z,
            0 - divHeight / 2 + knifeblockBladeHeight / 2,
            0,
          );
        } else if (j.name == "knifeblockHandleBoardMesh" || j.name == "knifeblockLargeHandle2BoardMesh") {
          bigNotchGeometry = new THREE.BoxBufferGeometry(
            boardThickness,
            knifeblockHandleHeight - 2 * boardThickness,
            boardThickness,
          );
          bigNotchGeometry.translate(
            vertSpanMesh.position.z - j.position.z,
            0 - divHeight / 2 + knifeblockHandleHeight / 2,
            0,
          );
        } else if (j.name == "knifeblockLargeHandleBoardMesh") {
          bigNotchGeometry = new THREE.BoxBufferGeometry(
            boardThickness,
            knifeblockLargeHandleHeight - 2 * boardThickness,
            boardThickness,
          );
          bigNotchGeometry.translate(
            vertSpanMesh.position.z - j.position.z,
            0 - divHeight / 2 + knifeblockLargeHandleHeight / 2,
            0,
          );
        } else {
          bigNotchGeometry = new THREE.BoxBufferGeometry(
            boardThickness,
            divHeight - 2 * boardThickness,
            boardThickness,
          );
          bigNotchGeometry.translate(
            vertSpanMesh.position.z - j.position.z,
            0,
            0,
          );
        }

        bigNotchGeometry.computeBoundingBox();

        const newNotchedBoardCSG = CSG.subtract([
          vertSpanMesh.geometry,
          bigNotchGeometry,
        ]);

        bigNotchGeometry.dispose();

        let saveName = vertSpanMesh.geometry.name;
        vertSpanMesh.geometry.dispose();
        vertSpanMesh.geometry.copy(CSG.BufferGeometry(newNotchedBoardCSG));
        vertSpanMesh.geometry.name = saveName;
        vertSpanMesh.geometry.computeBoundingBox();
      }
    });
  }

  function makeHorizSpanDivGeoNotch(horizSpanMesh) {
    // add notches where other vertical spanning dividers meet this horizontal spanning divider

    spanVertDivGroup.forEach((j) => {
      var thisDivbBox = new THREE.Box3().setFromObject(j);

      //X is z because of position of the geometry vs. the position of the mesh.
      let hSpanX = +horizSpanMesh.position.z.toFixed(6);
      let vDivMinX = +thisDivbBox.min.z.toFixed(6);
      let vDivMaxX = +thisDivbBox.max.z.toFixed(6);

      if (
        +((hSpanX - boardThickness / 2).toFixed(6) == vDivMinX) ||
        +((hSpanX + boardThickness / 2).toFixed(6) == vDivMaxX)
      ) {
        let bigNotchGeometry = new THREE.BoxBufferGeometry(
          boardThickness,
          divHeight - 2 * boardThickness,
          boardThickness,
        );
        bigNotchGeometry.translate(
          0 - horizSpanMesh.position.x + j.position.x,
          0,
          0,
        );
        bigNotchGeometry.computeBoundingBox();

        const newNotchedBoardCSG = CSG.subtract([
          horizSpanMesh.geometry,
          bigNotchGeometry,
        ]);

        bigNotchGeometry.dispose();

        let saveName = horizSpanMesh.geometry.name;
        horizSpanMesh.geometry.dispose();
        horizSpanMesh.geometry.copy(CSG.BufferGeometry(newNotchedBoardCSG));
        horizSpanMesh.geometry.name = saveName;
        horizSpanMesh.geometry.computeBoundingBox();
      }
    });
  }

  function makeFullVertDivGeometry() {
    const fvGeometry = new THREE.BoxBufferGeometry(
      insertDepth,
      divHeight,
      boardThickness,
    );
    let notch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch3Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch4Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );

    notch1Geometry.translate(
      insertDepth / 2 - boardThickness / 2,
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch2Geometry.translate(
      0 - (insertDepth / 2 - boardThickness / 2),
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch3Geometry.translate(
      insertDepth / 2 - boardThickness / 2,
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );
    notch4Geometry.translate(
      0 - (insertDepth / 2 - boardThickness / 2),
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );

    const newFvDivCSG = CSG.subtract([
      fvGeometry,
      notch1Geometry,
      notch2Geometry,
      notch3Geometry,
      notch4Geometry,
    ]);

    notch1Geometry.dispose();
    notch2Geometry.dispose();
    notch3Geometry.dispose();
    notch4Geometry.dispose();

    let newFullVertDivGeometry = CSG.BufferGeometry(newFvDivCSG);

    // add notches for exisitng horizontal dividers
    fullHorizDivGroup.forEach((i) => {
      let bigNotchGeometry = new THREE.BoxBufferGeometry(
        boardThickness,
        divHeight / 2,
        boardThickness,
      );
      bigNotchGeometry.translate(0 - i.position.z, 0 - divHeight / 4, 0);
      const newNotchedFbBoardCSG = CSG.subtract([
        newFullVertDivGeometry,
        bigNotchGeometry,
      ]);

      bigNotchGeometry.dispose();

      newFullVertDivGeometry.dispose();
      newFullVertDivGeometry = CSG.BufferGeometry(newNotchedFbBoardCSG);
    });

    newFullVertDivGeometry.name = "fullVertDivGeometry";

    return newFullVertDivGeometry;
  }

  function makeFullHorizDivGeometry() {
    const fhGeometry = new THREE.BoxBufferGeometry(
      insertWidth,
      divHeight,
      boardThickness,
    );
    let notch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch3Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch4Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );

    notch1Geometry.translate(
      insertWidth / 2 - boardThickness / 2,
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch2Geometry.translate(
      0 - (insertWidth / 2 - boardThickness / 2),
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch3Geometry.translate(
      insertWidth / 2 - boardThickness / 2,
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );
    notch4Geometry.translate(
      0 - (insertWidth / 2 - boardThickness / 2),
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );

    const newFhDivCSG = CSG.subtract([
      fhGeometry,
      notch1Geometry,
      notch2Geometry,
      notch3Geometry,
      notch4Geometry,
    ]);

    notch1Geometry.dispose();
    notch2Geometry.dispose();
    notch3Geometry.dispose();
    notch4Geometry.dispose();

    let newFullHorizDivGeometry = CSG.BufferGeometry(newFhDivCSG);

    // add notches for exisitng vertical dividers
    fullVertDivGroup.forEach((i) => {
      let bigNotchGeometry = new THREE.BoxBufferGeometry(
        boardThickness,
        divHeight / 2,
        boardThickness,
      );
      bigNotchGeometry.translate(i.position.x, divHeight / 4, 0);
      const newNotchedFbBoardCSG = CSG.subtract([
        newFullHorizDivGeometry,
        bigNotchGeometry,
      ]);

      bigNotchGeometry.dispose();

      newFullHorizDivGeometry.dispose();
      newFullHorizDivGeometry = CSG.BufferGeometry(newNotchedFbBoardCSG);
    });

    newFullHorizDivGeometry.name = "fullHorizDivGeometry";

    return newFullHorizDivGeometry;
  }

  function makeFbGeometry() {
    const fbGeometry = new THREE.BoxBufferGeometry(
      insertWidth,
      divHeight,
      boardThickness,
    );

    let bigNotch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      divHeight - 2 * boardThickness,
      boardThickness,
    );
    let bigNotch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      divHeight - 2 * boardThickness,
      boardThickness,
    );
    //console.log(fbGeometry);
    bigNotch1Geometry.translate(insertWidth / 2 - boardThickness / 2, 0, 0);
    bigNotch2Geometry.translate(
      0 - (insertWidth / 2 - boardThickness / 2),
      0,
      0,
    );

    const newFbBoardCSG = CSG.subtract([
      fbGeometry,
      bigNotch1Geometry,
      bigNotch2Geometry,
    ]);

    bigNotch1Geometry.dispose();
    bigNotch2Geometry.dispose();

    let newFbBoardGeometry = new THREE.BoxBufferGeometry(
      insertWidth,
      divHeight,
      boardThickness,
    );
    newFbBoardGeometry.dispose();
    newFbBoardGeometry = CSG.BufferGeometry(newFbBoardCSG);

    // add notches for exisiting full vertical dividers
    fullVertDivGroup.forEach((i) => {
      let bigNotchGeometry = new THREE.BoxBufferGeometry(
        boardThickness,
        divHeight - 2 * boardThickness,
        boardThickness,
      );
      bigNotchGeometry.translate(i.position.x, 0, 0);
      const newNotchedFbBoardCSG = CSG.subtract([
        newFbBoardGeometry,
        bigNotchGeometry,
      ]);

      bigNotchGeometry.dispose();
      newFbBoardGeometry.dispose();
      newFbBoardGeometry = CSG.BufferGeometry(newNotchedFbBoardCSG);
    });

    newFbBoardGeometry.name = "fbGeometry";

    return newFbBoardGeometry;
  }

  function makeSideGeometry() {
    const sideGeometry = new THREE.BoxBufferGeometry(
      insertDepth,
      divHeight,
      boardThickness,
    );

    let notch1Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch2Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch3Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );
    let notch4Geometry = new THREE.BoxBufferGeometry(
      boardThickness,
      boardThickness,
      boardThickness,
    );

    notch1Geometry.translate(
      insertDepth / 2 - boardThickness / 2,
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch2Geometry.translate(
      0 - (insertDepth / 2 - boardThickness / 2),
      divHeight / 2 - boardThickness / 2,
      0,
    );
    notch3Geometry.translate(
      insertDepth / 2 - boardThickness / 2,
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );
    notch4Geometry.translate(
      0 - (insertDepth / 2 - boardThickness / 2),
      0 - (divHeight / 2 - boardThickness / 2),
      0,
    );

    const newBoardCSG = CSG.subtract([
      sideGeometry,
      notch1Geometry,
      notch2Geometry,
      notch3Geometry,
      notch4Geometry,
    ]);

    notch1Geometry.dispose();
    notch2Geometry.dispose();
    notch3Geometry.dispose();
    notch4Geometry.dispose();

    let newBoardGeometry = CSG.BufferGeometry(newBoardCSG);

    // add notches for exisitng horizontal dividers
    fullHorizDivGroup.forEach((i) => {
      let bigNotchGeometry = new THREE.BoxBufferGeometry(
        boardThickness,
        divHeight - 2 * boardThickness,
        boardThickness,
      );
      bigNotchGeometry.translate(0 - i.position.z, 0, 0);
      const newNotchedFbBoardCSG = CSG.subtract([
        newBoardGeometry,
        bigNotchGeometry,
      ]);

      bigNotchGeometry.dispose();
      newBoardGeometry.dispose();
      newBoardGeometry = CSG.BufferGeometry(newNotchedFbBoardCSG);
    });

    newBoardGeometry.name = "sideGeometry";

    return newBoardGeometry;
  }

  function makeBaseGeometry() {
    let baseGeometry = new THREE.BoxBufferGeometry(
      insertWidth,
      baseThickness,
      insertDepth,
    );

    baseGeometry.name = "baseGeometry";

    return baseGeometry;
  }

  function makeDbBackGeometry() {
    const dbBackGeometry = new THREE.BoxBufferGeometry(
      insertWidth + (drawerboxThickness * 2) + (drawerboxSpace * 2),
      drawerboxHeight,
      drawerboxThickness,
    );

    dbBackGeometry.name = "dbBackGeometry";

    return dbBackGeometry;
  }

  function makeDbSideGeometry() {
    const dbSideGeometry = new THREE.BoxBufferGeometry(
      insertDepth + (drawerboxSpace * 2),
      drawerboxHeight,
      drawerboxThickness,
    );

    dbSideGeometry.name = "dbSideGeometry";

    return dbSideGeometry;
  }

  function makeDbFrontGeometry() {
    const dbFrontGeometry = new THREE.BoxBufferGeometry(
      insertWidth + (drawerboxThickness * 2) + (drawerboxSpace * 2) + 0.05,
      drawerboxHeight + 0.05,
      drawerboxThickness,
    );

    dbFrontGeometry.name = "dbFrontGeometry";

    return dbFrontGeometry;
  }

  function makeDbBaseGeometry() {
    const dbBaseGeometry = new THREE.BoxBufferGeometry(
      insertWidth + (drawerboxThickness * 2) + (drawerboxSpace * 2),
      drawerboxThickness,
      insertDepth + drawerboxThickness + (drawerboxSpace * 2),
    );

    dbBaseGeometry.name = "dbBaseGeometry";

    return dbBaseGeometry;
  }

  function render() {
    renderer.render(scene, camera);
  }

  function changeWidth() {
    insertWidth =
      window.parent.document.getElementById("outside_width").value / 100;
    redoInsert();
  }

  function changeDepth() {

    const saveDepth = insertDepth;

    if ( spicerackInsertGroup.length == 0 ) {
    
      insertDepth = window.parent.document.getElementById("outside_depth").value / 100;

    } else {
      window.parent.document.getElementById("outside_depth").value = (saveDepth * 100);
    }

    redoInsert();
  }

  function changeHeight() {
 
    insertHeight =
      window.parent.document.getElementById("outside_height").value / 100;

    if ( (knifeblockBladeGroup.length != 0 || knifeblockLargeBladeGroup.length != 0) &&
          insertHeight <= knifeblockBladeHeight ) {
      insertHeight = knifeblockBladeHeight + baseThickness;
      window.parent.document.getElementById("outside_height").value = (insertHeight * 100);

    }

    if ( spicerackInsertGroup.length != 0 && insertHeight <= 0.0508 ) {
      insertHeight = 0.0508;
      window.parent.document.getElementById("outside_height").value = (insertHeight * 100);

    }

   if (bottomReqSwitchOn == true) { divHeight = insertHeight - baseThickness }
      else { divHeight = insertHeight }

    redoInsert();
  }

  function drawerBoxSwitch() {
    // turn on or off translucent drawer box
    let checkBox = window.parent.document.getElementById(
      "viewDrawerBoxSwitch",
    );

    if (checkBox.checked == true) {
      dbSwitchOn = true;
    } else {
      dbSwitchOn = false;
    }

    redoInsert();
  }

  function impSwitch() {
    let checkBox = window.parent.document.getElementById(
      "flexSwitchCheckImperial",
    );

    if (checkBox.checked == true) {
      impSwitchOn = true;
    } else {
      impSwitchOn = false;
    }

    redoInsert();
  }

  function vDimensionsSwitch() {
    // turn on or off dimensions mode
    let checkBox = window.parent.document.getElementById(
      "vDimensionsSwitchCheckChecked",
    );
    //console.log("running vDimensionsSwitch...");

    if (checkBox.checked == true) {
      vDimOn = true;
    } else {
      vDimOn = false;
      hDimOn = false;
      drawer_insert.remove(vMeasurementGroup);
      drawer_insert.remove(outsideVertMeasGroup);
      drawer_insert.remove(outsideHeightMeasGroup);
      vMeasurementGroup = new THREE.Group();
      outsideVertMeasGroup = new THREE.Group();
      outsideHeightMeasGroup = new THREE.Group();

      drawer_insert.remove(hMeasurementGroup);
      drawer_insert.remove(outsideHorizMeasGroup);
      hMeasurementGroup = new THREE.Group();
      outsideHorizMeasGroup = new THREE.Group();
    }

    redoInsert();
  }

  function hDimensionsSwitch() {
    // turn on or off dimensions mode
    let checkBox = window.parent.document.getElementById(
      "hDimensionsSwitchCheckChecked",
    );

    //console.log("running hDimensionsSwitch...");

    if (checkBox.checked == true) {
      hDimOn = true;
    } else {
      hDimOn = false;
      vDimOn = false;
      drawer_insert.remove(hMeasurementGroup);
      drawer_insert.remove(outsideHorizMeasGroup);
      hMeasurementGroup = new THREE.Group();
      outsideHorizMeasGroup = new THREE.Group();

      drawer_insert.remove(vMeasurementGroup);
      drawer_insert.remove(outsideVertMeasGroup);
      drawer_insert.remove(outsideHeightMeasGroup);
      vMeasurementGroup = new THREE.Group();
      outsideVertMeasGroup = new THREE.Group();
      outsideHeightMeasGroup = new THREE.Group();
    }

    redoInsert();
  }

  function addHeightOutsideMeasurementLine() {
    // then add a measurement line for height on the front corner
    drawer_insert.remove(outsideHeightMeasGroup);
    outsideHeightMeasGroup = new THREE.Group();

    var lineY;

    if (bottomReqSwitchOn == true) { lineY = insertHeight - baseThickness / 2 }
      else { lineY = insertHeight + baseThickness / 2 }

    // add a dimension line beside this divider and add it as a child if the divider meshes
    let outsideHeightBoardMeasLine = createHeightMeasurementLine(
      drawer_insert.children[2].position.x,
      lineY,
      drawer_insert.children[3].position.z,
      insertHeight,
    );
    outsideHeightMeasGroup.add(outsideHeightBoardMeasLine);

    let outsideHeightBoardMeasLineBackEnd = createHeightMeasFlatLineTopEnd(
      drawer_insert.children[2].position.x,
      lineY,
      drawer_insert.children[3].position.z,
      insertHeight,
    );
    outsideHeightMeasGroup.add(outsideHeightBoardMeasLineBackEnd);

    let outsideHeightBoardMeasLineFrontEnd = createHeightMeasFlatLineBottomEnd(
      drawer_insert.children[2].position.x,
      lineY,
      drawer_insert.children[3].position.z,
      insertHeight,
    );
    outsideHeightMeasGroup.add(outsideHeightBoardMeasLineFrontEnd);

    //add a length to the measurement linewidth
    let measurementMesh = new THREE.Mesh(createText(+insertHeight.toFixed(6)));
    measurementMesh.geometry.computeBoundingBox();

    measurementMesh.position.x =
      drawer_insert.children[2].position.x + 0.015 + fontSize / 2;
    measurementMesh.position.y =
      divHeight / 2 + baseThickness / 2 - fontSize * 2;
    measurementMesh.position.z = drawer_insert.children[3].position.z + 0.015;

    measurementMesh.rotation.z = radNinety;

    if (textureInUse == textureOak) {
      measurementMesh.material.color.set(0x4c4c4e);
    }

    outsideHeightMeasGroup.add(measurementMesh);
    outsideHeightMeasGroup.name = "outsideHeightMeasGroup";
    drawer_insert.add(outsideHeightMeasGroup);
  }

  function addVertOutsideMeasurementLine() {
    // then add a measurement line along the right side of the outside right vertical side
    drawer_insert.remove(outsideVertMeasGroup);
    outsideVertMeasGroup = new THREE.Group();

    var lineY;

    if (bottomReqSwitchOn == true) { lineY = insertHeight - baseThickness / 2 }
      else { lineY = insertHeight + baseThickness / 2 }

    // add a dimension line beside this divider and add it as a child if the divider meshes
    let outsideVertBoardMeasLine = createVertMeasurementLine(
      drawer_insert.children[2].position.x,
      lineY,
      0,
      insertDepth,
    );
    outsideVertMeasGroup.add(outsideVertBoardMeasLine);

    let outsideVertBoardMeasLineBackEnd = createVertMeasFlatLineBackEnd(
      drawer_insert.children[2].position.x,
      lineY,
      0,
      insertDepth,
    );
    outsideVertMeasGroup.add(outsideVertBoardMeasLineBackEnd);

    let outsideVertBoardMeasLineFrontEnd = createVertMeasFlatLineFrontEnd(
      drawer_insert.children[2].position.x,
      lineY,
      0,
      insertDepth,
    );
    outsideVertMeasGroup.add(outsideVertBoardMeasLineFrontEnd);

    //add a length to the measurement linewidth
    let measurementMesh = new THREE.Mesh(createText(+insertDepth.toFixed(6)));
    measurementMesh.geometry.computeBoundingBox();
    // let textBoxLength =
    //   measurementMesh.geometry.boundingBox.max.x -
    //   measurementMesh.geometry.boundingBox.min.x;

    measurementMesh.position.x =
      drawer_insert.children[2].position.x + 0.02 + fontSize / 2;
    measurementMesh.position.y = lineY;
    measurementMesh.position.z = 0;

    measurementMesh.rotation.x = -radNinety;
    measurementMesh.rotation.z = radNinety;

    if (textureInUse == textureOak) {
      measurementMesh.material.color.set(0x4c4c4e);
    }

    outsideVertMeasGroup.add(measurementMesh);
    outsideVertMeasGroup.name = "outsideVertMeasGroup";
    drawer_insert.add(outsideVertMeasGroup);
  }

  function addHorizOutsideMeasurementLine() {
    // then add a measurement line along the right side of the outside right vertical side
    drawer_insert.remove(outsideHorizMeasGroup);
    outsideHorizMeasGroup = new THREE.Group();

    var lineY;

    if (bottomReqSwitchOn == true) { lineY = insertHeight - baseThickness / 2 }
      else { lineY = insertHeight + baseThickness / 2 }
    // add a dimension line beside this divider and add it as a child if the divider meshes
    let outsideHorizBoardMeasLine = createHorizMeasurementLine(
      0,
      lineY,
      drawer_insert.children[3].position.z,
      insertWidth,
    );
    outsideHorizMeasGroup.add(outsideHorizBoardMeasLine);

    let outsideHorizBoardMeasLineBackEnd = createHorizMeasLineFlatBackEnd(
      0,
      lineY,
      drawer_insert.children[3].position.z,
      insertWidth,
    );
    outsideHorizMeasGroup.add(outsideHorizBoardMeasLineBackEnd);

    let outsideHorizBoardMeasLineFrontEnd = createHorizMeasLineFlatFrontEnd(
      0,
      lineY,
      drawer_insert.children[3].position.z,
      insertWidth,
    );
    outsideHorizMeasGroup.add(outsideHorizBoardMeasLineFrontEnd);

    //add a length to the measurement linewidth
    let measurementMesh = new THREE.Mesh(createText(+insertWidth.toFixed(6)));
    measurementMesh.geometry.computeBoundingBox();
    // let textBoxLength =
    //   measurementMesh.geometry.boundingBox.max.x -
    //   measurementMesh.geometry.boundingBox.min.x;

    measurementMesh.position.x = 0;
    measurementMesh.position.y = lineY;
    measurementMesh.position.z =
      drawer_insert.children[3].position.z + 0.02 + fontSize / 2;

    measurementMesh.rotation.x = -radNinety;

    if (textureInUse == textureOak) {
      measurementMesh.material.color.set(0x4c4c4e);
    }

    outsideHorizMeasGroup.add(measurementMesh);
    outsideHorizMeasGroup.name = "outsideHorizMeasGroup";
    drawer_insert.add(outsideHorizMeasGroup);
  }

  function addVertMeasurementLines() {
    drawer_insert.remove(vMeasurementGroup);
    vMeasurementGroup = new THREE.Group();

    var lineY;

    if (bottomReqSwitchOn == true) { lineY = insertHeight - baseThickness / 2 }
      else { lineY = insertHeight + baseThickness / 2 }

    let vDivsToCheck = [];
    vDivsToCheck.push(drawer_insert.children[1]);
    Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);
    Array.prototype.push.apply(vDivsToCheck, spanVertDivGroup);

    vDivsToCheck.forEach((i) => {
      //console.log("  for: " + i.name);
      var thisSpanVertbBox = new THREE.Box3().setFromObject(i);
      let hDivsToCheck = [];
      let hDivZsToDo = [];
      hDivsToCheck.push(drawer_insert.children[3]);
      hDivsToCheck.push(drawer_insert.children[4]);
      Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
      Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);

      hDivsToCheck.forEach((j) => {
        var thishDivbBox = new THREE.Box3().setFromObject(j);

        let vSpanX = +i.position.x;
        let hDivMinX = +thishDivbBox.min.x;
        let hDivMaxX = +thishDivbBox.max.x;

        if (
          thisSpanVertbBox.intersectsBox(thishDivbBox) &&
          (+((vSpanX - boardThickness / 2).toFixed(6) == hDivMinX.toFixed(6)) ||
            (vSpanX > hDivMinX + boardThickness + 0.005 &&
              vSpanX < hDivMaxX - boardThickness - 0.005) ||
            j.name == "fbFrontMesh" ||
            j.name == "fbBackMesh" ||
            j.name == "fullHorizBoardMesh")
        ) {
          // then add the z value of the horizontal div to the array for sorting
          hDivZsToDo.push(+j.position.z.toFixed(6));
        }
      });

      // descending sort the hDivZsToDo array and loop through it creating measurement lines
      hDivZsToDo.sort(function (a, b) {
        return b - a;
      });

      let k = 0;
      for (k = 0; k < hDivZsToDo.length - 1; k++) {
        // then add a measurement line along the right side of this vertical divider
        let spanVertMeasGroup = new THREE.Group();
        const measLength = hDivZsToDo[k] - hDivZsToDo[k + 1] - boardThickness;

        // add a dimension line beside this divider and add to the vMeasurementGroup
        let spanVertBoardMeasLine = createVertMeasurementLine(
          i.position.x,
          lineY,
          hDivZsToDo[k] - measLength / 2 - boardThickness / 2,
          measLength,
        );
        spanVertMeasGroup.add(spanVertBoardMeasLine);

        let spanVertBoardMeasLineBackEnd = createVertMeasurementLineBackEnd(
          i.position.x,
          lineY,
          hDivZsToDo[k] - measLength / 2 - boardThickness / 2,
          measLength,
        );
        spanVertMeasGroup.add(spanVertBoardMeasLineBackEnd);

        let spanVertBoardMeasLineFrontEnd = createVertMeasurementLineFrontEnd(
          i.position.x,
          lineY,
          hDivZsToDo[k] - measLength / 2 - boardThickness / 2,
          measLength,
        );
        spanVertMeasGroup.add(spanVertBoardMeasLineFrontEnd);

        //add a length to the measurement linewidth
        let measurementMesh = new THREE.Mesh(
          createText(+measLength.toFixed(6)),
        );
        measurementMesh.geometry.computeBoundingBox();
        let textBoxLength =
          measurementMesh.geometry.boundingBox.max.x -
          measurementMesh.geometry.boundingBox.min.x;

        measurementMesh.position.x = i.position.x + 0.02 + fontSize / 2;
        measurementMesh.position.y = lineY;
        measurementMesh.position.z =
          hDivZsToDo[k] - measLength / 2 + textBoxLength / 2;

        measurementMesh.rotation.x = -radNinety;
        measurementMesh.rotation.z = radNinety;

        if (textureInUse == textureOak) {
          measurementMesh.material.color.set(0x4c4c4e);
        }

        spanVertMeasGroup.add(measurementMesh);
        vMeasurementGroup.add(spanVertMeasGroup);
        vMeasurementGroup.name = "vMeasurementGroup";
        drawer_insert.add(vMeasurementGroup);
      }
    });
  }

  function addHorizMeasurementLines() {
    drawer_insert.remove(hMeasurementGroup);
    hMeasurementGroup = new THREE.Group();

    var lineY;

    if (bottomReqSwitchOn == true) { lineY = insertHeight - baseThickness / 2 }
      else { lineY = insertHeight + baseThickness / 2 }

    let hDivsToCheck = [];
    hDivsToCheck.push(drawer_insert.children[4]);
    Array.prototype.push.apply(hDivsToCheck, fullHorizDivGroup);
    Array.prototype.push.apply(hDivsToCheck, spanHorizDivGroup);

    hDivsToCheck.forEach((i) => {
      var thisSpanHorizbBox = new THREE.Box3().setFromObject(i);
      let vDivsToCheck = [];
      let vDivXsToDo = [];
      vDivsToCheck.push(drawer_insert.children[1]);
      vDivsToCheck.push(drawer_insert.children[2]);
      Array.prototype.push.apply(vDivsToCheck, fullVertDivGroup);
      Array.prototype.push.apply(vDivsToCheck, spanVertDivGroup);

      vDivsToCheck.forEach((j) => {
        var thisvDivbBox = new THREE.Box3().setFromObject(j);

        let hSpanZ = +i.position.z;
        let vDivMinZ = +thisvDivbBox.min.z;
        let vDivMaxZ = +thisvDivbBox.max.z;

        if (
          thisSpanHorizbBox.intersectsBox(thisvDivbBox) &&
          (+((hSpanZ - boardThickness / 2).toFixed(6) == vDivMinZ.toFixed(6)) ||
            (hSpanZ > vDivMinZ + boardThickness + 0.005 &&
              hSpanZ < vDivMaxZ - boardThickness - 0.005) ||
            j.name == "leftBoardMesh" ||
            j.name == "rightBoardMesh" ||
            j.name == "fullVertBoardMesh")
        ) {
          // then add the z value of the horizontal div to the array for sorting
          vDivXsToDo.push(+j.position.x.toFixed(6));
        }
      });

      // descending sort the hDivZsToDo array and loop through it creating measurement lines
      vDivXsToDo.sort(function (a, b) {
        return b - a;
      });

      let k = 0;
      for (k = 0; k < vDivXsToDo.length - 1; k++) {
        // then add a measurement line along the right side of this vertical divider
        //console.log("adding measurement line from z = " + hDivZsToDo[k] + " to z = " + hDivZsToDo[k + 1]);
        let spanHorizMeasGroup = new THREE.Group();
        const measLength = vDivXsToDo[k] - vDivXsToDo[k + 1] - boardThickness;
        //console.log("creating horiz measurement line for: " + i.name);
        // add a dimension line beside this divider and add it as a child if the divider meshes
        let spanHorizBoardMeasLine = createHorizMeasurementLine(
          vDivXsToDo[k] - measLength / 2 - boardThickness / 2,
          lineY,
          i.position.z,
          measLength,
        );
        spanHorizMeasGroup.add(spanHorizBoardMeasLine);

        let spanHorizBoardMeasLineBackEnd = createHorizMeasurementLineBackEnd(
          vDivXsToDo[k] - measLength / 2 - boardThickness / 2,
          lineY,
          i.position.z,
          measLength,
        );
        spanHorizMeasGroup.add(spanHorizBoardMeasLineBackEnd);

        let spanHorizBoardMeasLineFrontEnd = createHorizMeasurementLineFrontEnd(
          vDivXsToDo[k] - measLength / 2 - boardThickness / 2,
          lineY,
          i.position.z,
          measLength,
        );
        spanHorizMeasGroup.add(spanHorizBoardMeasLineFrontEnd);

        //add a length to the measurement linewidth
        let measurementMesh = new THREE.Mesh(
          createText(+measLength.toFixed(6)),
        );
        measurementMesh.geometry.computeBoundingBox();
        let textBoxLength =
          measurementMesh.geometry.boundingBox.max.x -
          measurementMesh.geometry.boundingBox.min.x;

        measurementMesh.position.x =
          vDivXsToDo[k] - measLength / 2 - textBoxLength / 2;
        measurementMesh.position.y = lineY;
        measurementMesh.position.z = i.position.z + 0.02 + fontSize / 2;

        measurementMesh.rotation.x = -radNinety;

        if (textureInUse == textureOak) {
          measurementMesh.material.color.set(0x4c4c4e);
        }

        spanHorizMeasGroup.add(measurementMesh);
        hMeasurementGroup.add(spanHorizMeasGroup);
        hMeasurementGroup.name = "hMeasurementGroup";
        drawer_insert.add(hMeasurementGroup);
      }
    });
  }

  function createText(divLength) {
    if (impSwitchOn == true) {
      // convert from meters to inches
      // display in 1/4, 1/8, 1/16 or 1/32nds
      divLength = (divLength * 39.3701).toFixed(6);

      divLength = getFract(divLength);
    } else {
      // convert from meters to cm for display
      divLength = (divLength * 100).toFixed(1);
    }

    let measurementGeometry = new THREE.TextGeometry(divLength, {
      font: font,

      size: fontSize,
      height: fontHeight,
      curveSegments: fontCurveSegments,
    });

    measurementGeometry.computeBoundingBox();

    return measurementGeometry;
  }

  function getFract(theNum) {
    var whole = theNum.split(".")[0];
    var rem = (theNum.split(".")[1] * 0.000001).toFixed(6);

    // if ( whole == 4 ) {
    //   console.log("rem = " + rem);
    // }
    
    var numerator = Math.round(rem * 16);
    var denominator = 16;

    if (numerator == 0) {
      return whole + '"';
    }

    while ((numerator % 2) - 1) {
      //console.log("numerator = " + numerator + " -> is even, reducing to /" + ( denominator / 2));
      numerator = numerator / 2;
      denominator = denominator / 2;
    }

    if (numerator == 1 && denominator == 1) {
      whole++;
      return whole + '"';
    }

    return whole + " " + numerator + "/" + denominator + '"';
  }

  function createHeightMeasurementLine(
    locationX,
    insertLineHeight,
    locationZ,
    measLineLength,
  ) {
    const points = [];
    points.push(
      new THREE.Vector3(locationX + 0.015, insertLineHeight, locationZ + 0.015),
    );
    points.push(
      new THREE.Vector3(
        locationX + 0.015,
        insertLineHeight - insertHeight,
        locationZ + 0.015,
      ),
    );

    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);
    const dimensionLine = new THREE.Line(lineGeometry, lineMaterial);

    return dimensionLine;
  }

  function createHeightMeasFlatLineTopEnd(
    locationX,
    insertLineHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsBackEnd = [];
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.015 - 0.0066,
        insertLineHeight,
        locationZ + 0.015 - 0.0066,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.015 + 0.0066,
        insertLineHeight,
        locationZ + 0.015 + 0.0066,
      ),
    );

    const lineBackEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsBackEnd,
    );
    const dimensionLineBackEnd = new THREE.Line(
      lineBackEndGeometry,
      lineMaterial,
    );

    return dimensionLineBackEnd;
  }

  function createHeightMeasFlatLineBottomEnd(
    locationX,
    insertLineHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsFrontEnd = [];
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.015 - 0.0066,
        insertLineHeight - insertHeight,
        locationZ + 0.015 - 0.0066,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.015 + 0.0066,
        insertLineHeight - insertHeight,
        locationZ + 0.015 + 0.0066,
      ),
    );

    const lineFrontEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsFrontEnd,
    );
    const dimensionLineFrontEnd = new THREE.Line(
      lineFrontEndGeometry,
      lineMaterial,
    );

    return dimensionLineFrontEnd;
  }

  function createVertMeasurementLine(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const points = [];
    points.push(
      new THREE.Vector3(
        locationX + 0.02,
        divHeight,
        locationZ + measLineLength / 2,
      ),
    );
    points.push(
      new THREE.Vector3(
        locationX + 0.02,
        divHeight,
        locationZ - measLineLength / 2,
      ),
    );

    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);
    const dimensionLine = new THREE.Line(lineGeometry, lineMaterial);

    return dimensionLine;
  }

  function createVertMeasurementLineBackEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsBackEnd = [];
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.015,
        divHeight,
        locationZ + measLineLength / 2 - 0.005,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.02,
        divHeight,
        locationZ + measLineLength / 2,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.025,
        divHeight,
        locationZ + measLineLength / 2 - 0.005,
      ),
    );

    const lineBackEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsBackEnd,
    );
    const dimensionLineBackEnd = new THREE.Line(
      lineBackEndGeometry,
      lineMaterial,
    );

    return dimensionLineBackEnd;
  }

  function createVertMeasurementLineFrontEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsFrontEnd = [];
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.015,
        divHeight,
        locationZ - measLineLength / 2 + 0.005,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.02,
        divHeight,
        locationZ - measLineLength / 2,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.025,
        divHeight,
        locationZ - measLineLength / 2 + 0.005,
      ),
    );

    const lineFrontEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsFrontEnd,
    );
    const dimensionLineFrontEnd = new THREE.Line(
      lineFrontEndGeometry,
      lineMaterial,
    );

    return dimensionLineFrontEnd;
  }

  function createVertMeasFlatLineBackEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsBackEnd = [];
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.02 - 0.01,
        divHeight,
        locationZ + measLineLength / 2,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + 0.02 + 0.01,
        divHeight,
        locationZ + measLineLength / 2,
      ),
    );

    const lineBackEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsBackEnd,
    );
    const dimensionLineBackEnd = new THREE.Line(
      lineBackEndGeometry,
      lineMaterial,
    );

    return dimensionLineBackEnd;
  }

  function createVertMeasFlatLineFrontEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsFrontEnd = [];
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.02 - 0.01,
        divHeight,
        locationZ - measLineLength / 2,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX + 0.02 + 0.01,
        divHeight,
        locationZ - measLineLength / 2,
      ),
    );

    const lineFrontEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsFrontEnd,
    );
    const dimensionLineFrontEnd = new THREE.Line(
      lineFrontEndGeometry,
      lineMaterial,
    );

    return dimensionLineFrontEnd;
  }

  function createHorizMeasurementLine(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const points = [];
    //console.log("  locationX = " + locationX);
    //console.log("  locationZ = " + locationZ);
    //console.log("  measLineLength = " + measLineLength);
    points.push(
      new THREE.Vector3(
        locationX + measLineLength / 2,
        divHeight,
        locationZ + 0.02,
      ),
    );
    points.push(
      new THREE.Vector3(
        locationX - measLineLength / 2,
        divHeight,
        locationZ + 0.02,
      ),
    );

    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);
    const dimensionLine = new THREE.Line(lineGeometry, lineMaterial);

    return dimensionLine;
  }

  function createHorizMeasurementLineBackEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsBackEnd = [];
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + measLineLength / 2 - 0.005,
        divHeight,
        locationZ + 0.015,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + measLineLength / 2,
        divHeight,
        locationZ + 0.02,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + measLineLength / 2 - 0.005,
        divHeight,
        locationZ + 0.025,
      ),
    );

    const lineBackEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsBackEnd,
    );
    const dimensionLineBackEnd = new THREE.Line(
      lineBackEndGeometry,
      lineMaterial,
    );

    return dimensionLineBackEnd;
  }

  function createHorizMeasurementLineFrontEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsFrontEnd = [];
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX - measLineLength / 2 + 0.005,
        divHeight,
        locationZ + 0.015,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX - measLineLength / 2,
        divHeight,
        locationZ + 0.02,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX - measLineLength / 2 + 0.005,
        divHeight,
        locationZ + 0.025,
      ),
    );

    const lineFrontEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsFrontEnd,
    );
    const dimensionLineFrontEnd = new THREE.Line(
      lineFrontEndGeometry,
      lineMaterial,
    );

    return dimensionLineFrontEnd;
  }

  function createHorizMeasLineFlatBackEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsBackEnd = [];
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + measLineLength / 2,
        divHeight,
        locationZ + 0.02 - 0.01,
      ),
    );
    pointsBackEnd.push(
      new THREE.Vector3(
        locationX + measLineLength / 2,
        divHeight,
        locationZ + 0.02 + 0.01,
      ),
    );

    const lineBackEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsBackEnd,
    );
    const dimensionLineBackEnd = new THREE.Line(
      lineBackEndGeometry,
      lineMaterial,
    );

    return dimensionLineBackEnd;
  }

  function createHorizMeasLineFlatFrontEnd(
    locationX,
    divHeight,
    locationZ,
    measLineLength,
  ) {
    const pointsFrontEnd = [];
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX - measLineLength / 2,
        divHeight,
        locationZ + 0.02 - 0.01,
      ),
    );
    pointsFrontEnd.push(
      new THREE.Vector3(
        locationX - measLineLength / 2,
        divHeight,
        locationZ + 0.02 + 0.01,
      ),
    );

    const lineFrontEndGeometry = new THREE.BufferGeometry().setFromPoints(
      pointsFrontEnd,
    );
    const dimensionLineFrontEnd = new THREE.Line(
      lineFrontEndGeometry,
      lineMaterial,
    );

    return dimensionLineFrontEnd;
  }

  function assignUVs(meshToAddUVs) {
    //console.log("assigning UVs to: " + meshToAddUVs.name);
    //console.log(meshToAddUVs);
    let posAttr = meshToAddUVs.geometry.getAttribute("position");
    let normAttr = meshToAddUVs.geometry.getAttribute("normal");

    let points = [];
    //let norms = [];

    const uvs = new Float32Array(posAttr.count * 2);

    meshToAddUVs.geometry.setAttribute("uv", new THREE.BufferAttribute(uvs, 2));

    // add uv's to all the points on the 6 sides, 2 each from each 'view'

    // Set uv's for the points making up the faces at these Z values and
    // a normal of (0,0,1) or (0,0,-1)
    let zValuesToTest = [
      (boardThickness / 2).toFixed(6),
      ((boardThickness / 2) * -1).toFixed(6),
      (insertDepth / 2).toFixed(6),
      ((insertDepth / 2) * -1).toFixed(6),
    ];

    let j = 0;
    for (j = 0; j < zValuesToTest.length; j++) {
      //console.log("checking for zValuesToTest = " + zValuesToTest[j]);
      let normalZ = 1;
      if (zValuesToTest[j] < 0) {
        normalZ = -1;
      }

      // find the absolute range of the X values
      let lowestX = 0;
      let highestX = 0;
      let i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getZ(i).toFixed(6) === zValuesToTest[j] &&
          normAttr.getZ(i) == normalZ
        ) {
          if (posAttr.getX(i) < lowestX) {
            lowestX = posAttr.getX(i);
          }
          if (posAttr.getX(i) > highestX) {
            highestX = posAttr.getX(i);
          }
        }
      }
      let rangeX = (lowestX - highestX) * -1;
      let offsetX = 0 - lowestX;

      // for each X in the face add its value to the offset and divide by the range
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getZ(i).toFixed(6) === zValuesToTest[j] &&
          normAttr.getZ(i) == normalZ
        ) {
          let absPosX = posAttr.getX(i) + offsetX;
          let uCoordX = absPosX / rangeX;
          let holdvCoordX = meshToAddUVs.geometry.attributes.uv.getY(i);
          meshToAddUVs.geometry.attributes.uv.setXY(i, uCoordX, holdvCoordX);
        }
      }

      // find the absolute range of the Y values
      let lowestY = 0;
      let highestY = 0;
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getZ(i).toFixed(6) === zValuesToTest[j] &&
          normAttr.getZ(i) == normalZ
        ) {
          if (posAttr.getY(i) < lowestY) {
            lowestY = posAttr.getY(i);
          }
          if (posAttr.getY(i) > highestY) {
            highestY = posAttr.getY(i);
          }
        }
      }
      let rangeY = (lowestY - highestY) * -1;
      let offsetY = 0 - lowestY;

      // for each Y in the front face add its value to the offset and divide by the range
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getZ(i).toFixed(6) === zValuesToTest[j] &&
          normAttr.getZ(i) == normalZ
        ) {
          let absPosY = posAttr.getY(i) + offsetY;
          let vCoordY = absPosY / rangeY;
          let holduCoordY = meshToAddUVs.geometry.attributes.uv.getX(i);
          meshToAddUVs.geometry.attributes.uv.setXY(i, holduCoordY, vCoordY);
        }
      }
    }

    // Set uv's for the points making up the faces at these Y values and
    // a normal of (0,1,0) or (0,-1,0)
    let yValuesToTest = [
      (baseThickness / 2).toFixed(6),
      ((baseThickness / 2) * -1).toFixed(6),
      (divHeight / 2).toFixed(6),
      ((divHeight / 2) * -1).toFixed(6),
    ];

    j = 0;
    for (j = 0; j < yValuesToTest.length; j++) {
      //console.log("checking for yValuesToTest = " + yValuesToTest[j]);
      let normalY = 1;
      if (yValuesToTest[j] < 0) {
        normalY = -1;
      }

      // find the absolute range of the X values
      let lowestX = 0;
      let highestX = 0;
      let i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getY(i).toFixed(6) === yValuesToTest[j] &&
          normAttr.getY(i) == normalY
        ) {
          if (posAttr.getX(i) < lowestX) {
            lowestX = posAttr.getX(i);
          }
          if (posAttr.getX(i) > highestX) {
            highestX = posAttr.getX(i);
          }
        }
      }
      let rangeX = (lowestX - highestX) * -1;
      let offsetX = 0 - lowestX;

      // for each X in the face add its value to the offset and divide by the range
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getY(i).toFixed(6) === yValuesToTest[j] &&
          normAttr.getY(i) == normalY
        ) {
          let absPosX = posAttr.getX(i) + offsetX;
          let uCoordX = absPosX / rangeX;
          let holdvCoordX = meshToAddUVs.geometry.attributes.uv.getY(i);
          meshToAddUVs.geometry.attributes.uv.setXY(i, uCoordX, holdvCoordX);
        }
      }

      // find the absolute range of the Z values
      let lowestZ = 0;
      let highestZ = 0;
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getY(i).toFixed(6) === yValuesToTest[j] &&
          normAttr.getY(i) == normalY
        ) {
          if (posAttr.getZ(i) < lowestZ) {
            lowestZ = posAttr.getZ(i);
          }
          if (posAttr.getZ(i) > highestZ) {
            highestZ = posAttr.getZ(i);
          }
        }
      }
      let rangeZ = (lowestZ - highestZ) * -1;
      let offsetZ = 0 - lowestZ;

      // for each Z in the front face add its value to the offset and divide by the range
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getY(i).toFixed(6) === yValuesToTest[j] &&
          normAttr.getY(i) == normalY
        ) {
          let absPosZ = posAttr.getZ(i) + offsetZ;
          let vCoordZ = absPosZ / rangeZ;
          let holduCoordZ = meshToAddUVs.geometry.attributes.uv.getX(i);
          meshToAddUVs.geometry.attributes.uv.setXY(i, holduCoordZ, vCoordZ);
        }
      }
    }

    // Set uv's for the points making up the faces at these X values and
    // a normal of (1,0,0) or (-1,0,0)
    // also check the faces on the ends of spanning dividers using their
    // boundingbox
    meshToAddUVs.geometry.computeBoundingBox();
    let xValuesToTest = [
      (insertWidth / 2).toFixed(6),
      ((insertWidth / 2) * -1).toFixed(6),
      (insertDepth / 2).toFixed(6),
      ((insertDepth / 2) * -1).toFixed(6),
      meshToAddUVs.geometry.boundingBox.max.x.toFixed(6),
      meshToAddUVs.geometry.boundingBox.min.x.toFixed(6),
    ];

    j = 0;
    for (j = 0; j < xValuesToTest.length; j++) {
      //console.log("checking for xValuesToTest = " + xValuesToTest[j]);
      let normalX = 1;
      if (xValuesToTest[j] < 0) {
        normalX = -1;
      }

      // find the absolute range of the Y values
      let lowestY = 0;
      let highestY = 0;
      let i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getX(i).toFixed(6) === xValuesToTest[j] &&
          normAttr.getX(i) == normalX
        ) {
          if (posAttr.getY(i) < lowestY) {
            lowestY = posAttr.getY(i);
          }
          if (posAttr.getY(i) > highestY) {
            highestY = posAttr.getY(i);
          }
        }
      }
      let rangeY = (lowestY - highestY) * -1;
      let offsetY = 0 - lowestY;

      // for each Y in the face add its value to the offset and divide by the range
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getX(i).toFixed(6) === xValuesToTest[j] &&
          normAttr.getX(i) == normalX
        ) {
          let absPosY = posAttr.getY(i) + offsetY;
          let uCoordY = absPosY / rangeY;
          let holdvCoordY = meshToAddUVs.geometry.attributes.uv.getY(i);
          meshToAddUVs.geometry.attributes.uv.setXY(i, uCoordY, holdvCoordY);
        }
      }

      // find the absolute range of the Z values
      let lowestZ = 0;
      let highestZ = 0;
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getX(i).toFixed(6) === xValuesToTest[j] &&
          normAttr.getX(i) == normalX
        ) {
          if (posAttr.getZ(i) < lowestZ) {
            lowestZ = posAttr.getZ(i);
          }
          if (posAttr.getZ(i) > highestZ) {
            highestZ = posAttr.getZ(i);
          }
        }
      }
      let rangeZ = (lowestZ - highestZ) * -1;
      let offsetZ = 0 - lowestZ;

      // for each Z in the front face add its value to the offset and divide by the range
      i = 0;
      for (i = 0; i < posAttr.count; i++) {
        if (
          posAttr.getX(i).toFixed(6) === xValuesToTest[j] &&
          normAttr.getX(i) == normalX
        ) {
          let absPosZ = posAttr.getZ(i) + offsetZ;
          let vCoordZ = absPosZ / rangeZ;
          let holduCoordZ = meshToAddUVs.geometry.attributes.uv.getX(i);
          meshToAddUVs.geometry.attributes.uv.setXY(i, holduCoordZ, vCoordZ);
        }
      }
    }

    // add uv's to the y face if there is a cutaway
    //console.log("checking if meshToAddUVs has cutaway: " + meshToAddUVs.userData.hasCutaway);

    // if ( meshToAddUVs.userData.hasCutaway === true ) {
    //
    //   //console.log("adding UV data to cutaway...");
    //
    //   // find the absolute range of the X values
    //   //let lowestX = 0;
    //   //let highestX = 0;
    //
    //   let cutAwayXStart = (meshToAddUVs.geometry.boundingBox.max.x -
    //     (meshToAddUVs.geometry.boundingBox.max.x -
    //       meshToAddUVs.geometry.boundingBox.min.x) / 3);
    //   cutAwayXStart = Math.round( cutAwayXStart * 1000000 + Number.EPSILON ) / 1000000;
    //
    //   let highestX = cutAwayXStart;
    //   let lowestX = cutAwayXStart * -1;
    //
    //   let rangeX = (lowestX - highestX ) * -1;
    //   let offsetX = 0 - lowestX;
    //
    //   let normalY = 1;
    //
    //   // for each X in the face add its value to the offset and divide by the range
    //   let i = 0;
    //   for (i = 0; i < posAttr.count; i++) {
    //     if ( (posAttr.getY(i) <= insertHeight / 2) ||
    //      (posAttr.getY(i) >= (insertHeight / 2) - (insertHeight / 3)) &&
    //      normAttr.getY(i) == normalY ) {
    //       let absPosX = posAttr.getX(i) + offsetX;
    //       let uCoordX = absPosX / rangeX;
    //       let holdvCoordY = meshToAddUVs.geometry.attributes.uv.getY(i);
    //       console.log("uv X from: u = " + meshToAddUVs.geometry.attributes.uv.getX(i) + " v = " + meshToAddUVs.geometry.attributes.uv.getY(i));
    //       if ( meshToAddUVs.geometry.attributes.uv.getX(i) == 0 ) {
    //         meshToAddUVs.geometry.attributes.uv.setXY(i, uCoordX, holdvCoordY);
    //         console.log("uv X to  : u = " + meshToAddUVs.geometry.attributes.uv.getX(i) + " v = " + meshToAddUVs.geometry.attributes.uv.getY(i));
    //       }
    //     }
    //   }
    //
    //   //find the absolute range of the Z values
    //   let lowestZ = 0;
    //   let highestZ = 0;
    //   i = 0;
    //   for (i = 0; i < posAttr.count; i++) {
    //     if ( (posAttr.getY(i) <= insertHeight / 2) ||
    //      (posAttr.getY(i) >= (insertHeight / 2) - (insertHeight / 3)) &&
    //      normAttr.getY(i) == normalY ) {
    //       if ( posAttr.getZ(i) < lowestZ ) { lowestZ = posAttr.getZ(i) }
    //       if ( posAttr.getZ(i) > highestZ ) { highestZ = posAttr.getZ(i) }
    //     }
    //   }
    //   let rangeZ = (lowestZ - highestZ ) * -1;
    //   let offsetZ = 0 - lowestZ;
    //
    //   //for each Z in the front face add its value to the offset and divide by the range
    //   i = 0;
    //   for (i = 0; i < posAttr.count; i++) {
    //     if ( (posAttr.getY(i) <= insertHeight / 2) ||
    //      (posAttr.getY(i) >= (insertHeight / 2) - (insertHeight / 3)) &&
    //      normAttr.getY(i) == normalY ) {
    //       let absPosZ = posAttr.getZ(i) + offsetZ;
    //       let vCoordZ = absPosZ / rangeZ;
    //       let holduCoordZ = meshToAddUVs.geometry.attributes.uv.getX(i);
    //       console.log("uv Z from: u = " + meshToAddUVs.geometry.attributes.uv.getX(i) + " v = " + meshToAddUVs.geometry.attributes.uv.getY(i));
    //       if ( meshToAddUVs.geometry.attributes.uv.getY(i) == 0 ) {
    //         meshToAddUVs.geometry.attributes.uv.setXY(i, holduCoordZ, vCoordZ);
    //         console.log("uv Z from: u = " + meshToAddUVs.geometry.attributes.uv.getX(i) + " v = " + meshToAddUVs.geometry.attributes.uv.getY(i));
    //       }
    //     }
    //   }
    //
    //
    // }

    meshToAddUVs.geometry.attributes.uv.needsUpdate = true;
  }

  function calcAreas() {
    baseArea = (insertWidth * insertDepth).toFixed(2);
    // calculate area of the two sides plus the front and back.
    sideArea = insertWidth * divHeight * 2 + insertDepth * divHeight * 2;

    // add the areas of the dividers
    fullVertDivGroup.forEach((i) => {
      sideArea = sideArea + insertDepth * divHeight;
    });

    fullHorizDivGroup.forEach((i) => {
      sideArea = sideArea + insertWidth * divHeight;
    });

    spanVertDivGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * divHeight;
    });

    spanHorizDivGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * divHeight;
    });

    knifeblockBladeGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * knifeblockBladeHeight;
    });

    knifeblockHandleGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * knifeblockHandleHeight;
    });

    knifeblockLargeBladeGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * knifeblockBladeHeight;
    });

    knifeblockLargeHandleGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * knifeblockLargeHandleHeight;
    });

    knifeblockLargeHandle2Group.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * knifeblockHandleHeight;
    });

    spicerackInsertGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      sideArea = sideArea + divLength * spicerackInsertDepth;
    });

    sideArea = sideArea.toFixed(2);

    var displayUnit = " m2";

    // if (impSwitchOn == true) {
    //   displayUnit = " inches2";
    //
    //   //convert square meters to square inches with decimals
    //   sideArea = (sideArea * 1550).toFixed(2);
    //   baseArea = (baseArea * 1550).toFixed(2);
    //
    //   // convert to a fraction, not needed? as it the fractions don't matter
    //   // when square inches are the unit.
    //   baseArea = getFract(baseArea);
    //   sideArea = getFract(sideArea);
    // }

    var hasLargeKnifeBlock = knifeblockLargeBladeGroup.length;
    var hasSmallKnifeBlock = knifeblockBladeGroup.length;
    var hasSpiceRack = spicerackInsertGroup.length;

    return { baseArea, sideArea, displayUnit, hasLargeKnifeBlock, hasSmallKnifeBlock, hasSpiceRack };
  }

  function calcSpicejars() {

    var numJars = 0;

    spicerackInsertGroup.forEach((i) => {
      i.geometry.computeBoundingBox();
      let divLength =
        i.geometry.boundingBox.max.x - i.geometry.boundingBox.min.x;
      numJars = numJars + Math.trunc(divLength / spiceJarWidth);
    });


    return { numJars };
  }
} // end of main didScript() function
